(function() {
  angular.module('ideal', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ui.select', 'miniGrid', 'ngMessages', 'ngAria', 'pascalprecht.translate', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'ng-token-auth', 'angularFileUpload', 'xeditable', 'ui.sortable', 'angular.filter', 'ui.utils.masks', 'chart.js', 'angularTrix', 'ngLocale', 'ngTagsInput', 'ui.mask']).run(function(toastr, $rootScope, $auth, $state, $window) {
    $rootScope.showError = function(error) {
      var key;
      if (error.status === 500) {
        toastr.error(error.data.error);
      } else {
        for (key in error.data) {
          toastr.error(error.data[key][0]);
        }
      }
    };
    $rootScope.hasRole = function(role_name) {
      if (angular.isDefined($rootScope.user.roles)) {
        if ($rootScope.user.roles.indexOf(role_name) > -1) {
          return true;
        } else {
          return false;
        }
      }
    };
    $rootScope.hasPermission = function(roles) {
      if (angular.isDefined(roles)) {
        if (roles.indexOf("can_extract_clients") > -1 || roles.indexOf("can_export_cards") > -1 || roles.indexOf("can_extract_affiliates") > -1 || roles.indexOf("can_extract_contracts_block") > -1 || roles.indexOf("can_extract_calls") > -1 || roles.indexOf("can_extract_contracts") > -1 || roles.indexOf("can_extract_users") > -1 || roles.indexOf('can_extract_archive') > -1) {
          return true;
        } else {
          return false;
        }
      }
    };
    $rootScope.LogOut = function() {
      return $auth.signOut().then(function(resp) {
        $state.go("login");
      })["catch"](function(resp) {
        console.log(resp);
      });
    };
    $rootScope.openNewTab = function(url) {
      $window.open("#" + url, '_blank');
    };
    return (function(factory) {
      if (typeof define === 'function' && define.amd) {
        define(['moment'], factory);
      } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment'));
      } else {
        factory(window.moment);
      }
    })(function(moment) {
      return moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
        longDateFormat: {
          LT: 'HH:mm',
          L: 'DD/MM/YYYY',
          LL: 'D [de] MMMM [de] YYYY',
          LLL: 'D [de] MMMM [de] YYYY [às] LT',
          LLLL: 'dddd, D [de] MMMM [de] YYYY [às] LT'
        },
        calendar: {
          sameDay: '[Hoje às] LT',
          nextDay: '[Amanhã às] LT',
          nextWeek: 'dddd [às] LT',
          lastDay: '[Ontem às] LT',
          lastWeek: function() {
            if (this.day() === 0 || this.day() === 6) {
              return '[Último] dddd [às] LT';
            } else {
              return '[Última] dddd [às] LT';
            }
          },
          sameElse: 'L'
        },
        relativeTime: {
          future: 'em %s',
          past: '%s atrás',
          s: 'segundos',
          m: 'um minuto',
          mm: '%d minutos',
          h: 'uma hora',
          hh: '%d horas',
          d: 'um dia',
          dd: '%d dias',
          M: 'um mês',
          MM: '%d meses',
          y: 'um ano',
          yy: '%d anos'
        },
        ordinal: '%dº'
      });
    });
  }).directive('ngEnter', function() {
    return function(scope, element, attrs) {
      element.bind('keydown keypress', function(event) {
        if (event.which === 13) {
          scope.$apply(function() {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  }).directive("ngReallyClick", [
    "$uibModal", function($uibModal) {
      var ModalInstanceCtrl;
      ModalInstanceCtrl = function($scope, $uibModalInstance) {
        $scope.ok = function() {
          $uibModalInstance.close();
        };
        $scope.cancel = function() {
          $uibModalInstance.dismiss("cancel");
        };
      };
      return {
        restrict: "A",
        scope: {
          ngReallyClick: "&",
          item: "="
        },
        link: function(scope, element, attrs) {
          element.bind("click", function() {
            var btn, btn_right_class, description, modalHtml, modalInstance, subtitle, title;
            title = attrs.ngReallyTitle || "Você tem certeza?";
            subtitle = attrs.ngReallySubTitle || "";
            description = attrs.ngReallyDescription || "";
            btn = attrs.ngReallyBtn || "Remover";
            btn_right_class = attrs.ngReallyBtnRightClass || "btn-danger";
            modalHtml = "<div class=\"modal-header\"><h4>" + title + " </h4> </div>";
            modalHtml += "<div class=\"modal-body text-center\"><h5 class=\"text-primary ng-sub-title\">" + subtitle + "</h5>  <h6 class=\"text-primary  white-space-preline\">" + description + "</h6> </div>";
            modalHtml += "<div class=\"modal-footer text-center\"><button class=\"btn btn-sm btn-default  pull-left\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> Cancelar </button><button class=\"btn " + btn_right_class + " pull-right btn-sm \" ng-click=\"ok()\"><i class=\"fa fa-check\"></i> " + btn + "</button></div>";
            modalInstance = $uibModal.open({
              template: modalHtml,
              animation: false,
              controller: ModalInstanceCtrl
            });
            scope.$apply();
            modalInstance.result.then((function() {
              scope.ngReallyClick({
                item: scope.item
              });
            }), function() {});
          });
        }
      };
    }
  ]).directive('phoneInput', [
    '$filter', '$browser', function($filter, $browser) {
      return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModelCtrl) {
          var listener;
          listener = function() {
            var value;
            value = $element.val().replace(/[^0-9]/g, '');
            $element.val($filter('tel')(value, false));
          };
          ngModelCtrl.$parsers.push(function(viewValue) {
            return viewValue.replace(/[^0-9]/g, '').slice(0, 12);
          });
          ngModelCtrl.$render = function() {
            $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
          };
          $element.bind('change', listener);
          $element.bind('keydown', function(event) {
            var key;
            key = event.keyCode;
            if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
              return;
            }
            $browser.defer(listener);
          });
          $element.bind('paste cut', function() {
            $browser.defer(listener);
          });
        }
      };
    }
  ]).filter('ageFilter', function() {
    return function(birthday) {
      var age, today;
      birthday = new Date(birthday);
      today = new Date;
      age = (today - birthday) / 31557600000;
      age = Math.floor(age);
      return age;
    };
  }).filter('cep', function() {
    return function(cep) {
      if (cep) {
        return cep.substr(0, 5) + "-" + cep.substr(5, 3);
      }
    };
  }).filter('document', function() {
    return function(document) {
      if (document) {
        if (document.length > 11) {
          return document.substr(0, 2) + "." + document.substr(2, 3) + "." + document.substr(5, 3) + "/" + document.substr(8, 4) + "-" + document.substr(12, 2);
        } else {
          return document.substr(0, 3) + "." + document.substr(3, 3) + "." + document.substr(6, 3) + "-" + document.substr(9, 2);
        }
      }
    };
  }).filter('tel', function() {
    return function(tel) {
      var city, country, number, value;
      if (!tel) {
        return '';
      }
      value = tel.toString().trim().replace(/^\+\-/, '');
      if (value.match(/[^0-9]/)) {
        return tel;
      }
      country = void 0;
      city = void 0;
      number = void 0;
      switch (value.length) {
        case 1:
        case 2:
          city = value;
          break;
        default:
          if (value.length > 9) {
            city = value.slice(0, 2);
            number = value.slice(2);
          } else {
            number = value;
          }
      }
      if (number) {
        if (number.length > 4) {
          if (number.length > 8) {
            number = number.slice(0, 5) + '-' + number.slice(5, 9);
          } else {
            number = number.slice(0, 4) + '-' + number.slice(4, 9);
          }
        } else {
          number = number;
        }
        if (city) {
          return ('(' + city + ') ' + number).trim();
        } else {
          return number;
        }
      } else {
        return '(' + city;
      }
    };
  }).filter('diagnosis', function() {
    return function(code) {
      var value;
      if (!code) {
        return '';
      }
      value = code.toString().trim().replace(/^\+\-/, '');
      if (value.match(/[^0-9]/)) {
        return code;
      }
      switch (value.length) {
        case 1:
        case 2:
          value;
          break;
        default:
          value = value.slice(0, 2) + "-" + value.slice(2, 4);
      }
      return value;
    };
  }).directive('codeInput', [
    '$filter', '$browser', function($filter, $browser) {
      return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModelCtrl) {
          var listener;
          listener = function() {
            var value;
            value = $element.val().replace(/[^0-9]/g, '');
            $element.val($filter('diagnosis')(value, false));
          };
          ngModelCtrl.$parsers.push(function(viewValue) {
            return viewValue.replace(/[^0-9]/g, '').slice(0, 12);
          });
          ngModelCtrl.$render = function() {
            $element.val($filter('diagnosis')(ngModelCtrl.$viewValue, false));
          };
          $element.bind('change', listener);
          $element.bind('keydown', function(event) {
            var key;
            key = event.keyCode;
            if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
              return;
            }
            $browser.defer(listener);
          });
          $element.bind('paste cut', function() {
            $browser.defer(listener);
          });
        }
      };
    }
  ]).filter('timeFilter', function() {
    return function(code) {
      var value;
      if (!code) {
        return '';
      }
      value = code.toString().trim().replace(/^\+\:/, '');
      if (value.match(/[^0-9]/)) {
        return code;
      }
      switch (value.length) {
        case 1:
        case 2:
          value;
          break;
        default:
          value = value.slice(0, 2) + ":" + value.slice(2, 4);
      }
      return value;
    };
  }).directive('timeInput', [
    '$filter', '$browser', function($filter, $browser) {
      return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModelCtrl) {
          var listener;
          listener = function() {
            var value;
            value = $element.val().replace(/[^0-9]/g, '');
            $element.val($filter('timeFilter')(value, false));
          };
          ngModelCtrl.$parsers.push(function(viewValue) {
            return viewValue.replace(/[^0-9]/g, '').slice(0, 12);
          });
          ngModelCtrl.$render = function() {
            $element.val($filter('timeFilter')(ngModelCtrl.$viewValue, false));
          };
          $element.bind('change', listener);
          $element.bind('keydown', function(event) {
            var key;
            key = event.keyCode;
            if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
              return;
            }
            $browser.defer(listener);
          });
          $element.bind('paste cut', function() {
            $browser.defer(listener);
          });
        }
      };
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').service('webDevTec', function() {
    'ngInject';
    var data, getTec;
    data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      }, {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      }, {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      }, {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      }, {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      }, {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      }, {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      }, {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }, {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }, {
        'title': 'CoffeeScript',
        'url': 'http://coffeescript.org/',
        'description': 'CoffeeScript, \'a little language that compiles into JavaScript\'.',
        'logo': 'coffeescript.png'
      }, {
        'key': 'jade',
        'title': 'Jade',
        'url': 'http://jade-lang.com/',
        'description': 'Jade is a high performance template engine heavily influenced by Haml and implemented with JavaScript for node.',
        'logo': 'jade.png'
      }
    ];
    getTec = function() {
      return data;
    };
    this.getTec = getTec;
  });

}).call(this);



(function() {
  angular.module('ideal').directive('acmeNavbar', function() {
    var NavbarController, directive;
    NavbarController = function(moment) {
      'ngInject';
      var vm;
      vm = this;
      vm.relativeDate = moment(vm.creationDate).fromNow();
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };
  });

}).call(this);



(function() {
  angular.module('ideal').directive('acmeMalarkey', function() {
    var MalarkeyController, directive, linkFunc;
    MalarkeyController = function($log, githubContributor) {
      'ngInject';
      var activate, getContributors, vm;
      vm = this;
      activate = function() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      };
      getContributors = function() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;
          return vm.contributors;
        });
      };
      vm.contributors = [];
      activate();
    };
    linkFunc = function(scope, el, attr, vm) {
      var typist, watcher;
      watcher = void 0;
      typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });
      el.addClass('acme-malarkey');
      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause()["delete"]();
      });
      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause()["delete"]();
        });
      });
      scope.$on('$destroy', function() {
        watcher();
      });
    };
    return directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('githubContributor', function($log, $http) {
    'ngInject';
    var apiHost, getContributors, service;
    apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';
    getContributors = function(limit) {
      var getContributorsComplete, getContributorsFailed;
      if (limit == null) {
        limit = 30;
      }
      getContributorsComplete = function(response) {
        return response.data;
      };
      getContributorsFailed = function(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      };
      return $http.get(apiHost + '/contributors?per_page=' + limit).then(getContributorsComplete)["catch"](getContributorsFailed);
    };
    return service = {
      apiHost: apiHost,
      getContributors: getContributors
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('VehiclesController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Vehicle) {
    var ModalInstanceCtrl;
    $scope.vehicle = {};
    $scope.vehicles = [];
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    $scope.searchVehicle = function() {
      return Vehicle.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.vehicles = data.vehicles;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Vehicle.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.vehicles = data.vehicles;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.getVehicles = function() {
      return Vehicle.get({}, (function(data) {
        $scope.vehicles = data.vehicles;
        $scope.pagination = data.pagination;
        $scope.totalItems = data.pagination.total_items;
        return $scope.load_data = false;
      }), function(error) {
        $scope.showError(error);
        return $scope.load_data = false;
      });
    };
    $scope.getVehicles();
    $scope.newVehicle = function() {
      $scope.vehicle = {};
      return $scope.vehicleModal();
    };
    $scope.editVehicle = function(vehicle) {
      $scope.vehicle = angular.copy(vehicle);
      $scope.vehicle.ipva_due_date = new Date($scope.vehicle.format_ipva_due_date);
      $scope.vehicle.insurance_due_date = new Date($scope.vehicle.format_insurance_due_date);
      return $scope.vehicleModal();
    };
    $scope.vehicleModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/vehicles/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    $scope.removeVehicle = function(vehicle_id, index) {
      return Vehicle["delete"]({
        id: vehicle_id
      }, (function(data) {
        $scope.vehicles.splice(index, 1);
        return toastr.error("Veículo removido");
      }), function(error) {
        $scope.showError(error);
      });
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      var disabled;
      $scope.dateFormat = "dd/MM/yyyy";
      $scope.dateOptions = {
        formatYear: "yy",
        startingDay: 0,
        dateFormat: $scope.dateFormat
      };
      $scope.clear = function() {
        $scope.vehicle.ipva_due_date = null;
      };
      $scope.inlineOptions = {
        minDate: new Date,
        showWeeks: true
      };
      $scope.toggleMin = function() {
        $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
        $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
      };
      $scope.toggleMin();
      $scope.open1 = function() {
        $scope.popup1.opened = true;
      };
      $scope.open2 = function() {
        $scope.popup2.opened = true;
      };
      $scope.setDate = function(year, month, day) {
        $scope.vehicle.ipva_due_date = new Date(year, month, day);
      };
      $scope.altInputFormats = ['M!/d!/yyyy'];
      $scope.popup1 = {
        opened: false
      };
      $scope.popup2 = {
        opened: false
      };
      disabled = function(data) {
        var date, mode;
        date = data.date;
        mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
      };
      $scope.today = function() {
        $scope.vehicle.ipva_due_date = new Date('');
      };
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      return $scope.saveVehicle = function() {
        if (!$scope.vehicle.id) {
          return Vehicle.save({
            vehicle: $scope.vehicle
          }, (function(data) {
            toastr.info('Veículo cadastrado');
            $scope.vehicle = {};
            $scope.getVehicles();
            return $scope.ok();
          }), function(error) {
            $scope.showError(error);
          });
        } else {
          return Vehicle.update({
            id: $scope.vehicle.id,
            vehicle: $scope.vehicle
          }, (function(data) {
            $scope.getVehicles();
            $scope.ok();
            return $scope.vehicle = {};
          }), function(error) {
            $scope.showError(error);
          });
        }
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Vehicle', [
    '$resource', function($resource) {
      return $resource('/api/vehicles/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/vehicles/:id',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('UsersController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state) {
    $scope.users = [];
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_users = true;
    $scope.search = null;
    User.get({}, (function(data) {
      $scope.users = data.users;
      $scope.pagination = data.pagination;
      $scope.totalItems = data.pagination.total_items;
      return $scope.load_users = false;
    }), function(error) {
      $scope.showError(error);
      return $scope.load_users = false;
    });
    $scope.searchUser = function() {
      $scope.users = [];
      return User.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.users = data.users;
        $scope.load_users = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return User.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.users = data.users;
        $scope.load_users = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.toggleIsActive = function(user_id) {
      return User.toggle_active({
        id: user_id
      });
    };
    return $scope.toggleSystemAcess = function(user_id) {
      return User.toggle_system_access({
        id: user_id
      });
    };
  }).controller('UsersNewController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, $window) {
    var closeSearchWhenClickingElsewhere, disabled;
    $scope.newUser = {
      system_access: true,
      positions: {
        nurse: false,
        driver: false,
        doctor: false,
        operator: false,
        supervisor: false,
        seller: false,
        administrative: false
      }
    };
    $scope.phones = [];
    $scope.positions = [
      {
        name: 'Enfermagem',
        id: 'nurse'
      }, {
        name: 'Motorista',
        id: 'driver'
      }, {
        name: 'Médico',
        id: 'doctor'
      }, {
        name: 'Operador',
        id: 'operator'
      }, {
        name: 'Supervisor',
        id: 'supervisor'
      }, {
        name: 'Vendedor',
        id: 'seller'
      }, {
        name: 'Administrativo',
        id: 'administrative'
      }
    ];
    $scope.addFone = function(phone) {
      if (angular.isDefined($scope.newUser.phone) || $scope.newUser.phone === 'defined') {
        if ($scope.newUser.phone.length >= 8) {
          $scope.phones.push(phone);
          phone = null;
        } else {
          $scope.form.$invalid;
        }
      } else {
        $scope.form.$invalid;
      }
    };
    $scope.check_selected = false;
    $scope.$window = $window;
    $scope.toggleSearch = function() {
      $scope.check_selected = !$scope.check_selected;
      if ($scope.check_selected) {
        $scope.$window.onclick = function(event) {
          closeSearchWhenClickingElsewhere(event, $scope.toggleSearch);
        };
      } else {
        $scope.check_selected = false;
        $scope.$window.onclick = null;
        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
          $scope.$apply();
        }
      }
    };
    closeSearchWhenClickingElsewhere = function(event, callbackOnClose) {
      var clickedElement, clickedOnSearchDrawer, elementClasses;
      clickedElement = event.target;
      if (!clickedElement) {
        return;
      }
      elementClasses = clickedElement.classList;
      clickedOnSearchDrawer = elementClasses.contains('handle-right') || elementClasses.contains('drawer-right') || clickedElement.parentElement !== null && clickedElement.parentElement.classList.contains('drawer-right');
      if (!clickedOnSearchDrawer) {
        if (event.target.nodeName !== 'SPAN' && event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'LI') {
          console.log(event.target.nodeName);
          callbackOnClose();
        }
        return;
      }
    };
    $scope.removePhone = function($index) {
      $scope.phones.splice($index, 1);
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      startingDay: 0,
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.affiliate.birth_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.newUser.birth_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.check_selected2 = false;
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.newUser.birth_date = new Date('');
    };
    return $scope.createUser = function() {
      $scope.newUser.phone = $scope.phones.join(", ");
      console.log($scope.newUser);
      User.save({
        user: $scope.newUser
      }, (function(data) {
        return $state.go("users");
      }), function(error) {
        $scope.showError(error);
      });
    };
  }).controller('ProfileController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, FileUploader) {
    $scope.edit_user = angular.copy($scope.user);
    User.user_avatar({
      id: $scope.user.id
    }, function(data) {
      return $scope.user_avatar = data.avatar;
    });
    $scope.uploader = new FileUploader({
      url: "./api/users/" + $scope.user.id + "/update_avatar.json?",
      method: 'put',
      alias: 'user[avatar]',
      autoUpload: true,
      headers: $auth.retrieveData('auth_headers'),
      withCredentials: true
    });
    $scope.uploader.onSuccessItem = function(fileItem, response, status, headers) {
      return $scope.user_avatar = response.avatar;
    };
    return $scope.updateUser = function() {
      angular.copy($scope.edit_user, $scope.user);
      $auth.updateAccount($scope.user);
    };
  }).controller('UsersEditController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, $stateParams, $window) {
    var closeSearchWhenClickingElsewhere, disabled;
    $scope.phones = [];
    User.get({
      id: $stateParams.id
    }, function(data) {
      $scope.newUser = data;
      $scope.newUser.phones = [];
      if ($scope.newUser.phone) {
        $scope.phones = $scope.newUser.phone.split(", ");
      }
      $scope.newUser.phone = "";
      if ($scope.newUser.format_birth_date) {
        $scope.newUser.birth_date = new Date($scope.newUser.format_birth_date);
      }
      if ($scope.newUser.format_admission_date) {
        $scope.newUser.admission_date = new Date($scope.newUser.format_admission_date);
      }
      if ($scope.newUser.format_aso_date) {
        $scope.newUser.aso_date = new Date($scope.newUser.format_aso_date);
      }
      if ($scope.newUser.format_integration_date) {
        return $scope.newUser.integration_date = new Date($scope.newUser.format_integration_date);
      }
    });
    $scope.positions = [
      {
        name: 'Enfermagem',
        id: 'nurse'
      }, {
        name: 'Motorista',
        id: 'driver'
      }, {
        name: 'Médico',
        id: 'doctor'
      }, {
        name: 'Operador',
        id: 'operator'
      }, {
        name: 'Supervisor',
        id: 'supervisor'
      }, {
        name: 'Vendedor',
        id: 'seller'
      }, {
        name: 'Administrativo',
        id: 'administrative'
      }
    ];
    $scope.check_selected = false;
    $scope.$window = $window;
    $scope.toggleSearch = function() {
      $scope.check_selected = !$scope.check_selected;
      if ($scope.check_selected) {
        $scope.$window.onclick = function(event) {
          closeSearchWhenClickingElsewhere(event, $scope.toggleSearch);
        };
      } else {
        $scope.check_selected = false;
        $scope.$window.onclick = null;
        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
          $scope.$apply();
        }
      }
    };
    closeSearchWhenClickingElsewhere = function(event, callbackOnClose) {
      var clickedElement, clickedOnSearchDrawer, elementClasses;
      clickedElement = event.target;
      if (!clickedElement) {
        return;
      }
      elementClasses = clickedElement.classList;
      clickedOnSearchDrawer = elementClasses.contains('handle-right') || elementClasses.contains('drawer-right') || clickedElement.parentElement !== null && clickedElement.parentElement.classList.contains('drawer-right');
      if (!clickedOnSearchDrawer) {
        if (event.target.nodeName !== 'SPAN' && event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'LI') {
          console.log(event.target.nodeName);
          callbackOnClose();
        }
        return;
      }
    };
    $scope.addFone = function(phone) {
      if (angular.isDefined($scope.newUser.phone) || $scope.newUser.phone === 'defined') {
        if ($scope.newUser.phone.length >= 8) {
          $scope.phones.push(phone);
          phone = null;
        } else {
          $scope.form.$invalid;
        }
      } else {
        $scope.form.$invalid;
      }
    };
    $scope.removePhone = function($index) {
      $scope.phones.splice($index, 1);
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      startingDay: 0,
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.affiliate.birth_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.check_selected1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.newUser.birth_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.check_selected2 = false;
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.newUser.birth_date = new Date('');
    };
    return $scope.createUser = function() {
      $scope.newUser.phone = $scope.phones.join(", ");
      User.update({
        id: $scope.newUser.id,
        user: $scope.newUser
      }, (function(data) {
        return $state.go("users");
      }), function(error) {
        $scope.showError(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('User', [
    '$resource', function($resource) {
      return $resource('/api/users/:id', {
        id: '@id'
      }, {
        toggle_active: {
          url: '/api/users/:id/toggle_active',
          method: 'PUT'
        },
        toggle_system_access: {
          url: '/api/users/:id/toggle_system_access',
          method: 'PUT'
        },
        user_avatar: {
          url: '/api/users/:id/user_avatar',
          method: 'GET'
        },
        update: {
          url: '/api/users/:id',
          method: 'PUT'
        },
        update_preferences: {
          url: '/api/users/update_preferences',
          method: 'PUT'
        },
        users_by_position: {
          url: '/api/users/users_by_position'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('TeamsController', function($timeout, webDevTec, toastr, $scope, $auth, $state, Team) {
    $scope.teams = [];
    $scope.new_team = null;
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    Team.get({}, (function(data) {
      $scope.teams = data.teams;
      $scope.pagination = data.pagination;
      $scope.totalItems = data.pagination.total_items;
      return $scope.load_data = false;
    }), function(error) {
      $scope.showError(error);
      return $scope.load_data = false;
    });
    $scope.searchTeam = function() {
      return Team.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.teams = data.teams;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Team.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.teams = data.teams;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.updateTeam = function(team) {
      return Team.update({
        id: team.id,
        team: team
      }, (function(data) {
        return toastr.info('Equipe alterada');
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.addTeam = function(team) {
      return Team.save({
        team: {
          title: team
        }
      }, (function(data) {
        toastr.info('Equipe cadastrada');
        $scope.new_team = null;
        return $scope.teams.push(data);
      }), function(error) {
        $scope.showError(error);
      });
    };
    return $scope.removeTeam = function(team_id, index) {
      return Team["delete"]({
        id: team_id
      }, (function(data) {
        $scope.teams.splice(index, 1);
        return toastr.error("Equipe removida");
      }), function(error) {
        $scope.showError(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Team', [
    '$resource', function($resource) {
      return $resource('/api/teams/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/teams/:id',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ShiftHoursController', function($timeout, toastr, $scope, $auth, $state, ShiftHour) {
    $scope.new_shift_hour = null;
    $scope.shift_hours = [];
    ShiftHour.query({}, function(data) {
      return $scope.shift_hours = data;
    });
    $scope.addShiftHour = function(new_shift_hour) {
      if ($scope.new_shift_hour) {
        return ShiftHour.save({
          shift_hour: {
            title: new_shift_hour
          }
        }, (function(data) {
          $scope.shift_hours.push(data);
          toastr.info('Tipo de hora de deslocamento adicionado');
          return $scope.new_shift_hour = null;
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
    $scope.removeShiftHour = function(shift_hour_id, index) {
      return ShiftHour["delete"]({
        id: shift_hour_id
      }, function(data) {
        $scope.shift_hours.splice(index, 1);
        return toastr.error('Tipo de hora de deslocamento removido');
      });
    };
    return $scope.updateOrder = function() {
      return ShiftHour.update_order({
        shift_hours: $scope.shift_hours
      }, (function(data) {
        return console.log(data);
      }), function(error) {
        $scope.showError(error);
        return console.log(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('ShiftHour', [
    '$resource', function($resource) {
      return $resource('/api/shift_hours/:id', {
        id: '@id'
      }, {
        update_order: {
          method: 'PUT',
          url: '/api/shift_hours/update_order'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('SessionsController', function($timeout, webDevTec, toastr, Client, $scope, $auth) {});

}).call(this);



(function() {
  angular.module('ideal').controller('RoleGroupsController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, RoleGroup) {
    $scope.new_role_group = null;
    $scope.role_groups = [];
    RoleGroup.query({}, function(data) {
      return $scope.role_groups = data;
    });
    $scope.filterRoleGroups = function(query) {
      return RoleGroup.query({
        query: query
      }, function(data) {
        return $scope.role_groups = data;
      });
    };
    $scope.addRoleGroup = function() {
      if ($scope.new_role_group) {
        return RoleGroup.save({
          role_group: {
            name: $scope.new_role_group
          }
        }, (function(data) {
          toastr.info("Grupo de permissão criado");
          $scope.new_role_group = null;
          return $scope.role_groups.push(data);
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    return $scope.removeRoleGroup = function(role_group_id, index) {
      return RoleGroup["delete"]({
        id: role_group_id
      }, (function(data) {
        toastr.error("Grupo de permissão removido");
        return $scope.role_groups.splice(index, 1);
      }), function(error) {
        $scope.showError(error);
      });
    };
  }).controller('RoleGroupsShowController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, $stateParams, RoleGroup, $filter) {
    $scope.role_group = {};
    $scope.roles = [];
    $scope.report_roles = [];
    $scope.users = [];
    $scope.new_user = {};
    RoleGroup.get({
      id: $stateParams.id
    }, function(data) {
      $scope.role_group = data.role_group;
      $scope.roles = data.roles;
      $scope.report_roles = data.roles.splice(15, 23);
      return $scope.users = data.users;
    });
    $scope.translate_roles = {
      manage_users: 'Gerenciar Usuários',
      manage_calls: 'Gerenciar Chamadas',
      manage_teams: 'Gerenciar Equipes',
      manage_attendance_codes: 'Gerenciar Códigos de Atendimento',
      manage_ceps: 'Gerenciar Cadastro de CEP',
      manage_shift_hours: 'Gerenciar Tipo de Hora de Deslocamento',
      manage_notifications: 'Gerenciar Notificações',
      manage_clients: 'Gerenciar Clientes',
      manage_vehicles: 'Gerenciar Veículos',
      manage_contract_types: 'Gerenciar Plano',
      manage_destinations: 'Gerenciar Destinos',
      manage_role_group: 'Gerenciar Grupo de Permissões',
      edit_closed_calls: 'Editar Chamadas Fechadas',
      manage_disease: 'Gerenciar Agravantes',
      manage_health_plan: 'Gerenciar Tipo de Plano de Saúde',
      can_extract_clients: 'Clientes',
      can_export_cards: 'Exportar Carteirinha',
      can_extract_affiliates: 'Filiados',
      can_extract_contracts_block: 'Adendo em Bloco',
      can_extract_calls: 'Chamadas',
      can_extract_contracts: 'Planos',
      can_extract_users: 'Usuários',
      can_extract_archive: 'Clientes removidos'
    };
    $scope.checkExists = function(value) {
      return $filter('filter')($scope.role_group.roles, {
        id: value.id
      }).length > 0;
    };
    $scope.updateRole = function(key, value) {
      var data;
      if ($scope.role_group[key]) {
        data = {
          id: $scope.role_group.id,
          role_id: value
        };
        return RoleGroup.add_role(data, function(data, status) {
          return toastr.info('Permissão adicionada');
        });
      } else {
        data = {
          id: $scope.role_group.id,
          role_id: value
        };
        return RoleGroup.remove_role(data, (function(data, status) {
          return toastr.error("Permissão removida");
        }), function(error) {
          $scope.role_group[key] = true;
          return $scope.showError(error);
        });
      }
    };
    $scope.addUser = function(user, select_index) {
      if (user) {
        return RoleGroup.add_user({
          id: $scope.role_group.id,
          user_id: user.id
        }, (function(data) {
          toastr.info("Usuário adicionado");
          $scope.role_group.users.push(user);
          return $scope.users.splice(select_index, 1);
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
    return $scope.removeUser = function(user, index) {
      return RoleGroup.remove_user({
        id: $scope.role_group.id,
        user_id: user.id
      }, (function(data) {
        toastr.error("Usuário removido");
        $scope.role_group.users.splice(index, 1);
        return $scope.users.push(user);
      }), function(error) {
        return $scope.showError(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('RoleGroup', [
    '$resource', function($resource) {
      return $resource('/api/role_groups/:id', {
        id: '@id'
      }, {
        remove_role: {
          url: '/api/role_groups/:id/remove_role',
          method: 'put'
        },
        add_role: {
          url: '/api/role_groups/:id/add_role',
          method: 'put',
          isArray: true
        },
        add_user: {
          url: '/api/role_groups/:id/add_user',
          method: 'PUT'
        },
        remove_user: {
          url: '/api/role_groups/:id/remove_user',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ReviewsController', function($timeout, toastr, $scope, $auth, $state, Organization) {
    $scope.organization = {};
    Organization.get({}, function(data) {
      return $scope.organization = data;
    });
    return $scope.saveRevision = function() {
      if ($scope.organization.id) {
        return Organization.update({
          id: $scope.organization.id,
          organization: $scope.organization
        }, (function(data) {
          return toastr.info("Revisão alterada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        return Organization.save({
          organization: $scope.organization
        }, (function(data) {
          toastr.info('Revisão Alterada');
          return $scope.organization = data;
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('ReportsExportCardswController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, Client, $filter, $http) {
    var disabled;
    $scope.clients = [];
    $scope.affiliates = [];
    $scope.report = {
      start_date: new Date(),
      exported: true,
      not_exported: true,
      active: true,
      inactive: true,
      affiliate_ids: []
    };
    $scope.result = [];
    $scope.exported_labels = {
      "true": 'Exportado',
      "false": 'Não exportado'
    };
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      locale: 'pt-br',
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.report.start_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.newUser.birth_date = new Date('');
    };
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          return $scope.clients = data;
        });
      }
    };
    $scope.applyReport = function() {
      $scope.report.affiliate_ids = [];
      return Report.get_affiliates_cards({
        report: $scope.report
      }, function(data) {
        return $scope.result = data;
      });
    };
    $scope.none = {
      id: null,
      name: "Nenhum"
    };
    $scope.getAffiliates = function(client_id) {
      $scope.report.affiliate_id = {};
      $scope.affiliates = [];
      return Client.get_affiliates({
        id: client_id,
        active: true
      }, function(data) {
        $scope.affiliates = data;
        if (data.length > 0) {
          return $scope.affiliates.splice(0, 0, $scope.none);
        }
      });
    };
    $scope.setAll = function(select) {
      $.each($scope.result, function(index, value) {
        value.checked = select;
        return true;
      });
    };
    $scope.generateSelected = function() {
      var selected_affiliates;
      selected_affiliates = $filter('filter')($scope.result, {
        checked: true
      }, true).map(function(a) {
        return a.affiliate_id;
      });
      if (selected_affiliates.length > 0) {
        $scope.report.affiliate_ids = selected_affiliates;
        return $http({
          method: 'PUT',
          url: "/api/reports/export_cards",
          data: {
            report: $scope.report
          },
          responseType: 'arraybuffer',
          headers: $auth.retrieveData('auth_headers')
        }).then((function(response) {
          var a, file, fileURL;
          a = document.createElement('a');
          document.body.appendChild(a);
          file = new Blob([response.data], {
            type: 'plain/text'
          });
          fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = 'Carteirinhas.txt';
          a.click();
        }));
      }
    };
    return $scope.generateAll = function() {
      $http({
        method: 'PUT',
        url: "/api/reports/export_cards",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'plain/text'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Carteirinhas.txt';
        a.click();
      }));
    };
  }).controller('ReportsExtractCallsController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, Client, $filter, $http, AttendanceCode) {
    var disabled;
    $scope.result = [];
    $scope.clients = [];
    $scope.report = {
      opened: true,
      closed: true,
      revised: true,
      canceled: true,
      not_revised: true
    };
    $scope.loadingPdf = false;
    $scope.loadingCSV = false;
    $scope.loadingCSVDetailed = false;
    $scope.attendance_codes = [];
    $scope.is_closed_labels = {
      "true": 'Fechado',
      "false": 'Aberto'
    };
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    AttendanceCode.get({}, function(data) {
      return $scope.attendance_codes = data.attendance_codes;
    });
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.loadAffiliates = function(search) {
      if (search.length > 0) {
        return Client.load_affiliates({
          search: search,
          client_id: $scope.report.client_id
        }, function(data) {
          return $scope.affiliates = data;
        });
      }
    };
    $scope.clearAffiliateValues = function() {
      $scope.affiliates = [];
      return $scope.affiliate_id = null;
    };
    $scope.dateFormat = "dd/MM/yyyy";
    User.users_by_position({}, function(data) {
      return $scope.team_users = data;
    });
    $scope.dateOptions = {
      formatYear: "yy",
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.report.start_date = null;
      $scope.report.end_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
      $scope.report.end_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.report.start_date = new Date('');
      $scope.report.end_date = new Date('');
    };
    $scope.applyReport = function() {
      return Report.extract_calls({
        report: $scope.report
      }, function(data) {
        return $scope.result = data;
      });
    };
    $scope.downloadPDF = function() {
      $scope.loadingPdf = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_calls_pdf",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingPdf = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/pdf'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = "Chamadas.pdf";
        a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingPdf = false;
      });
    };
    return $scope.downloadCSVDetailed = function() {
      $scope.loadingCSVDetailed = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_calls_csv_detailed",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingCSVDetailed = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Chamadas.xlsx';
        return a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingCSVDetailed = false;
      });
    };
  }).controller('ReportsExtractClientsController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, Client, $filter, $http, ContractType) {
    var disabled;
    $scope.result = [];
    $scope.clients = [];
    $scope.report = {
      active: true,
      inactive: true,
      person: true,
      legal: true,
      seller_id: null
    };
    ContractType.query({}, function(data) {
      $scope.contract_types = data;
      return $scope.contract_types.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.report.start_date = null;
      $scope.report.end_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
      $scope.report.end_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.report.start_date = new Date('');
      $scope.report.end_date = new Date('');
    };
    $scope.sellers = [];
    User.users_by_position({}, function(data) {
      $scope.sellers = data.sellers;
      return $scope.sellers.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.applySearch = false;
    $scope.applyReport = function() {
      $scope.applySearch = true;
      return Report.extract_clients({
        report: $scope.report
      }, function(data) {
        $scope.result = data;
        return $scope.applySearch = false;
      });
    };
    return $scope.downloadCSV = function() {
      return $http({
        method: 'PUT',
        url: "/api/reports/extract_clients_csv",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Clientes.xlsx';
        a.click();
      }));
    };
  }).controller('ReportsExtractAffiliatesController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, Client, $filter, $http, ContractType) {
    var disabled;
    $scope.result = [];
    $scope.clients = [];
    $scope.loadingReport = false;
    $scope.report = {
      active: true,
      inactive: true,
      person: true,
      legal: true
    };
    ContractType.query({}, function(data) {
      $scope.contract_types = data;
      return $scope.contract_types.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      dateFormat: $scope.dateFormat
    };
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.clear = function() {
      $scope.report.start_date = null;
      $scope.report.end_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
      $scope.report.end_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.report.start_date = new Date('');
      $scope.report.end_date = new Date('');
    };
    $scope.applyReport = function() {
      $scope.loadingReport = true;
      return Report.extract_affiliates({
        report: $scope.report
      }, function(data) {
        $scope.loadingReport = false;
        return $scope.result = data;
      });
    };
    $scope.downloadPDF = function() {
      $scope.loadingReport = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_affiliates_pdf",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingReport = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/pdf'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = "Filiados.pdf";
        a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingReport = false;
      });
    };
    return $scope.downloadCSV = function() {
      $scope.loadingReport = true;
      return $http({
        method: 'PUT',
        url: "/api/reports/extract_affiliates_csv",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingReport = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Filiados.xlsx';
        a.click();
      }));
    };
  }).controller('ReportsExtractContractsController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Contract, Report, Client, ContractType, $filter, $http) {
    var date;
    $scope.result = [];
    $scope.clients = [];
    date = new Date();
    $scope.applySearch = false;
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.report = {
      start_date: null,
      end_date: null,
      active: true,
      inactive: true,
      canceled: true,
      person: true,
      legal: true,
      contract_type_id: null,
      seller_id: null
    };
    $scope.dateOptions = {
      formatYear: "yy",
      locale: 'pt-br',
      dateFormat: $scope.dateFormat
    };
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    $scope.sellers = [];
    User.users_by_position({}, function(data) {
      $scope.sellers = data.sellers;
      return $scope.sellers.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.contract_types = [];
    ContractType.query({}, function(data) {
      $scope.contract_types = data;
      return $scope.contract_types.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    $scope.applyReport = function() {
      $scope.applySearch = true;
      return Report.extract_contracts({
        report: $scope.report
      }, function(data) {
        $scope.result = data;
        return $scope.applySearch = false;
      });
    };
    return $scope.downloadCSV = function() {
      $scope.loadingCSV = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_contracts_csv",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingCSV = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Contratos.xlsx';
        return a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingCSV = false;
      });
    };
  }).controller('ReportsExtractContractsBlockController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Contract, Report, Client, $filter, $http) {
    var date;
    $scope.result = [];
    $scope.clients = [];
    date = new Date();
    $scope.dateFormat = "MM/yyyy";
    $scope.affiliate_rider_value = 0;
    $scope.report = {
      end_month_date: new Date(),
      active: true,
      inactive: true,
      person: true,
      legal: true,
      contract_block: true
    };
    $scope.propertyName = 'expiration_date';
    $scope.reverse = false;
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
      $scope.selected_index = [];
      $scope.selected_ids = [];
    };
    $scope.dateOptions = {
      formatYear: "yy",
      locale: 'pt-br',
      minMode: 'month',
      dateFormat: $scope.dateFormat
    };
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    $scope.applySearch = false;
    $scope.applyReport = function() {
      $scope.applySearch = true;
      $scope.selected_index = [];
      $scope.selected_ids = [];
      return Report.extract_contracts({
        report: $scope.report
      }, function(data) {
        $scope.result = data;
        return $scope.applySearch = false;
      });
    };
    $scope.all_check = false;
    $scope.selected_index = [];
    $scope.selected_ids = [];
    $scope.checkAll = function(value) {
      var i;
      $scope.selected_index = [];
      $scope.selected_ids = [];
      i = 0;
      while (i < $scope.result.length) {
        if (value) {
          $scope.selected_index.push(i);
          $scope.selected_ids.push($scope.result[i].id);
        } else {
          $scope.selected_index = [];
          $scope.selected_ids = [];
        }
        $scope.result[i].checked = value;
        i++;
      }
    };
    $scope.selectedIndex = function(contract, index) {
      var percent_value;
      if (contract.checked) {
        $scope.selected_index.push(index);
        $scope.selected_ids.push(contract.id);
        percent_value = 0;
        percent_value = ($scope.result[index].billing_cycle_value / 100) * $scope.affiliate_rider_value;
        percent_value = parseFloat(percent_value).toFixed(1);
        return contract.rider = parseFloat($scope.result[index].billing_cycle_value) + parseFloat(percent_value);
      } else {
        $scope.selected_index.splice($scope.selected_index.indexOf(index), 1);
        return $scope.selected_ids.splice($scope.selected_ids.indexOf(contract.id), 1);
      }
    };
    $scope.removeMark = function() {
      var eachData;
      eachData = $scope.selected_index.sort(function(a, b) {
        return b - a;
      });
      $.each(eachData, function(index, value) {
        return $scope.result.splice(value, 1);
      });
      $scope.selected_index = [];
      return $scope.selected_ids = [];
    };
    $scope.updateAffiliateRider = function() {
      $.each($scope.result, function(index, value) {
        var percent_value;
        if (value.checked) {
          percent_value = 0;
          percent_value = (value.billing_cycle_value / 100) * $scope.affiliate_rider_value;
          percent_value = parseFloat(percent_value).toFixed(1);
          return $scope.result[index].rider = parseFloat(value.billing_cycle_value) + parseFloat(percent_value);
        }
      });
    };
    $scope.addRiderBlock = function() {
      if ($scope.selected_ids.length > 0) {
        $scope.disable_action = true;
        return Contract.add_riders_block({
          contract_ids: $scope.selected_ids,
          percent_value: $scope.affiliate_rider_value
        }, (function(data) {
          toastr.info(data.qtd + ' adendo em bloco gerado(s)');
          $scope.removeMark();
          $scope.disable_action = false;
          return $scope.all_check = false;
        }), function(error) {
          $scope.showError(error);
          $scope.disable_action = false;
          return $scope.all_check = false;
        });
      }
    };
    return $scope.downloadCSV = function() {
      $scope.loadingCSV = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_contracts_csv",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingCSV = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Adendo-em-bloco.xlsx';
        return a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingCSV = false;
      });
    };
  }).controller('ReportsExtractUsersController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, $filter, $http, $window) {
    var closeSearchWhenClickingElsewhere, date;
    $scope.result = [];
    date = new Date();
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.report = {
      start_date: null,
      end_date: null,
      positions: {}
    };
    $scope.positions = [
      {
        name: 'Enfermagem',
        id: 'nurse'
      }, {
        name: 'Motorista',
        id: 'driver'
      }, {
        name: 'Médico',
        id: 'doctor'
      }, {
        name: 'Operador',
        id: 'operator'
      }, {
        name: 'Supervisor',
        id: 'supervisor'
      }, {
        name: 'Vendedor',
        id: 'seller'
      }, {
        name: 'Administrativo',
        id: 'administrative'
      }
    ];
    $scope.dateOptions = {
      formatYear: "yy",
      locale: 'pt-br',
      dateFormat: $scope.dateFormat
    };
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.admission_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    $scope.check_selected = false;
    $scope.$window = $window;
    $scope.toggleSearch = function() {
      $scope.check_selected = !$scope.check_selected;
      if ($scope.check_selected) {
        $scope.$window.onclick = function(event) {
          closeSearchWhenClickingElsewhere(event, $scope.toggleSearch);
        };
      } else {
        $scope.check_selected = false;
        $scope.$window.onclick = null;
        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
          $scope.$apply();
        }
      }
    };
    closeSearchWhenClickingElsewhere = function(event, callbackOnClose) {
      var clickedElement, clickedOnSearchDrawer, elementClasses;
      clickedElement = event.target;
      if (!clickedElement) {
        return;
      }
      elementClasses = clickedElement.classList;
      clickedOnSearchDrawer = elementClasses.contains('handle-right') || elementClasses.contains('drawer-right') || clickedElement.parentElement !== null && clickedElement.parentElement.classList.contains('drawer-right');
      if (!clickedOnSearchDrawer) {
        if (event.target.nodeName !== 'SPAN' && event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'LI') {
          console.log(event.target.nodeName);
          callbackOnClose();
        }
        return;
      }
    };
    return $scope.downloadCSV = function() {
      $scope.loadingCSV = true;
      $http({
        method: 'PUT',
        url: "/api/reports/extract_users_by_position_csv",
        data: {
          report: $scope.report
        },
        responseType: 'arraybuffer',
        headers: $auth.retrieveData('auth_headers')
      }).then((function(response) {
        var a, file, fileURL;
        $scope.loadingCSV = false;
        a = document.createElement('a');
        document.body.appendChild(a);
        file = new Blob([response.data], {
          type: 'application/xlsx'
        });
        fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = 'Usuários.xlsx';
        return a.click();
      }), function(response) {
        toastr.error("Erro ao gerar relatório");
        return $scope.loadingCSV = false;
      });
    };
  }).controller('ReportsExtractArchivesController', function($timeout, webDevTec, toastr, User, $scope, $auth, $state, Report, Client, $filter, $http, ContractType, $uibModal) {
    var ModalInstanceCtrl, disabled;
    $scope.result = [];
    $scope.clients = [];
    $scope.report = {
      archive: true,
      person: true,
      legal: true
    };
    ContractType.query({}, function(data) {
      $scope.contract_types = data;
      return $scope.contract_types.unshift({
        name: "Nenhum",
        id: null
      });
    });
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_archive({
          search: search
        }, function(data) {
          $scope.clients = data;
          return $scope.clients.unshift({
            name: "Nenhum",
            id: null
          });
        });
      }
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.orderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.dateOptions = {
      formatYear: "yy",
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.report.start_date = null;
      $scope.report.end_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.report.start_date = new Date(year, month, day);
      $scope.report.end_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    $scope.popup2 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.report.start_date = new Date('');
      $scope.report.end_date = new Date('');
    };
    $scope.applySearch = false;
    $scope.applyReport = function() {
      $scope.applySearch = true;
      return Report.extract_archive({
        report: $scope.report
      }, function(data) {
        $scope.result = data;
        return $scope.applySearch = false;
      });
    };
    $scope.archiveModalRevive = function(client, index) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/reports/archive_modal_revive.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        resolve: {
          client: client,
          index: index
        },
        size: 'md'
      });
      return modalInstance;
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Client, client, index) {
      $scope.archive_revive = function(client_id, index) {
        return Client.archive_revive({
          id: client_id
        }, (function(data) {
          return $scope.result.splice(index, 1);
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.ok = function() {
        $scope.archive_revive(client.id, index);
        $uibModalInstance.close();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
        $state.go('extract_archive');
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Report', [
    '$resource', function($resource) {
      return $resource('/api/reports/:id', {
        id: '@id'
      }, {
        extract_archive: {
          url: '/api/reports/extract_archive',
          method: 'PUT',
          isArray: true
        },
        export_cards: {
          url: '/api/reports/export_cards',
          method: 'PUT'
        },
        get_affiliates_cards: {
          url: '/api/reports/get_affiliates_cards',
          method: 'PUT',
          isArray: true
        },
        extract_calls: {
          url: '/api/reports/extract_calls',
          method: 'PUT',
          isArray: true
        },
        extract_clients: {
          url: '/api/reports/extract_clients',
          method: 'PUT',
          isArray: true
        },
        extract_affiliates: {
          url: '/api/reports/extract_affiliates',
          method: 'PUT',
          isArray: true
        },
        extract_contracts: {
          url: '/api/reports/extract_contracts',
          method: 'PUT',
          isArray: true
        },
        extract_users_by_position: {
          url: '/api/reports/extract_users_by_position',
          method: 'PUT',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('QrlsController', function($timeout, webDevTec, toastr, $scope, $auth, $state, Qrl) {
    $scope.qrls = [];
    $scope.new_qrl = null;
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    Qrl.get({}, (function(data) {
      $scope.qrls = data.qrls;
      $scope.pagination = data.pagination;
      $scope.totalItems = data.pagination.total_items;
      return $scope.load_data = false;
    }), function(error) {
      $scope.showError(error);
      return $scope.load_data = false;
    });
    $scope.searchQRL = function() {
      return Qrl.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.qrls = data.qrls;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Qrl.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.qrls = data.qrls;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.updateQrl = function(qrl) {
      return Qrl.update({
        id: qrl.id,
        qrl: qrl
      }, (function(data) {
        return toastr.info('QRL alterado');
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.addQrl = function(qrl) {
      return Qrl.save({
        qrl: {
          name: qrl
        }
      }, (function(data) {
        toastr.info('QRL cadastrado');
        $scope.new_qrl = null;
        return $scope.qrls.push(data);
      }), function(error) {
        $scope.showError(error);
      });
    };
    return $scope.removeQrl = function(qrl_id, index) {
      return Qrl["delete"]({
        id: qrl_id
      }, function(data) {
        return $scope.qrls.splice(index, 1);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Qrl', [
    '$resource', function($resource) {
      return $resource('/api/qrls/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/qrls/:id',
          method: 'PUT'
        },
        get_qrls: {
          url: '/api/qrls/get_qrls',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('NotificationsController', function($timeout, webDevTec, toastr, Notification, $scope, $auth, $state, $uibModal) {
    var ModalInstanceCtrl;
    $scope.notification = {};
    Notification.get({}, function(data) {
      if (data) {
        return $scope.notification = data;
      }
    });
    $scope.changeNotification = function() {
      if ($scope.notification.id) {
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação alterada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        return Notification.save({
          notification: $scope.notification
        }, (function(data) {
          toastr.info('Notificação Alterada');
          return $scope.notification = data;
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.callsVariablesModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/notifications/calls_variables.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    $scope.usersVariablesModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/notifications/users_variables.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    $scope.notificationCloseActive = function() {
      if ($scope.notification.close_call_active === false) {
        $scope.notification.close_call_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.close_call_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.notificationReopenActive = function() {
      if ($scope.notification.reopen_call_active === false) {
        $scope.notification.reopen_call_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.reopen_call_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.notificationExpirationContract = function() {
      if ($scope.notification.expiration_contract_active === false) {
        $scope.notification.expiration_contract_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.expiration_contract_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.notificationOpenCall = function() {
      if ($scope.notification.open_call_active === false) {
        $scope.notification.open_call_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.open_call_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.notificationAso = function() {
      if ($scope.notification.aso_active === false) {
        $scope.notification.aso_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.aso_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.notificationIntegration = function() {
      if ($scope.notification.integration_active === false) {
        $scope.notification.integration_active = true;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Ativada");
        }), function(error) {
          $scope.showError(error);
        });
      } else {
        $scope.notification.integration_active = false;
        return Notification.update({
          id: $scope.notification.id,
          notification: $scope.notification
        }, (function(data) {
          return toastr.info("Notificação Desativada");
        }), function(error) {
          $scope.showError(error);
        });
      }
    };
    $scope.variablesModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/notifications/variables.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Notification', [
    '$resource', function($resource) {
      return $resource('/api/notifications/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/notifications/:id',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ModalInstanceCtrl', function($uibModalInstance, $scope) {
    $scope.ok = function() {
      console.log("AQUI");
      $uibModalInstance.close;
    };
    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('MainController', function($timeout, webDevTec, toastr, $scope, $auth, $state, Dashboard) {
    $scope.attendance_labels = [];
    $scope.attendance_data = [];
    $scope.attendance_color = [];
    $scope.attendance_options = {
      legend: {
        display: true
      }
    };
    Dashboard.calls_resume({}, function(data) {
      $scope.open_calls = data.open_calls[0].qtd_calls;
      return $scope.pending_revision_calls = data.pending_revision[0].qtd_calls;
    });
    Dashboard.attendance_month_chart({}, function(data) {
      data.forEach(function(_data) {
        $scope.attendance_labels.push(_data.attendance_code_title);
        $scope.attendance_color.push(_data.attendance_code_color);
        return $scope.attendance_data.push(_data.qtd_calls);
      });
      return $scope.attendance_data = $scope.attendance_data;
    });
    return $scope.LogOut = function() {
      return $auth.signOut().then(function(resp) {
        $state.go("login");
      })["catch"](function(resp) {
        console.log(resp);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('HealthPlansController', function($timeout, webDevTec, toastr, $scope, $auth, $state, HealthPlan) {
    $scope.health_plans = [];
    $scope.new_health_plan = null;
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    HealthPlan.get({}, (function(data) {
      $scope.health_plans = data.health_plans;
      $scope.pagination = data.pagination;
      $scope.totalItems = data.pagination.total_items;
      return $scope.load_data = false;
    }), function(error) {
      $scope.showError(error);
      return $scope.load_data = false;
    });
    $scope.searchHealthPlan = function() {
      return HealthPlan.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.health_plans = data.health_plans;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return HealthPlan.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.health_plans = data.health_plans;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.updateHealthPlan = function(data) {
      return HealthPlan.update({
        id: data.id,
        health_plan: data
      }, (function(data) {
        return toastr.info('Tipo de plano de saúde alterado');
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.addHealthPlan = function(data) {
      return HealthPlan.save({
        health_plan: {
          title: data
        }
      }, (function(data) {
        toastr.info('Plano de saúde cadastrado');
        $scope.new_health_plan = null;
        return $scope.health_plans.push(data);
      }), function(error) {
        $scope.showError(error);
      });
    };
    return $scope.removeHealthPlan = function(health_plan_id, index) {
      return HealthPlan["delete"]({
        id: health_plan_id
      }, (function(data) {
        $scope.health_plans.splice(index, 1);
        return toastr.error("Plano de saúde removido");
      }), function(error) {
        $scope.showError(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('HealthPlan', [
    '$resource', function($resource) {
      return $resource('/api/health_plans/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/health_plans/:id',
          method: 'PUT'
        },
        get_health_plans: {
          url: '/api/health_plans/get_health_plans',
          method: 'GET',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('Disease', [
    '$resource', function($resource) {
      return $resource('/api/diseases/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/diseases/:id',
          method: 'PUT'
        },
        reload_diseases: {
          url: '/api/diseases/reload_diseases',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('DiseasesController', function($timeout, webDevTec, toastr, $scope, $auth, $state, Disease, $uibModal) {
    var ModalInstanceCtrl;
    $scope.diseases = [];
    $scope.totalItems = 0;
    $scope.new_disease = null;
    $scope.filter = null;
    $scope.pagination = {
      page: 1,
      is_last_page: true
    };
    $scope.load_diseases = true;
    Disease.get({
      page: $scope.pagination.page,
      search: $scope.search
    }, function(data) {
      $scope.diseases = data.diseases;
      $scope.load_diseases = false;
      $scope.pagination = data.pagination;
      return $scope.totalItems = data.pagination.total_items;
    });
    $scope.searchDisease = function() {
      return Disease.get({
        search: $scope.search,
        page: 1
      }, function(data) {
        $scope.diseases = data.diseases;
        $scope.load_diseases = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Disease.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.diseases = data.diseases;
        $scope.load_diseases = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 4;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 5;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.updateDisease = function(disease) {
      return Disease.update({
        id: disease.id,
        disease: disease
      }, (function(data) {
        return toastr.info('Agravante alterado');
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.removeDisease = function(disease_id, index) {
      return Disease["delete"]({
        id: disease_id
      }, (function(data) {
        toastr.error('Agravante removido');
        return $scope.diseases.splice(index, 1);
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.newDisease = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/diseases/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance) {
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      return $scope.addDisease = function(disease) {
        return Disease.save({
          disease: {
            title: disease
          }
        }, (function(data) {
          toastr.info('Agravante cadastrado');
          $scope.new_disease = null;
          $scope.diseases.push(data);
          return $scope.ok();
        }), function(error) {
          $scope.showError(error);
        });
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Diagnosis', [
    '$resource', function($resource) {
      return $resource('/api/diagnoses/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT',
          url: '/api/diagnoses/:id'
        },
        get_by_code: {
          method: 'GET',
          url: '/api/diagnoses/get_by_code'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('DiagnosesController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Diagnosis) {
    var ModalInstanceCtrl;
    $scope.diagnosis = {};
    $scope.diagnoses = [];
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    $scope.getDiagnoses = function() {
      return Diagnosis.get({}, (function(data) {
        $scope.diagnoses = data.diagnoses;
        $scope.pagination = data.pagination;
        $scope.totalItems = data.pagination.total_items;
        return $scope.load_data = false;
      }), function(error) {
        $scope.showError(error);
        return $scope.load_data = false;
      });
    };
    $scope.getDiagnoses();
    $scope.searchDiagnose = function() {
      return Diagnosis.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.diagnoses = data.diagnoses;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Diagnosis.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.diagnoses = data.diagnoses;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.newDiagnosis = function() {
      $scope.diagnosis = {};
      return $scope.diagnosisModal();
    };
    $scope.editDiagnosis = function(diagnosis) {
      $scope.diagnosis = angular.copy(diagnosis);
      return $scope.diagnosisModal();
    };
    $scope.diagnosisModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/diagnoses/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    $scope.removeDiagnosis = function(diagnosis_id, index) {
      return Diagnosis["delete"]({
        id: diagnosis_id
      }, (function(data) {
        return $scope.diagnoses.splice(index, 1);
      }), function(error) {
        $scope.showError(error);
      });
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      $scope.code_regex = /[0-9]{2}-[0-9]{2}/;
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      return $scope.saveDiagnosis = function() {
        if (!$scope.diagnosis.id) {
          return Diagnosis.save({
            diagnosis: $scope.diagnosis
          }, (function(data) {
            toastr.info('Diagnóstico cadastrado');
            $scope.diagnosis = {};
            $scope.getDiagnoses();
            return $scope.ok();
          }), function(error) {
            $scope.showError(error);
          });
        } else {
          return Diagnosis.update({
            id: $scope.diagnosis.id,
            diagnosis: $scope.diagnosis
          }, (function(data) {
            toastr.info('Diagnóstico alterado');
            $scope.getDiagnoses();
            $scope.ok();
            return $scope.diagnosis = {};
          }), function(error) {
            $scope.showError(error);
          });
        }
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('DestinationsController', function($timeout, webDevTec, toastr, $scope, $auth, $state, Destination) {
    $scope.destinations = [];
    $scope.new_destination = null;
    $scope.pagination = {};
    $scope.totalItems = 0;
    $scope.load_data = true;
    $scope.search = null;
    Destination.get({}, (function(data) {
      $scope.destinations = data.destinations;
      $scope.pagination = data.pagination;
      $scope.totalItems = data.pagination.total_items;
      return $scope.load_data = false;
    }), function(error) {
      $scope.showError(error);
      return $scope.load_data = false;
    });
    $scope.searchDestination = function() {
      return Destination.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.destinations = data.destinations;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Destination.get({
        page: $scope.pagination.page,
        search: $scope.search
      }, function(data) {
        $scope.destinations = data.destinations;
        $scope.load_data = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.updateDestination = function(destination) {
      return Destination.update({
        id: destination.id,
        destination: destination
      }, (function(data) {
        return toastr.info('Destino alterado');
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.addDestination = function(destination) {
      return Destination.save({
        destination: {
          name: destination
        }
      }, (function(data) {
        toastr.info('Destino cadastrado');
        $scope.new_destination = null;
        return $scope.destinations.push(data);
      }), function(error) {
        $scope.showError(error);
      });
    };
    return $scope.removeDestination = function(destination_id, index) {
      return Destination["delete"]({
        id: destination_id
      }, function(data) {
        return $scope.destinations.splice(index, 1);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Destination', [
    '$resource', function($resource) {
      return $resource('/api/destinations/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/destinations/:id',
          method: 'PUT'
        },
        get_destinations: {
          url: '/api/destinations/get_destinations',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('Dashboard', [
    '$resource', function($resource) {
      return $resource('/api/dashboards/:id', {
        id: '@id'
      }, {
        calls_resume: {
          url: '/api/dashboards/calls_resume.json'
        },
        attendance_month_chart: {
          url: '/api/dashboards/attendance_month_chart.json',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ContractsController', function($timeout, toastr, $scope, $auth, $state, Contract) {
    $scope.contracts = [];
    $scope.filter = {
      active: true,
      inactive: false
    };
    $scope.all_types = {
      free: 'Livre',
      group: 'Compartilhado',
      single: 'Individual com taxa',
      single_free: 'Individual livre'
    };
    $scope.totalItems = 0;
    $scope.pagination = {};
    $scope.load_contracts = true;
    Contract.get({
      filter: $scope.filter
    }, function(data) {
      $scope.contracts = data.contracts;
      $scope.qtd_pages = data.pagination.quantity_pages;
      $scope.load_contracts = false;
      if (data.pagination) {
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      }
    });
    $scope.searchContracts = function() {
      $scope.contracts = [];
      return Contract.get({
        page: $scope.pagination.page,
        filter: $scope.filter
      }, function(data) {
        $scope.contracts = data.contracts;
        $scope.load_contracts = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Contract.get({
        page: $scope.pagination.page,
        filter: $scope.filter
      }, function(data) {
        $scope.contracts = data.contracts;
        $scope.load_contracts = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 10;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 10;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    return $scope.removeContract = function(contract_id, index) {
      return Contract["delete"]({
        id: contract_id
      }, (function(data) {
        toastr.error('Plano removido');
        return $scope.contracts.splice(index, 1);
      }), function(error) {
        return $scope.showError(error);
      });
    };
  }).controller('ContractsNewController', function($timeout, toastr, $scope, $auth, $state, $stateParams, $filter, Contract, ContractType, Client) {
    var current_rider_date, disabled;
    $scope.contract_types = [];
    $scope.clients = [];
    $scope.selected_contract_type = {};
    $scope.contract = {};
    $scope.contract_rider = {};
    $scope.contract_rider_affiliates = [];
    $scope.client_active = true;
    $scope.page_title = "Novo Plano";
    ContractType.query({}, function(data) {
      return $scope.contract_types = data;
    });
    $scope.loadClients = function(search) {
      if (search.length > 0) {
        return Client.reload_client({
          search: search,
          active: $scope.client_active
        }, function(data) {
          return $scope.clients = data;
        });
      }
    };
    $scope.loadAffiliates = false;
    $scope.getAffiliates = function(client_id) {
      $scope.contract_rider_affiliates = [];
      $scope.loadAffiliates = true;
      return Client.get_affiliates({
        id: client_id,
        active: $scope.client_active
      }, function(data) {
        $scope.affiliates = data;
        $scope.loadAffiliates = false;
        $scope.total_affiliates = data.length;
        if ($stateParams.current_rider && $stateParams.current_rider.contract_rider_affiliates && $stateParams.current_rider.contract_rider_affiliates.length > 0) {
          return $.each($stateParams.current_rider.contract_rider_affiliates, function(index, value) {
            $scope.contract_rider_affiliates.push({
              name: value.affiliate.name,
              billing_cycle_value: value.billing_cycle_value,
              qtd_calls: value.qtd_calls,
              additional_call: value.additional_call,
              id: value.affiliate.id,
              birth_date: value.affiliate.birth_date
            });
            return $scope.affiliates = $filter('filter')($scope.affiliates, function(affiliate, index) {
              return affiliate.name.indexOf(value.affiliate.name) === -1;
            });
          });
        }
      });
    };
    $scope.addAffiliate = function(affiliate, select) {
      var index;
      if (affiliate) {
        $scope.new_affiliate = '';
        select.selected = '';
        index = $scope.affiliates.indexOf(affiliate);
        $scope.affiliates.splice(index, 1);
        return $scope.contract_rider_affiliates.push(affiliate);
      }
    };
    $scope.removeAffiliate = function(index, affiliate) {
      $scope.contract_rider_affiliates.splice(index, 1);
      return $scope.affiliates.push(affiliate);
    };
    $scope.setContractType = function(selected) {
      $scope.contract_rider = {};
      $scope.selected_contract_type = selected;
      if ($scope.contract.client_id) {
        return $scope.getAffiliates($scope.contract.client_id);
      }
    };
    if ($stateParams.client_id) {
      $scope.contract.client_id = parseInt($stateParams.client_id);
      $scope.getAffiliates($stateParams.client_id);
      Client.get({
        id: $stateParams.client_id
      }, function(data) {
        return $scope.loadClients(data.client.name);
      });
    }
    if ($stateParams.contract_id) {
      $scope.page_title = "Editar Plano";
      $scope.contract = $stateParams.contract;
      $scope.contract.contract_type_id = parseInt($stateParams.contract.contract_type_id);
      $scope.contract.client_id = parseInt($stateParams.contract.client_id);
      $scope.contract_rider = $stateParams.current_rider;
      current_rider_date = new Date($stateParams.current_rider.start_date);
      $scope.contract_rider.start_date = new Date(current_rider_date.getFullYear(), current_rider_date.getMonth(), current_rider_date.getDate() + 1, 0, 0, 0);
      if ($stateParams.current_rider.billing_cicle) {
        $scope.contract_rider.billing_cicle = $stateParams.current_rider.billing_cicle.toString();
      }
      if ($stateParams.current_rider.closing_cicle) {
        $scope.contract_rider.closing_cicle = $stateParams.current_rider.closing_cicle.toString();
      }
      $scope.selected_contract_type = $stateParams.contract.contract_type;
      $scope.getAffiliates($stateParams.contract.client_id);
      $scope.loadClients($scope.contract.client.name);
    }
    $scope.removePhone = function($index) {
      $scope.phones.splice($index, 1);
    };
    $scope.dateOptions = {
      dateDisabled: false,
      formatYear: 'yyyy',
      startingDay: 1
    };
    $scope.clear = function() {
      $scope.contract_rider.start_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.addAllAffiliates = function() {
      if ($scope.affiliates && $scope.affiliates.length > 0) {
        $scope.contract_rider_affiliates = $scope.contract_rider_affiliates.concat(angular.copy($scope.affiliates));
        return $scope.affiliates = [];
      }
    };
    $scope.removeAllAffiliates = function() {
      $scope.affiliates = $scope.affiliates.concat(angular.copy($scope.contract_rider_affiliates));
      return $scope.contract_rider_affiliates = [];
    };
    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.contract_rider.start_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup1 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.newUser.birth_date = new Date('');
    };
    $scope.checkDate = function(start_date) {
      var date;
      if (angular.isDefined(start_date)) {
        if (start_date.getDate() > 28) {
          $scope.contract_rider.start_date = '';
          return toastr.error("Dia não pode ser maior que 28");
        } else {
          date = new Date(start_date);
          return $scope.contract_rider.start_date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }
      }
    };
    return $scope.saveContract = function() {
      if ($scope.contract.id) {
        return Contract.update({
          id: $scope.contract.id,
          contract: $scope.contract,
          contract_rider: $scope.contract_rider,
          contract_rider_affiliates: $scope.contract_rider_affiliates
        }, (function(data) {
          toastr.info('Plano atualizado');
          return $state.go("show_contract", {
            id: $scope.contract.id
          });
        }), function(error) {
          return $scope.showError(error);
        });
      } else {
        return Contract.save({
          contract: $scope.contract,
          contract_rider: $scope.contract_rider,
          contract_rider_affiliates: $scope.contract_rider_affiliates
        }, (function(data) {
          toastr.info('Plano criado');
          return $state.go("contracts");
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
  }).controller('ContractsShowController', function($timeout, $filter, toastr, $scope, $auth, $state, $stateParams, Contract, ContractType, Client, $uibModal, FileUploader, $http) {
    var ModalInstanceCtrl;
    $scope.panel = 'affiliates';
    $scope.rider_releases = [];
    $scope.all_types = {
      free: 'Livre',
      group: 'Compartilhado',
      single: 'Individual com taxa',
      single_free: 'Individual livre'
    };
    $scope.contract = {};
    $scope.rider_releases = {};
    $scope.current_rider = {};
    $scope.new_notification = {};
    $scope.billing_types = {
      after: 'Posterior',
      before: 'Antecipado'
    };
    $scope.cicles = {
      1: 'Mensal',
      2: 'Bimestral',
      3: 'Trimestral',
      6: 'Semestral',
      12: 'Anual'
    };
    $scope.translatePaymentMethod = {
      bill: 'Boleto',
      notification: 'Carnê',
      card: 'Cartão',
      bank_check: 'Cheque',
      money: 'Dinheiro',
      discount_in_pay: 'Desconto em folha',
      deposit: 'Depósito em conta',
      permutation: 'Permuta'
    };
    $scope.propertyName = 'affiliate.name';
    $scope.reverse = false;
    $scope.affiliatesOrderBy = function(propertyName) {
      $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
      $scope.propertyName = propertyName;
    };
    $scope.new_affiliate = null;
    $scope.rider_new_affiliate = null;
    $scope.dateOptions = {
      dateDisabled: false,
      formatYear: 'yyyy',
      startingDay: 1
    };
    $scope.uploader = new FileUploader({
      url: "./api/contracts/" + $stateParams.id + "/add_contract_files.json?",
      method: 'post',
      alias: 'contract_file[archive]',
      headers: $auth.retrieveData('auth_headers'),
      withCredentials: true
    });
    $scope.uploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.contract.contract_files.push(response);
      if ($scope.uploader.getNotUploadedItems().length === 0) {
        return $scope.uploader.clearQueue();
      }
    };
    $scope.removeFile = function(file_id, index) {
      return Contract.remove_file({
        id: $stateParams.id,
        file_id: file_id
      }, function(data) {
        return $scope.contract.contract_files.splice(index, 1);
      });
    };
    $scope.updateDescription = function() {
      return Contract.update_description({
        id: $stateParams.id,
        contract_rider: $scope.current_rider
      }, (function(data) {
        return toastr.info("Contrato Atualizado");
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.getAffiliates = function(rider_id) {
      return Contract.affiliates_not_in_contract({
        id: $stateParams.id,
        contract_rider_id: rider_id
      }, function(data) {
        return $scope.affiliates = data;
      });
    };
    $scope.getAffiliates(null);
    $scope.downloadFile = function(file) {
      return window.open(file.archive_url);
    };
    $scope.setContractValues = function() {
      return Contract.get({
        id: $stateParams.id
      }, function(data) {
        var date;
        $scope.contract = data;
        $scope.rider_releases = data.rider_releases;
        $scope.current_rider = data.last_rider;
        $scope.current_rider.is_last_rider = true;
        date = new Date(data.last_rider.start_date);
        return $scope.dateOptions.minDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2);
      });
    };
    $scope.setContractValues();
    $scope.getRider = function(rider_id) {
      $scope.getAffiliates(rider_id);
      return Contract.get_rider({
        id: $stateParams.id,
        contract_rider_id: rider_id
      }, function(data) {
        $scope.current_rider = data;
        return $scope.current_rider.user_name = data.user.name;
      });
    };
    $scope.removeLastRider = function() {
      return Contract.remove_last_rider({
        id: $stateParams.id
      }, (function(data) {
        toastr.info('Adendo removido');
        return $scope.setContractValues();
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.cancelContract = function() {
      var modalInstance;
      $scope.new_rider = {
        rider_type: 'cancel'
      };
      return modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/contracts/cancel_contract.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
    };
    $scope.addAffiliate = function(affiliate_id, select) {
      if (affiliate_id) {
        return Contract.add_affiliate({
          id: $stateParams.id,
          contract_rider_id: $scope.current_rider.id,
          affiliate_id: affiliate_id
        }, (function(data) {
          toastr.info('Filiado adicionado');
          $scope.new_affiliate = '';
          select.selected = '';
          $scope.current_rider.contract_rider_affiliates.push(data);
          $scope.rider_affiliates = $filter('filter')($scope.rider_affiliates, function(affiliate, index) {
            return affiliate.name.indexOf(data.affiliate.name) === -1;
          });
          return $scope.getAffiliates($scope.current_rider.id);
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
    $scope.removeAffiliate = function(index, affiliate_id) {
      return Contract.remove_affiliate({
        id: $stateParams.id,
        contract_rider_id: $scope.current_rider.id,
        affiliate_id: affiliate_id
      }, (function(data) {
        toastr.info('Filiado removido');
        $scope.getAffiliates($scope.current_rider.id);
        return $scope.current_rider.contract_rider_affiliates.splice(index, 1);
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.addNotification = function() {
      if ($scope.new_notification.emails && $scope.new_notification.days_before) {
        return Contract.add_notification({
          id: $stateParams.id,
          notification: $scope.new_notification
        }, (function(data) {
          toastr.info('Notificação adicionada');
          $scope.contract.contract_notifications.push(data);
          return $scope.new_notification = {};
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
    $scope.removeNotification = function(index, notification_id) {
      return Contract.remove_notification({
        id: $stateParams.id,
        notification_id: notification_id
      }, (function(data) {
        toastr.info('Notificação removida');
        return $scope.contract.contract_notifications.splice(index, 1);
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.newRiderAffiliates = function() {
      return Client.get_affiliates({
        id: $scope.contract.client_id,
        active: true
      }, function(data) {
        $scope.rider_affiliates = data;
        if ($scope.contract.contract_type._type !== 'free' && $scope.rider_affiliates.length === data.length) {
          if ($scope.contract.contract_type._type === 'single') {
            if ($scope.current_rider.contract_rider_affiliates.length > 0) {
              $.each($scope.current_rider.contract_rider_affiliates, function(index, value) {
                $scope.new_rider.contract_rider_affiliates_hash.push({
                  name: value.affiliate.name,
                  billing_cycle_value: value.billing_cycle_value,
                  qtd_calls: value.qtd_calls,
                  additional_call: value.additional_call,
                  id: value.affiliate.id,
                  birth_date: value.affiliate.birth_date
                });
                return $scope.rider_affiliates = $filter('filter')($scope.rider_affiliates, function(affiliate, index) {
                  return affiliate.name.indexOf(value.affiliate.name) === -1;
                });
              });
            }
          }
          if ($scope.contract.contract_type._type === 'group') {
            if ($scope.current_rider.contract_rider_affiliates.length > 0) {
              $.each($scope.current_rider.contract_rider_affiliates, function(index, value) {
                $scope.new_rider.contract_rider_affiliates_hash.push({
                  name: value.affiliate.name,
                  billing_cycle_value: value.billing_cycle_value,
                  qtd_calls: value.qtd_calls,
                  additional_call: value.additional_call,
                  id: value.affiliate.id,
                  birth_date: value.affiliate.birth_date
                });
                return $scope.rider_affiliates = $filter('filter')($scope.rider_affiliates, function(affiliate, index) {
                  return affiliate.name.indexOf(value.affiliate.name) === -1;
                });
              });
            }
          }
          if ($scope.contract.contract_type._type === 'single_free') {
            if ($scope.current_rider.contract_rider_affiliates.length > 0) {
              return $.each($scope.current_rider.contract_rider_affiliates, function(index, value) {
                $scope.new_rider.contract_rider_affiliates_hash.push({
                  name: value.affiliate.name,
                  billing_cycle_value: value.billing_cycle_value,
                  qtd_calls: value.affiliate.qtd_calls,
                  additional_call: value.affiliate.additional_call,
                  id: value.affiliate.id,
                  birth_date: value.affiliate.birth_date
                });
                return $scope.rider_affiliates = $filter('filter')($scope.rider_affiliates, function(affiliate, index) {
                  return affiliate.name.indexOf(value.affiliate.name) === -1;
                });
              });
            }
          }
        }
      });
    };
    $scope.editContract = function() {
      return $state.go('new_contract', {
        contract_id: $stateParams.id,
        current_rider: $scope.current_rider,
        contract: $scope.contract
      });
    };
    $scope.removeContract = function() {
      return Contract.remove({
        id: $stateParams.id
      }, (function(data) {
        return $state.go('contracts');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.addRiderModal = function() {
      $scope.new_rider = {
        contract_rider_affiliates_hash: []
      };
      $scope.newRiderAffiliates();
      Contract.get_rider({
        id: $stateParams.id
      }, function(data) {
        var modalInstance;
        $scope.dateOptions.startingDay = data.format_start_day;
        return modalInstance = $uibModal.open({
          animation: false,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/contracts/add_rider.html',
          controller: ModalInstanceCtrl,
          scope: $scope,
          size: 'md'
        });
      });
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Call) {
      var disabled;
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.dateFormat = "dd/MM/yyyy";
      $scope.dateOptions = {
        formatYear: "yy",
        startingDay: 1,
        dateFormat: $scope.dateFormat
      };
      $scope.clear = function() {
        $scope.affiliate.birth_date = null;
      };
      $scope.inlineOptions = {
        minDate: new Date,
        showWeeks: true
      };
      $scope.toggleMin = function() {
        $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
        $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
      };
      $scope.toggleMin();
      $scope.open2 = function() {
        $scope.popup2.opened = true;
      };
      $scope.open1 = function() {
        $scope.popup1.opened = true;
      };
      $scope.setDate = function(year, month, day) {
        $scope.affiliate.birth_date = new Date(year, month, day);
      };
      $scope.altInputFormats = ['M!/d!/yyyy'];
      $scope.popup1 = {
        opened: false
      };
      $scope.popup2 = {
        opened: false
      };
      disabled = function(data) {
        var date, mode;
        date = data.date;
        mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
      };
      $scope.today = function() {
        $scope.affiliate.birth_date = new Date('');
      };
      $scope.addRider = function() {
        return Contract.add_rider({
          id: $stateParams.id,
          contract_rider: $scope.new_rider
        }, (function(data) {
          toastr.info('Adendo criado');
          $scope.setContractValues();
          return $scope.ok();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.riderCancelContract = function() {
        return Contract.cancel_contract({
          id: $stateParams.id,
          contract_rider: $scope.new_rider
        }, (function(data) {
          toastr.info('Plano cancelado');
          $scope.setContractValues();
          return $scope.ok();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.riderAddAffiliate = function(affiliate, select) {
        var index;
        index = $scope.rider_affiliates.indexOf(affiliate);
        if (affiliate) {
          $scope.new_rider.contract_rider_affiliates_hash.push(affiliate);
          $scope.rider_affiliates.splice(index, 1);
          $scope.rider_new_affiliate = void 0;
          select.selected = void 0;
        }
      };
      $scope.riderRemoveAffiliate = function(index, affiliate) {
        if (affiliate) {
          $scope.new_rider.contract_rider_affiliates_hash.splice(index, 1);
          return $scope.rider_affiliates.push(affiliate);
        }
      };
      return $scope.clearValues = function() {
        if ($scope.new_rider.rider_type === 'during') {
          return $scope.new_rider.duration = null;
        } else if ($scope.new_rider.rider_type === 'due') {
          return $scope.new_rider.start_date = null;
        }
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Contract', [
    '$resource', function($resource) {
      return $resource('/api/contracts/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        },
        update_description: {
          method: 'PUT',
          url: '/contracts/:id/update_description.json'
        },
        get_rider: {
          url: '/api/contracts/:id/get_rider'
        },
        add_rider: {
          url: '/api/contracts/:id/add_rider',
          method: 'POST'
        },
        remove_last_rider: {
          url: '/api/contracts/:id/remove_last_rider',
          method: 'DELETE'
        },
        add_notification: {
          url: '/api/contracts/:id/add_notification',
          method: 'POST'
        },
        remove_notification: {
          url: '/api/contracts/:id/remove_notification',
          method: 'DELETE'
        },
        remove_file: {
          url: '/api/contracts/:id/remove_file',
          method: 'DELETE'
        },
        affiliates_not_in_contract: {
          url: '/api/contracts/:id/affiliates_not_in_contract',
          isArray: true
        },
        add_affiliate: {
          url: '/api/contracts/:id/add_affiliate',
          method: 'POST'
        },
        remove_affiliate: {
          url: '/api/contracts/:id/remove_affiliate',
          method: 'DELETE'
        },
        cancel_contract: {
          url: '/api/contracts/:id/cancel_contract',
          method: 'POST'
        },
        add_riders_block: {
          url: '/api/contracts/add_riders_block.json',
          method: 'POST'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ContractTypesController', function($timeout, webDevTec, toastr, ContractType, $scope, $auth, $state, $uibModal) {
    var ModalInstanceContractCtrl;
    $scope.new_contract_type = {};
    $scope.contract_types = [];
    $scope.all_types = {
      free: 'Livre',
      group: 'Compartilhado',
      single: 'Individual com taxa',
      single_free: 'Individual livre'
    };
    $scope.getContracts = function() {
      return ContractType.query({}, function(data) {
        return $scope.contract_types = data;
      });
    };
    $scope.getContracts();
    $scope.addContractType = function() {
      return ContractType.save({
        contract_type: $scope.new_contract_type
      }, (function(data) {
        $scope.new_contract_type = {};
        toastr.info('Tipo de contrato adicionado');
        return $scope.contract_types.push(data);
      }), function(error) {
        $scope.showError(error);
      });
    };
    $scope.editContract = function(contract_type) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/contract_types/modalEdit.html',
        controller: ModalInstanceContractCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          contract_type: angular.copy(contract_type)
        }
      });
    };
    ModalInstanceContractCtrl = function($scope, $uibModalInstance, contract_type) {
      $scope.new_contract_type = contract_type;
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      return $scope.saveContract = function() {
        return ContractType.update({
          id: $scope.new_contract_type.id,
          contract_type: $scope.new_contract_type
        }, (function(data) {
          $scope.getContracts();
          $scope.ok();
          return $scope.new_contract_type = {};
        }), function(error) {
          $scope.showError(error);
        });
      };
    };
    return $scope.deleteContractType = function(index, type_id) {
      return ContractType["delete"]({
        id: type_id
      }, (function(data) {
        $scope.new_contract_type = {};
        toastr.error('Tipo de contrato removido');
        return $scope.contract_types.splice(index, 1);
      }), function(error) {
        $scope.showError(error);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('ContractType', [
    '$resource', function($resource) {
      return $resource('/api/contract_types/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/contract_types/:id.json',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('Organization', [
    '$resource', function($resource) {
      return $resource('/api/organizations/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/organizations/:id',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('ConfigurationController', function($timeout, webDevTec, toastr, Client, $scope, $auth, $state) {
    return $scope.LogOut = function() {
      return $auth.signOut().then(function(resp) {
        $state.go("login");
      })["catch"](function(resp) {
        console.log(resp);
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('ClientsController', function($timeout, webDevTec, toastr, Client, $scope, $auth, $state, $uibModal) {
    var ModalInstanceCtrl;
    $scope.clients = [];
    $scope.totalItems = 0;
    $scope.pagination = {
      page: 1,
      is_last_page: true
    };
    $scope.load_clients = true;
    $scope.total_clients = '';
    $scope.client_active = true;
    $scope.client_inactive = true;
    $scope.last_field_order = '';
    $scope.direction = '';
    $scope.orderBy = function(field) {
      if ($scope.last_field_order !== field) {
        $scope.last_field_order = field;
        $scope.direction = 'asc';
      } else {
        if ($scope.direction === 'asc') {
          $scope.direction = 'desc';
        } else {
          $scope.direction = 'asc';
        }
      }
      return Client.get({
        reorder_field: field,
        direction: $scope.direction,
        page: $scope.pagination.page,
        search: $scope.search,
        client_active: $scope.client_active,
        client_inactive: $scope.client_inactive
      }, (function(data) {
        $scope.clients = data.clients;
        $scope.load_clients = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      }), function(error) {
        $scope.showError(error);
        return $scope.load_clients = false;
      });
    };
    Client.get({
      page: $scope.pagination.page,
      search: $scope.search
    }, function(data) {
      $scope.clients = data.clients;
      $scope.load_clients = false;
      $scope.pagination = data.pagination;
      return $scope.totalItems = data.pagination.total_items;
    });
    $scope.searchClient = function() {
      return Client.get({
        reorder_field: $scope.last_field_order,
        direction: $scope.direction,
        page: $scope.pagination.page,
        search: $scope.search,
        client_active: $scope.client_active,
        client_inactive: $scope.client_inactive
      }, function(data) {
        $scope.clients = data.clients;
        $scope.load_clients = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.pageChanged = function() {
      return Client.get({
        reorder_field: $scope.last_field_order,
        direction: $scope.direction,
        page: $scope.pagination.page,
        search: $scope.search,
        client_active: $scope.client_active,
        client_inactive: $scope.client_inactive
      }, function(data) {
        $scope.clients = data.clients;
        $scope.load_clients = false;
        $scope.pagination = data.pagination;
        return $scope.totalItems = data.pagination.total_items;
      });
    };
    $scope.viewby = 20;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 20;
    $scope.setPage = function(pageNo) {
      $scope.currentPage = pageNo;
    };
    $scope.setItemsPerPage = function(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1;
    };
    $scope.toggleActive = function(client_id, index) {
      return Client.toggle_active({
        id: client_id
      }, (function(data) {}), function(error) {
        $scope.showError(error);
        return $scope.clients[index].active = !$scope.clients[index].active;
      });
    };
    $scope.archiveModal = function(client, index) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/clients/archive_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        resolve: {
          client: client,
          index: index
        },
        size: 'md'
      });
      return modalInstance;
    };
    return ModalInstanceCtrl = function($scope, $uibModalInstance, Client, client, index) {
      $scope.archive = function(client_id, index, reason) {
        return Client.archive({
          id: client_id,
          cancel_reason: $scope.cancel_reason
        }, (function(data) {
          return $scope.clients.splice(index, 1);
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.ok = function() {
        $scope.archive(client.id, index);
        $uibModalInstance.close();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
        $state.go('clients');
      };
    };
  }).controller('ClientsNewController', function($timeout, webDevTec, toastr, User, Client, Cep, $scope, $auth, $state, FileUploader, $uibModal) {
    var ModalInstanceCtrl, disabled;
    $scope.step = 1;
    $scope.client = {
      client_type: "legal",
      client_addresses_attributes: [],
      emails: [],
      phones: []
    };
    $scope.client_address = {};
    $scope.email = "";
    $scope.phone = "";
    $scope.address_type = {
      document: 'Documento',
      attendance: 'Atendimento',
      both: 'Ambos'
    };
    $scope.cpf_available = false;
    $scope.check_cpf = function() {
      return Client.check_cpf_available({
        document: $scope.client.document
      }, function(data) {
        $scope.cpf_available = data.status;
        if (!data.status) {
          return toastr.error("CPF já registrado");
        }
      });
    };
    $scope.itemArray = [
      {
        id: 1,
        name: 'first'
      }, {
        id: 2,
        name: 'second'
      }, {
        id: 3,
        name: 'third'
      }, {
        id: 4,
        name: 'fourth'
      }, {
        id: 5,
        name: 'fifth'
      }
    ];
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.client.birth_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open3 = function() {
      $scope.popup3.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.client.birth_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup3 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.client.birth_date = new Date('');
    };
    User.users_by_position({}, function(data) {
      return $scope.sellers = data.sellers;
    });
    ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      $scope.cep = {};
      $scope.client_address = {};
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.finderCep = function() {
        if (angular.isDefined($scope.client_address.cep)) {
          Cep.finder_cep({
            cep: $scope.client_address.cep
          }, function(data) {
            $scope.load_cep = true;
            $scope.client_address.city = data.city;
            $scope.client_address.neighborhood = data.neighborhood;
            return $scope.client_address.street = data.address;
          });
          return $scope.load_cep = false;
        } else {
          return toastr.error("Verifique o CEP");
        }
      };
      $scope.createCep = function() {
        $scope.client.client_addresses_attributes.push($scope.client_address);
        return $scope.ok();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };
    $scope.onFocusCep = function(cep) {
      return $scope.cep_aux = angular.copy(cep);
    };
    $scope.updateCep = function(cep, index) {
      return Cep.update({
        id: cep.id,
        cep: cep
      }, (function(data) {
        return toastr.info('CEP alterado');
      }), function(error) {
        $scope.showError(error);
        return $scope.ceps[index] = $scope.cep_aux;
      });
    };
    $scope.newCep = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/new_address_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
      return modalInstance;
    };
    $scope.addAddress = function(address) {
      $scope.client_address = {};
      $scope.client.client_addresses_attributes.push(angular.copy(address));
      return $scope.selected_cep = "";
    };
    $scope.removeAddress = function(index) {
      $scope.client.client_addresses_attributes.splice(index, 1);
    };
    $scope.addEmail = function(email) {
      if (angular.isDefined($scope.email) || $scope.email === 'defined') {
        if ($scope.email.length >= 8) {
          $scope.client.emails.push(email);
          return $scope.email = "";
        } else {
          return $scope.form.$invalid;
        }
      } else {
        return $scope.form.$invalid;
      }
    };
    $scope.removeEmail = function(index) {
      return $scope.client.emails.splice(index, 1);
    };
    $scope.addPhone = function(phone) {
      if (angular.isDefined($scope.phone) || $scope.phone === 'defined') {
        if ($scope.phone.length >= 10) {
          $scope.client.phones.push(phone);
          return $scope.phone = "";
        } else {
          toastr.error("Necessário informar DDD+Número");
          return $scope.form.$invalid;
        }
      } else {
        return $scope.form.$invalid;
      }
    };
    $scope.removePhone = function(index) {
      return $scope.client.phones.splice(index, 1);
    };
    $scope.goToStep = function(step) {
      return $scope.step = step;
    };
    return $scope.addClient = function() {
      return Client.save({
        client: $scope.client
      }, (function(data) {
        toastr.info('Cliente criado');
        return $state.go("show_client", {
          id: data.id
        });
      }), function(error) {
        return $scope.showError(error);
      });
    };
  }).controller('ClientsShowController', function($timeout, webDevTec, toastr, User, Client, Cep, ClientAddress, $scope, $auth, $state, $stateParams, $uibModal, Disease, $filter) {
    var ModalArchiveInstanceCtrl, ModalInstanceCtrl, disabled;
    $scope.client = {};
    $scope.showFindCPF = false;
    $scope.another_cliente = {};
    $scope.affiliate = {
      affiliate_address: {}
    };
    $scope.affiliate.diseases = [];
    $scope.affiliate.health_insurance = [];
    $scope.panel = 'phones';
    $scope.newPhone = "";
    $scope.newEmail = null;
    $scope.selected_cep = "";
    $scope.client_types = {
      'person': 'Pessoa Física',
      'legal': 'Pessoa Jurídica'
    };
    $scope.document_type = {
      'person': 'CPF',
      'legal': 'CNPJ'
    };
    $scope.client_address = {};
    $scope.affiliate_address = {};
    $scope.modal_type = 'affiliate';
    $scope.address_type = {
      document: 'Documento',
      attendance: 'Atendimento',
      both: 'Ambos'
    };
    $scope.dateFormat = "dd/MM/yyyy";
    $scope.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
      dateFormat: $scope.dateFormat
    };
    $scope.clear = function() {
      $scope.client.birth_date = null;
    };
    $scope.inlineOptions = {
      minDate: new Date,
      showWeeks: true
    };
    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
    $scope.toggleMin();
    $scope.open3 = function() {
      $scope.popup3.opened = true;
    };
    $scope.setDate = function(year, month, day) {
      $scope.client.birth_date = new Date(year, month, day);
    };
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.popup3 = {
      opened: false
    };
    disabled = function(data) {
      var date, mode;
      date = data.date;
      mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };
    $scope.today = function() {
      $scope.client.birth_date = new Date('');
    };
    Client.get({
      id: $stateParams.id
    }, function(data) {
      var date, foundItem, index;
      $scope.client = data.client;
      if (data.client.birth_date) {
        date = new Date(data.client.birth_date);
        $scope.client.birth_date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
      }
      $scope.client.client_addresses = data.client_addresses;
      $scope.client.affiliates = data.affiliates;
      if ($stateParams.tab && $stateParams.affiliate && !$stateParams.reopen_modal) {
        $scope.panel = 'affiliate';
        foundItem = $filter('filter')($scope.client.affiliates, {
          cpf: $stateParams.affiliate.cpf
        }, true)[0];
        index = $scope.client.affiliates.indexOf(foundItem);
        $scope.editAffiliate($scope.client.affiliates[index], index, $stateParams.client_id);
      }
      if ($stateParams.tab && $stateParams.affiliate && $stateParams.reopen_modal) {
        $scope.panel = 'affiliate';
        $scope.affiliate = $stateParams.affiliate;
        $scope.affiliate.has_duplicate_cpf = true;
        $scope.affiliate.membership_card = null;
        return Client.add_affiliate({
          id: $scope.client.id,
          affiliate: $scope.affiliate,
          diseases_ids: $scope.affiliate.diseases
        }, (function(data) {
          if (data.active) {
            $scope.affiliate.status_description = "ATIVO";
          } else {
            $scope.affiliate.status_description = "INATIVO";
          }
          $scope.affiliate.id = data.id;
          $scope.affiliate.active = data.active;
          $scope.pushAffiliateScope($scope.affiliate);
          toastr.info('Filiado criado com sucesso');
          $scope.affiliate.active = false;
          return $scope.ok();
        }), function(error) {
          return $scope.showError(error);
        });
      }
    });
    User.users_by_position({}, function(data) {
      return $scope.sellers = data.sellers;
    });
    $scope.last_field_order = '';
    $scope.direction = '';
    $scope.toggleActive = function(client_id, index) {
      return Client.toggle_active({
        id: client_id
      }, (function(data) {}), function(error) {
        $scope.showError(error);
        return $scope.client.active = !$scope.client.active;
      });
    };
    $scope.updateClient = function() {
      return Client.update({
        id: $stateParams.id,
        client: $scope.client
      }, (function(data) {
        return toastr.info('Cliente Atualizado');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.removePhone = function(index) {
      $scope.client.phones.splice(index, 1);
      $scope.updateClient();
    };
    $scope.removeEmail = function(index) {
      $scope.client.emails.splice(index, 1);
      $scope.updateClient();
    };
    $scope.addPhone = function(phone) {
      if (angular.isDefined($scope.newPhone) || $scope.newPhone === 'defined') {
        if ($scope.newPhone.length >= 10) {
          $scope.client.phones.push(phone);
          $scope.updateClient();
          return $scope.newPhone = "";
        } else {
          toastr.error("Necessário informar DDD+Número");
          return $scope.form.newPhone.$invalid;
        }
      } else {
        return $scope.form.newPhone.$invalid;
      }
    };
    $scope.addEmail = function(email) {
      if (!$scope.client.emails) {
        $scope.client.emails = [];
      }
      if (angular.isDefined($scope.newEmail) || $scope.newEmail === 'defined') {
        if ($scope.newEmail.length >= 8) {
          $scope.client.emails.push(email);
          $scope.updateClient();
          $scope.newEmail = "";
        } else {
          $scope.form.newEmail.$invalid;
        }
      } else {
        $scope.form.newEmail.$invalid;
      }
    };
    $scope.newCep = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/new_address_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: void 0
        }
      });
      return modalInstance;
    };
    $scope.editAddress = function(address) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/clients/new_address_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: angular.copy(address)
        }
      });
    };
    $scope.removeAddress = function(id, index) {
      ClientAddress["delete"]({
        id: id
      }, (function(data) {
        return $scope.client.client_addresses.splice(index, 1);
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.getHolders = function() {
      return Client.get_holders({
        id: $scope.client.id
      }, function(data) {
        return $scope.holders = data;
      });
    };
    $scope.AffiliateModal = function() {
      var modalInstance;
      $scope.modal_type = 'affiliate';
      $scope.holders = [];
      $scope.getHolders();
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/clients/new_affiliate.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'lg',
        resolve: {
          address: void 0
        }
      });
      return modalInstance;
    };
    $scope.editAffiliate = function(affiliate, index, client_id) {
      $scope.client_id = client_id;
      $scope.affiliate = angular.copy(affiliate);
      $scope.affiliate_index = index;
      $scope.affiliate.birth_date = new Date($scope.affiliate.birth_date);
      $scope.affiliate.birth_date.setMinutes($scope.affiliate.birth_date.getMinutes() + $scope.affiliate.birth_date.getTimezoneOffset());
      $scope.affiliate.created_at = new Date($scope.affiliate.created_at);
      return $scope.AffiliateModal();
    };
    $scope.newAffiliate = function() {
      $scope.affiliate = {};
      $scope.affiliate = {
        phones: [],
        active: true,
        created_at: new Date(),
        affiliate_address: {},
        phones: {}
      };
      $scope.formatAddress($scope.affiliate);
      return $scope.AffiliateModal();
    };
    $scope.createAffiliateAddressModal = function() {
      var modalInstance;
      $scope.load_cep = true;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/new_address_affiliate_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: void 0
        }
      });
      return modalInstance;
    };
    $scope.openModalAction = function(affiliate) {
      var modalInstance;
      $scope.another_affiliate = affiliate;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/new_affiliate_actions_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: void 0
        }
      });
      return modalInstance;
    };
    $scope.openHasDuplicateCpf = function(affiliate) {
      var modalInstance;
      $scope.duplicate_affiliate = affiliate;
      return modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/open_has_duplicate_cpf_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: void 0
        }
      });
    };
    $scope.openHasDuplicateCpfAnotherClient = function(affiliate, anotherClient, status) {
      var modalInstance;
      $scope.duplicate_affiliate = affiliate;
      $scope.another_cliente = anotherClient;
      $scope.affiliate_is_active = status;
      return modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/clients/open_has_duplicate_cpf_another_client_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {
          address: void 0
        }
      });
    };
    $scope.formatAddress = function(affiliate) {
      var address;
      if ($scope.client.client_addresses.length > 0) {
        address = $scope.client.client_addresses[0];
        $scope.affiliate.affiliate_address.street = address.street;
        $scope.affiliate.affiliate_address.number = address.number;
        $scope.affiliate.affiliate_address.cep = address.cep;
        $scope.affiliate.affiliate_address.neighborhood = address.neighborhood;
        $scope.affiliate.affiliate_address.city = address.city;
        if (address.complement) {
          $scope.affiliate.affiliate_address.complement = address.complement;
        }
        if (address.landmark) {
          $scope.affiliate.affiliate_address.landmark = address.landmark;
        }
      }
    };
    $scope.getAffiliates = function(field) {
      if ($scope.last_field_order !== field) {
        $scope.last_field_order = field;
        $scope.direction = 'asc';
      } else {
        if ($scope.direction === 'asc') {
          $scope.direction = 'desc';
        } else {
          $scope.direction = 'asc';
        }
      }
      return Client.get_affiliates({
        id: $scope.client.id,
        reorder_field: field,
        direction: $scope.direction
      }, (function(data) {
        return $scope.client.affiliates = data;
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.clearHolder = function(affiliate) {
      if (!affiliate.dependent) {
        return $scope.affiliate.holder_id = null;
      }
    };
    $scope.pushAffiliateScope = function(affiliate) {
      if (affiliate) {
        return $scope.client.affiliates.push(affiliate);
      }
    };
    $scope.updateAffiliateScope = function(affiliate, index) {
      if (affiliate) {
        return $scope.client.affiliates[index] = affiliate;
      }
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, $uibModalStack, Cep, Disease, address, ClientAddress, HealthPlan, AffiliateAddress) {
      $scope.client_address = address;
      $scope.new_address_modal = {};
      $scope.affiliate_emails = [];
      if (address !== void 0) {
        $scope.load_cep = true;
      }
      Disease.reload_diseases({}, function(data) {
        return $scope.diseases = data;
      });
      $scope.splitValues = function(values) {
        if (values) {
          return values.split(',');
        }
      };
      if ($scope.affiliate.id) {
        if ($scope.affiliate.email) {
          $.each($scope.splitValues($scope.affiliate.email), function(index, value) {
            return $scope.affiliate_emails.push({
              text: value
            });
          });
        }
      } else {
        if (angular.isDefined($scope.client.emails)) {
          $scope.affiliate_emails = [];
          if ($scope.client.emails) {
            $.each($scope.client.emails, function(index, value) {
              return $scope.affiliate_emails.push({
                text: value
              });
            });
          }
        }
      }
      $scope.updateAffiliateAggravate = function() {
        var aggravates;
        aggravates = $scope.affiliate_aggravates.map(function(row) {
          return row.text;
        });
        return $scope.affiliate.aggravate = aggravates.join(",");
      };
      $scope.updateAffiliateEmails = function() {
        var emails;
        if ($scope.affiliate_emails.length > 0) {
          emails = $scope.affiliate_emails.map(function(row) {
            return row.text;
          });
          return $scope.affiliate.email = emails.join(",");
        }
      };
      if (!$scope.affiliate.id) {
        if (angular.isDefined($scope.client.phones)) {
          $scope.affiliate.phones = angular.copy($scope.client.phones);
        }
      }
      $scope.getAffiliateCep = function() {
        if (angular.isDefined($scope.affiliate.affiliate_address.cep)) {
          Cep.finder_cep({
            cep: $scope.affiliate.affiliate_address.cep
          }, function(data) {
            $scope.load_cep = true;
            $scope.affiliate.affiliate_address.city = data.city;
            $scope.affiliate.affiliate_address.neighborhood = data.neighborhood;
            return $scope.affiliate.affiliate_address.street = data.address;
          });
          return $scope.load_cep = true;
        } else {
          return toastr.error("Verifique o CEP");
        }
      };
      $scope.finderCep = function() {
        if (angular.isDefined($scope.client_address.cep)) {
          Cep.finder_cep({
            cep: $scope.client_address.cep
          }, function(data) {
            $scope.load_cep = true;
            $scope.client_address.city = data.city;
            $scope.client_address.neighborhood = data.neighborhood;
            return $scope.client_address.street = data.address;
          });
          return $scope.load_cep = true;
        } else {
          return toastr.error("Verifique o CEP");
        }
      };
      $scope.getAddress = function() {
        return ClientAddress.query({}, function(data) {
          return $scope.client_addresses = data.client_addresses;
        });
      };
      $scope.getAddress();
      $scope.health_plans = [];
      HealthPlan.get_health_plans({}, function(data) {
        return $scope.health_plans = data;
      });
      $scope.editDuplicateAffiliate = function(data) {
        $scope.affiliate.name = data.name;
        $scope.affiliate.id = data.id;
        $scope.affiliate.active = data.active;
        $scope.affiliate.dependent = data.dependent;
        $scope.affiliate.birth_date = new Date(data.birth_date);
        $scope.affiliate.created_at = new Date(data.created_at);
        $scope.affiliate.cpf = data.cpf;
        $scope.affiliate.rg = data.rg;
        $scope.affiliate.phones = data.phones;
        $scope.affiliate.email = data.email;
        $scope.affiliate.health_plan_id = data.health_plan_id;
        $scope.affiliate.membership_card = data.membership_card;
        $scope.affiliate.aggravate = data.aggravate;
        $scope.affiliate.old_id = data.old_id;
        $scope.affiliate.send_call_emails = data.send_call_emails;
        $scope.affiliate.note = data.note;
        $scope.affiliate.gender = data.gender;
        $scope.affiliate.exported = data.exported;
        $scope.affiliate.diseases = data.diseases;
        $scope.affiliate.affiliate_address = data.affiliate_address;
        $scope.affiliate.has_duplicate_cpf = true;
        return $scope.ok();
      };
      $scope.duplicateAffiliate = function(affiliate) {
        var emails;
        $scope.has_duplicate_cpf = true;
        emails = $scope.affiliate_emails.map(function(row) {
          return row.text;
        });
        $scope.affiliate.email = emails.join(",");
        affiliate.membership_card = null;
        return Client.add_affiliate({
          id: $scope.client.id,
          affiliate: affiliate,
          diseases_ids: affiliate.diseases
        }, (function(data) {
          if (data.active) {
            $scope.affiliate.status_description = "ATIVO";
          } else {
            $scope.affiliate.status_description = "INATIVO";
          }
          $scope.affiliate.name = data.name;
          $scope.affiliate.birth_date = data.birth_date;
          $scope.affiliate.membership_card = data.membership_card;
          $scope.affiliate.id = data.id;
          $scope.affiliate.active = data.active;
          $scope.affiliate.gender = data.gender;
          $scope.affiliate.phones = data.phones;
          $scope.affiliate.affiliate_address = data.affiliate_address;
          $scope.affiliate.email = data.email;
          $scope.affiliate.health_plan_id = data.health_plan_id;
          $scope.affiliate.note = data.note;
          $scope.affiliate.diseases = affiliate.diseases;
          $scope.pushAffiliateScope($scope.affiliate);
          toastr.info('Filiado criado com sucesso');
          return $uibModalStack.dismissAll();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.getAffiliateByCPF = function() {
        if ($scope.affiliate.cpf && !$scope.affiliate.id) {
          $scope.showFindCPF = false;
          return Client.get_affiliate_by_cpf({
            id: $stateParams.id,
            cpf: $scope.affiliate.cpf
          }, (function(data) {
            if (data.name) {
              if (data.client_id === parseInt($stateParams.id)) {
                $scope.has_duplicate_cpf = true;
                return $scope.openHasDuplicateCpf(data);
              } else {
                $scope.affiliate_is_active = data.active;
                $scope.affiliate = {
                  name: data.name,
                  id: null,
                  active: true,
                  dependent: data.dependent,
                  birth_date: new Date(data.birth_date),
                  created_at: new Date(data.created_at),
                  cpf: data.cpf,
                  rg: data.rg,
                  phones: data.phones,
                  email: data.email,
                  health_plan_id: data.health_plan_id,
                  membership_card: data.membership_card,
                  aggravate: data.aggravate,
                  old_id: data.old_id,
                  send_call_emails: data.send_call_emails,
                  note: data.note,
                  gender: data.gender,
                  exported: data.exported,
                  diseases: data.diseases,
                  affiliate_address: data.affiliate_address,
                  has_duplicate_cpf: true
                };
                $scope.showFindCPF = true;
                $scope.has_duplicate_cpf = true;
                $scope.another_cliente = data.client;
                return $scope.openHasDuplicateCpfAnotherClient($scope.affiliate, $scope.another_cliente, $scope.affiliate_is_active);
              }
            }
          }), function(error) {
            $scope.showError(error);
            return $scope.showFindCPF = false;
          });
        }
      };
      $scope.createAffiliateAddress = function() {
        if (!$scope.affiliate.affiliate_address.id) {
          $scope.affiliate.affiliate_address.affiliate_id = $scope.affiliate.id;
          return AffiliateAddress.save({
            affiliate_address: $scope.affiliate.affiliate_address
          }, (function(data) {
            toastr.info('Endereço Salvo');
            return $scope.ok();
          }), function(error) {
            return $scope.showError(error);
          });
        } else {
          return AffiliateAddress.update({
            id: $scope.affiliate.affiliate_address.id,
            affiliate_address: $scope.affiliate.affiliate_address
          }, (function(data) {
            toastr.info('Endereço Salvo');
            return $scope.ok();
          }), function(error) {
            return $scope.showError(error);
          });
        }
      };
      $scope.createCep = function() {
        if (!$scope.client_address.id) {
          $scope.client_address.client_id = $stateParams.id;
          return ClientAddress.save({
            client_address: $scope.client_address
          }, (function(data) {
            $scope.client.client_addresses.push(data);
            toastr.info('Endereço Salvo');
            return $scope.ok();
          }), function(error) {
            return $scope.showError(error);
          });
        } else {
          $scope.client_address.client_id = $stateParams.id;
          return ClientAddress.update({
            id: $scope.client_address.id,
            client_address: $scope.client_address
          }, (function(data) {
            Client.get_addresses({
              id: $scope.client.id
            }, function(data) {
              return $scope.client.client_addresses = data;
            });
            $scope.getAddress();
            toastr.info('Endereço Salvo');
            $scope.ok();
            return $scope.client_addresses = {};
          }), function(error) {
            return $scope.showError(error);
          });
        }
      };
      $scope.changeAffiliateAddress = function() {
        $scope.affiliate.address = $scope.affiliate_address.street + ", " + $scope.affiliate_address.number + ", ";
        if ($scope.affiliate_address.complement) {
          $scope.affiliate.address = $scope.affiliate.address + $scope.affiliate_address.complement + ",";
        }
        if ($scope.affiliate_address.landmark) {
          $scope.affiliate.address = $scope.affiliate.address + $scope.affiliate_address.landmark + ", ";
        }
        $scope.affiliate.address = $scope.affiliate.address + $scope.affiliate_address.neighborhood + ", " + $scope.affiliate_address.city;
        return $scope.ok();
      };
      $scope.dateFormat = "dd/MM/yyyy";
      $scope.dateOptions = {
        formatYear: "yy",
        startingDay: 0,
        dateFormat: $scope.dateFormat
      };
      $scope.clear = function() {
        $scope.affiliate.birth_date = null;
      };
      $scope.inlineOptions = {
        minDate: new Date,
        showWeeks: true
      };
      $scope.toggleMin = function() {
        $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date;
        $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
      };
      $scope.toggleMin();
      $scope.open2 = function() {
        $scope.popup2.opened = true;
      };
      $scope.open1 = function() {
        $scope.popup1.opened = true;
      };
      $scope.setDate = function(year, month, day) {
        $scope.affiliate.birth_date = new Date(year, month, day);
      };
      $scope.altInputFormats = ['M!/d!/yyyy'];
      $scope.popup1 = {
        opened: false
      };
      $scope.popup2 = {
        opened: false
      };
      disabled = function(data) {
        var date, mode;
        date = data.date;
        mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
      };
      $scope.today = function() {
        $scope.affiliate.birth_date = new Date('');
      };
      $scope.ok = function() {
        $uibModalInstance.dismiss('ok');
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.addAffiliatePhone = function(phone) {
        if (angular.isDefined($scope.newPhone) || $scope.newPhone === 'defined') {
          if ($scope.newPhone.length >= 10) {
            $scope.affiliate.phones.push(phone);
            return $scope.newPhone.phone = "";
          } else {
            toastr.error("Necessário informar DDD+Número");
            return $scope.form.newPhone.$invalid;
          }
        } else {
          return $scope.form.newPhone.$invalid;
        }
      };
      $scope.removeAffiliatePhone = function(index) {
        return $scope.affiliate.phones.splice(index, 1);
      };
      $scope.createAffiliate = function() {
        var emails;
        if ($scope.affiliate_emails.length === 0) {
          $scope.affiliate.send_call_emails = false;
        }
        if ($scope.affiliate.id) {
          console.log('update');
          $scope.affiliate.has_duplicate_cpf = true;
          return Client.update_affiliate({
            id: $scope.client.id,
            affiliate: $scope.affiliate,
            diseases_ids: $scope.affiliate.diseases
          }, (function(data) {
            if (data.active) {
              $scope.affiliate.status_description = "ATIVO";
            } else {
              $scope.affiliate.status_description = "INATIVO";
            }
            $scope.affiliate.membership_card = data.membership_card;
            $scope.updateAffiliateScope($scope.affiliate, $scope.affiliate_index);
            toastr.info('Filiado alterado com sucesso');
            return $scope.ok();
          }), function(error) {
            return $scope.showError(error);
          });
        } else {
          emails = $scope.affiliate_emails.map(function(row) {
            return row.text;
          });
          $scope.affiliate.email = emails.join(",");
          return Client.add_affiliate({
            id: $scope.client.id,
            affiliate: $scope.affiliate,
            diseases_ids: $scope.affiliate.diseases
          }, (function(data) {
            if (data.active) {
              $scope.affiliate.status_description = "ATIVO";
            } else {
              $scope.affiliate.status_description = "INATIVO";
            }
            $scope.affiliate.membership_card = data.membership_card;
            $scope.affiliate.id = data.id;
            $scope.affiliate.active = data.active;
            $scope.pushAffiliateScope($scope.affiliate);
            toastr.info('Filiado criado com sucesso');
            return $scope.ok();
          }), function(error) {
            return $scope.showError(error);
          });
        }
      };
      $scope.updateAffiliatePlan = function() {
        if ($scope.affiliate.id) {
          return Client.update_affiliate({
            id: $scope.client.id,
            affiliate: $scope.affiliate,
            diseases_ids: $scope.affiliate.diseases
          }, (function(data) {
            return toastr.info('Filiado alterado com sucesso');
          }), function(error) {
            return $scope.showError(error);
          });
        }
      };
      $scope.inactivateAffiliate = function(form) {
        form.id = $scope.affiliate.id;
        form.active = false;
        form.has_duplicate_cpf = true;
        return Client.inactivate_affiliate({
          id: $scope.client.id,
          affiliate: form
        }, (function(data) {
          if ($scope.client_id) {
            return $state.go('show_client', {
              id: $scope.client_id,
              affiliate: $scope.affiliate,
              tab: 'affiliateTab',
              reopen_modal: true
            });
          } else {
            $scope.getAffiliates();
            toastr.info('Filiado inativado');
            return $scope.ok();
          }
        }), function(error) {
          return $scope.showError(error);
        });
      };
      return $scope.activateAffiliate = function() {
        return Client.activate_affiliate({
          id: $scope.client.id,
          affiliate_id: $scope.affiliate.id,
          cpf: $scope.affiliate.cpf
        }, (function(data) {
          if (data.name) {
            $scope.getAffiliates();
            toastr.info('Filiado ativado');
          } else {
            toastr.error('Não foi possível ativar o filiado, pois já existe um filiado com esse CPF ativo.');
          }
          return $scope.ok();
        }), function(error) {
          return $scope.showError(error);
        });
      };
    };
    $scope.setModalType = function(type) {
      $scope.modal_type = type;
    };
    $scope.affiliateArchiveModal = function(affiliate, index) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/clients/affiliate_archive_modal.html',
        controller: ModalArchiveInstanceCtrl,
        scope: $scope,
        resolve: {
          affiliate: affiliate,
          index: index
        },
        size: 'md'
      });
      return modalInstance;
    };
    return ModalArchiveInstanceCtrl = function($scope, $uibModalInstance, Client, affiliate, index) {
      $scope.affiliateArchive = function() {
        return Client.affiliate_archive({
          id: affiliate.client_id,
          affiliate_id: affiliate.id
        }, (function(data) {
          $scope.client.affiliates.splice(index, 1);
          return toastr.info('Filiado removido com sucesso!');
        }), function(error) {
          return toastr.error('Não é possível remover um filiado com chamadas em seu nome!');
        });
      };
      $scope.ok = function() {
        $scope.affiliateArchive();
        $uibModalInstance.close();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('ClientAddress', [
    '$resource', function($resource) {
      return $resource('/api/client_addresses/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/client_addresses/:id.json',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('Client', [
    '$resource', function($resource) {
      return $resource('/api/clients/:id', {
        id: '@id'
      }, {
        toggle_active: {
          url: '/api/clients/:id/toggle_active.json',
          method: 'PUT'
        },
        affiliate_archive: {
          url: '/api/clients/:id/affiliate_archive.json',
          method: 'PUT'
        },
        archive_revive: {
          url: '/api/clients/:id/archive_revive.json',
          method: 'PUT'
        },
        archive: {
          url: '/api/clients/:id/archive.json',
          method: 'PUT'
        },
        get_holders: {
          url: '/api/clients/:id/get_holders.json',
          isArray: true
        },
        add_affiliate: {
          url: '/api/clients/:id/add_affiliate.json',
          method: 'POST'
        },
        update: {
          url: '/api/clients/:id.json',
          method: 'PUT'
        },
        get_affiliate_by_cpf: {
          url: '/api/clients/:id/get_affiliate_by_cpf.json'
        },
        get_affiliates: {
          url: '/api/clients/:id/get_affiliates.json',
          isArray: true
        },
        update_affiliate: {
          url: '/api/clients/:id/update_affiliate.json',
          method: 'PUT'
        },
        inactivate_affiliate: {
          url: '/api/clients/:id/inactivate_affiliate.json',
          method: 'PUT'
        },
        activate_affiliate: {
          url: '/api/clients/:id/activate_affiliate.json',
          method: 'PUT'
        },
        reload_affiliate: {
          url: '/api/clients/reload_affiliates.json',
          isArray: true
        },
        load_affiliates: {
          url: '/api/clients/load_affiliates.json',
          isArray: true
        },
        reload_client: {
          url: '/api/clients/reload_clients.json',
          isArray: true
        },
        reload_archive: {
          url: '/api/clients/reload_archive.json',
          isArray: true
        },
        check_cpf_available: {
          url: '/api/clients/check_cpf_available.json',
          method: 'GET'
        },
        get_addresses: {
          url: '/api/clients/:id/get_addresses.json',
          method: 'GET',
          isArray: true
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('AffiliateAddress', [
    '$resource', function($resource) {
      return $resource('/api/affiliate_addresses/:id', {
        id: '@id'
      }, {
        update: {
          url: '/api/affiliate_addresses/:id.json',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {


}).call(this);



(function() {
  angular.module('miniGrid', ["ui.bootstrap"]).directive('miniGrid', function() {
    return {
      restrict: 'E',
      scope: {
        columns: "=?",
        groupField: "=?",
        orderField: "=?",
        reverse: "=?",
        data: "=?",
        onSetVisible: "&",
        onGroup: "&",
        onOrderField: "&",
        onRowClick: "&",
        urlPrefix: "=?",
        canSelect: "=?",
        idField: "=?",
        openNewTab: "=?",
        visibleRows: "=?"
      },
      controller: function($scope, $filter, $parse, $location, $window, $cookies) {
        $scope.filterPlaceholder = "Filtrar";
        $scope.all_check = false;
        $scope.$watch('$scope.columns', function(preferences) {
          if ($scope.columns.length > 0) {
            return $scope.visible_columns = $filter('filter')($scope.columns, {
              visible: true
            });
          }
        });
        if (!angular.isDefined($scope.openNewTab)) {
          $scope.openNewTab = false;
        }
        if (!$scope.idField) {
          $scope.idField = "id";
        }
        if (!angular.isDefined($scope.visibleRows)) {
          $scope.visibleRows = {};
        }
        if (!$scope.urlId) {
          $scope.urlId = "id";
        }
        $scope.setVisible = function(selected, visible) {
          if (selected) {
            selected.visible = visible;
            if (visible) {
              $scope.visible_columns.push(selected);
            }
            if (!visible) {
              $scope.visible_columns.splice($scope.visible_columns.indexOf(selected), 1);
              $scope.selected = "";
            }
            if (!($scope.onSetVisible === void 0)) {
              return $scope.onSetVisible({
                visible_columns: $scope.visible_columns
              });
            }
          }
        };
        $scope.setRowsVisible = function(field) {
          var visible;
          visible = 'true' === $cookies.get(field);
          $scope.visibleRows[field] = !visible;
          return $cookies.put(field, $scope.visibleRows[field]);
        };
        $scope.rowsIsVisible = function(field) {
          return $scope.visibleRows[field] === true || $cookies.get(field) === 'true';
        };
        $scope.visibleLength = function() {
          return $scope.visible_columns.length;
        };
        $scope.setGroup = function(selected_field) {
          if (!($scope.onGroup === void 0)) {
            return $scope.onGroup({
              group: $scope.groupField
            });
          }
        };
        $scope.displayFormatTooltip = function(column, row) {
          if (column.display_format_tooltip) {
            return $filter(column.display_format_tooltip)(row[column.id], column.display_arguments_tooltip);
          } else {
            return row[column.id];
          }
        };
        $scope.displayWithFormat = function(display_format, display_arguments, row, column_id, func) {
          var args, format;
          format = display_format;
          args = display_arguments;
          if (angular.isDefined(func)) {
            return func(row, column_id);
          } else {
            if (display_format) {
              return $filter(format)(row[column_id], args);
            } else {
              if (row[column_id]) {
                if (row[column_id].length > 0) {
                  return row[column_id].substring(0, 30).toString();
                } else {
                  return row[column_id].toString();
                }
              } else {
                return row[column_id];
              }
            }
          }
        };
        $scope.goToLink = function(id, event) {
          if (!angular.isDefined($scope.urlPrefix)) {
            $scope.onRowClick({
              id: id
            });
          } else {
            if (event.ctrlKey || $scope.openNewTab) {
              $window.open("#" + $scope.urlPrefix + id, '_blank');
            } else {
              $location.path($scope.urlPrefix + id);
            }
          }
          return true;
        };
        $scope.displayGroupWithFormat = function(field) {
          var formats;
          if (angular.isUndefined(field) || field === 'undefined' || field === 'null') {
            return 'Sem nome';
          } else {
            formats = $filter('filter')($scope.columns, {
              id: $scope.groupField
            })[0];
            if (formats.display_format) {
              return $filter(formats.display_format)(field, formats.display_arguments);
            } else {
              return field;
            }
          }
        };
        $scope.orderBy = function(column) {
          $scope.reverse = $scope.orderField === column.id ? !$scope.reverse : false;
          $scope.orderField = column.id;
          if (!($scope.onOrderField === void 0)) {
            return $scope.onOrderField({
              field: $scope.orderField,
              reverse: $scope.reverse
            });
          }
        };
        $scope.onDropFn = function(to, from) {
          var aux;
          if ($scope.canSelect) {
            to = to - 1;
            from = from - 1;
          }
          aux = $scope.visible_columns[to];
          $scope.visible_columns[to] = $scope.visible_columns[from];
          $scope.visible_columns[from] = aux;
          $scope.$apply();
          return $scope.onSetVisible({
            visible_columns: $scope.visible_columns
          });
        };
        $scope.setCustomCss = function(row, column) {
          var customCss;
          customCss = {};
          if (column.use_custom_css) {
            customCss = row[column.custom_css_field];
          }
          return customCss;
        };
        $scope.checkAll = function(value) {
          var i, results;
          i = 0;
          results = [];
          while (i < $scope.data.length) {
            $scope.data[i].checked = value;
            results.push(i++);
          }
          return results;
        };
        return $scope.hasVisible = function() {
          return $filter('filter')($scope.columns, {
            visible: true
          }).length === 0;
        };
      },
      template: '<div class="panel panel-default border-none remake boxshadow-none", ng-show="columns"> <div class="p-15px"> <div class="row"> <div class="col-lg-3 col-sm-6 form-group"> <menu class="c-input" > <label for="checkbox" class="c-input__label white-space-nowrap"> Selecione para mostrar <i class="fa fa-caret-down c-input__icon" aria-hidden="true"></i> </label> <input id="checkbox" type="checkbox" aria-hidden="true" class="c-dropdown__trigger"> <ul class="c-dropdown u-text-small"> <li ng-repeat="column in columns"> <label class="ui-checkbox blue m-r-0"> <input name="checkbox1" type="checkbox", ng-checked="column.visible", ng-model="column.visible", ng-change="setVisible(column, column.visible)"> <span class="text-black font-weight-bold">{{column.display_name}}</span> </label> </li> </ul> </menu> </div> <div class="col-lg-3 col-sm-6 form-group"> <select ng-model="groupField" placeholder="Group by field" ng-options="column.id as column.display_name for column in columns" class="form-control", ng-change="setGroup(groupField)"> <option value="">Agrupar por</option> </select> </div> <div class="col-lg-6 col-sm-12 form-group"> <input type="text" ng-model="filterByText" placeholder="{{filterPlaceholder | translate}}" class="form-control"> </div> </div> <div class="panel panel-default border-none boxshadow-none"> <div class="p-10px w-100" ng-show="hasVisible()"> <h4 class="font-weight-bold text-danger col-md-12"><i class="fa fa-hand-o-up m-r-1" aria-hidden="true"></i>Selecione ao menos uma coluna</h5> </div> <div class=""> <div class=col-md-12"> <table class="table table-hover table-responsive table-condensed mini-grid m-b-0" ng-hide="hasVisible()"> <thead> <tr class="bg-default dragdrop-it"> <th class="border-none vertical-align inherit p-l-13px" style="width: 15px" ng-if="canSelect"> <label class="ui-checkbox blue m-r-0"> <input name="checkbox1" type="checkbox" ng-change="checkAll(all_check)" ng-model="all_check"> <span class="text-black font-weight-bold"></span> </label> </th> <th class="p-10px  border-none text-black overflow-text" ng-repeat="column in visible_columns" drag-drop on-drop="onDropFn(to, from)" ng-click="orderBy(column)"> <span> <span class="name">{{column.display_name}}</span> </span> <span class="fa fa-caret-up",  data-ng-click = "!reverse"></span> <span class="fa fa-caret-down", data-ng-class" = "reverse"></span> </th> </tr> </thead> <tbody ng-if="!groupField"> <tr class="rc" ng-repeat="row in data | filter:filterByText | orderBy:orderField:reverse"> <td ng-if="canSelect" class="vertical-align inherit p-l-13px" style="width: 15px"> <label class="ui-checkbox blue"> <input name="checkbox1" type="checkbox" value="row.checked" checked="false", ng-model="row.checked"> <span></span> </label> </td> <td style="width: 0px; vertical-align: inherit" ng-repeat="column in visible_columns", ng-click="goToLink(row[idField], $event)", class="p-5px", ng-style="setCustomCss(row, column)"> <span uib-tooltip="{{displayFormatTooltip(column, row)}}" tooltip-enable="{{column.show_tooltip}}"> <p ng-bind-html="displayWithFormat(column.display_format, column.display_arguments, row, column.id, column.display_function)"></p> </span> </td> </tr> </tbody> <tbody ng-if="groupField" ng-repeat="(field,rows) in data | orderBy:groupField | filter:filterByText | groupBy:groupField"  style="border: 0px"> <tr class=" disable-select"> <td class="disable-select visible" ng-click="setRowsVisible(field)", colspan="{{visibleLength()}}"><i class="fa fa-fw", ng-class="{\'fa-plus-square\': !rowsIsVisible(field), \'fa-minus-square\': rowsIsVisible(field)}"></i> <strong class="disable-select">{{displayGroupWithFormat(field)+ " ("+rows.length+")"}}</strong> </td> </tr> <tr class="rc" ng-repeat="row in rows | orderBy:orderField:reverse", ng-show=rowsIsVisible(field)> <td ng-if="canSelect" class="vertical-align inherit p-l-13px" style="width: 15px"> <label class="ui-checkbox blue"> <input name="checkbox1" type="checkbox" value="row.checked" checked="false", ng-model="row.checked"> <span></span> </label> </td> <td ng-repeat="column in visible_columns", ng-click="goToLink(row[idField], $event)", class="p-5px", ng-style="setCustomCss(row, column)"> <span uib-tooltip="{{displayFormatTooltip(column, row)}}" tooltip-enable="{{column.show_tooltip}}"> <p ng-bind-html="displayWithFormat(column.display_format, column.display_arguments, row, column.id, column.display_function)"> </p> </span> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div>'
    };
  }).directive('resizeColumn', function() {
    return function(scope, element, attrs) {
      var grip, startOffset, th, thElm;
      th = element[0];
      thElm = void 0;
      startOffset = void 0;
      th = element[0];
      th.style.position = 'relative';
      grip = document.createElement('div');
      grip.innerHTML = '&nbsp;';
      grip.style.top = 0;
      grip.style.right = 0;
      grip.style.bottom = 0;
      grip.style.width = '5px';
      grip.style.position = 'absolute';
      grip.style.cursor = 'col-resize';
      grip.addEventListener('mousedown', function(e) {
        thElm = th;
        startOffset = th.offsetWidth - e.pageX;
      });
      th.appendChild(grip);
      th.addEventListener('mousemove', function(e) {
        if (thElm) {
          thElm.style.width = startOffset + e.pageX + 'px';
          thElm.style.minWidth = '0px';
        }
      });
      th.addEventListener('mouseup', function() {
        thElm = void 0;
      });
    };
  }).directive('dragDrop', function() {
    return {
      restrict: 'A',
      scope: {
        onDrop: "&"
      },
      controller: function() {},
      compile: function(el, attr) {
        var removeDragClass;
        removeDragClass = function(element, className) {
          var elm;
          elm = element[0].parentNode.querySelector('.' + className);
          if (!!elm) {
            elm.classList.remove(className);
          }
        };
        return function(scope, element, attrs, ctrl) {
          element.attr('draggable', true);
          element.bind('dragstart', function(e) {
            var ev;
            ctrl.target = this;
            this.classList.add('dragged');
            ev = e.originalEvent || e;
            ev.dataTransfer.setData('text', ctrl.target.cellIndex);
          });
          element.bind('dragover', function(e) {
            e.preventDefault();
          });
          element.bind('dragenter', function(e) {
            ctrl.toTarget = this;
            if (!this.classList.contains('draggedOver') && !this.classList.contains('dragged')) {
              this.classList.add('draggedOver');
            }
            e.preventDefault();
            e.stopPropagation();
          });
          element.bind('dragend', function(e) {
            if (this.classList.contains('dragged')) {
              this.classList.remove('dragged');
            }
            e.preventDefault();
          });
          element.bind('dragleave', function(e) {
            this.classList.remove('draggedOver');
          });
          element.bind('drop', function(e) {
            var currentIndex, draggedIndex, ev;
            currentIndex = ctrl.toTarget.cellIndex;
            ev = e.originalEvent || e;
            draggedIndex = parseInt(ev.dataTransfer.getData('text'), 10);
            removeDragClass(element, 'dragged');
            removeDragClass(element, 'draggedOver');
            scope.onDrop({
              to: draggedIndex,
              from: currentIndex
            });
            e.preventDefault();
          });
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('ideal').controller('CepsController', function($timeout, webDevTec, toastr, Cep, $scope, $auth, $state, $uibModal) {
    var ModalInstanceCtrl;
    $scope.ceps = [];
    $scope.getCeps = function() {
      return Cep.query({}, function(data) {
        return $scope.ceps = data;
      });
    };
    $scope.getCeps();
    $scope.removeCep = function(index, id) {
      return Cep["delete"]({
        id: id
      }, function(data) {
        return $scope.ceps.splice(index, 1);
      });
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      $scope.cep = {};
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.finderCep = function() {
        if (angular.isDefined($scope.cep.cep_number)) {
          Cep.finder_cep({
            cep: $scope.cep.cep_number
          }, function(data) {
            $scope.load_cep = true;
            $scope.cep.city = data.city;
            $scope.cep.neighborhood = data.neighborhood;
            return $scope.cep.street = data.address;
          });
          return $scope.load_cep = true;
        } else {
          return toastr.error("Verifique o CEP");
        }
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      return $scope.createCep = function() {
        return Cep.save({
          cep: $scope.cep
        }, (function(data) {
          $scope.getCeps();
          $scope.ok();
          return toastr.info('CEP salvo');
        }), function(error) {
          $scope.showError(error);
          return console.log(error);
        });
      };
    };
    return $scope.newCep = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/ceps/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
      return modalInstance;
    };
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Cep', [
    '$resource', function($resource) {
      return $resource('/api/ceps/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        },
        finder_cep: {
          url: '/api/ceps/finder_cep',
          method: 'PUT'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('CallsController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Call, User, $filter) {
    var ModalInstanceCtrl, all_fields, field, filter, i, len, table_field;
    filter = {
      is_closed: false
    };
    $scope.onSetVisible = function(columns) {
      $scope.user.preferences.columns = columns;
      return User.update_preferences({
        preferences: $scope.user.preferences
      }, (function(data) {
        return console.log('Preferences');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.textModeCalls = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/calls_text_mode.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'xl'
      });
      return modalInstance;
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, Call) {
      $scope.gender_text = {
        male: 'Masculino',
        female: 'Feminino'
      };
      $scope.shiftHourFormat = function(index) {
        return (index + 1) % 4 === 0;
      };
      $scope.diseases = {};
      $scope.get_call = function(call_id, mode) {
        return Call.calls_text_mode({
          last_id: call_id,
          mode: mode
        }, function(data) {
          if (data.id) {
            if (data.affiliate.diseases) {
              $scope.diseases = data.affiliate.diseases;
            }
            return $scope.call = data;
          }
        });
      };
      $scope.get_call(null, null);
      $scope.next = function() {
        return $scope.get_call($scope.call.id, 'next');
      };
      $scope.first = function() {
        return $scope.get_call($scope.call.id, 'first');
      };
      $scope.last = function() {
        return $scope.get_call($scope.call.id, 'last');
      };
      $scope.previous = function() {
        return $scope.get_call($scope.call.id, 'previous');
      };
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      return $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
        $state.go('calls');
      };
    };
    $scope.onGroup = function(group) {
      $scope.user.preferences.group = group;
      return User.update_preferences({
        preferences: $scope.user.preferences
      }, (function(data) {
        return console.log('Preferences');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.onOrderField = function(field, reverse) {
      $scope.user.preferences.order = field;
      $scope.user.preferences.reverse = reverse;
      return User.update_preferences({
        preferences: $scope.user.preferences
      }, (function(data) {
        return console.log('Preferences');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.onSetVisible = function(columns) {
      $scope.user.preferences.columns = columns;
      return User.update_preferences({
        preferences: $scope.user.preferences
      }, (function(data) {
        return console.log('Preferences');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    all_fields = [
      {
        display_name: 'ID',
        id: 'id'
      }, {
        display_name: 'Abertura',
        id: 'created_at'
      }, {
        display_name: 'Filiado',
        id: 'affiliate_name'
      }, {
        display_name: 'Cliente',
        id: 'client_name'
      }, {
        display_name: 'Código de atendimento',
        id: 'attendance_code_title'
      }, {
        display_name: 'Observação',
        id: 'affiliate_note'
      }, {
        display_name: 'QRL',
        id: 'qrl_name'
      }, {
        display_name: 'QNI',
        id: 'qni'
      }, {
        display_name: 'Plano de Saúde',
        id: 'affiliate_health_plan'
      }, {
        display_name: 'Situação',
        id: 'status_description'
      }
    ];
    $scope.calls = [];
    $scope.table_fields = $scope.user.preferences.columns;
    if (!$scope.table_fields) {
      $scope.table_fields = [];
    }
    for (i = 0, len = all_fields.length; i < len; i++) {
      table_field = all_fields[i];
      if (!$filter('filter')($scope.table_fields, {
        "id": table_field.id
      })[0]) {
        field = table_field;
        if (field.id === 'created_at') {
          field.display_format = "date";
          field.display_arguments = "dd/MM/yyyy HH:mm";
        }
        if (field.id === 'attendance_code_title') {
          field.use_custom_css = true;
          field.custom_css_field = 'attendance_color';
        }
        $scope.table_fields.push(field);
      }
    }
    $scope.getLastAnswerClass = function(row, column_id) {
      var icon;
      icon = "";
      if (row.last_answer === "technical_answer") {
        icon = "<i class='fa fa-exclamation-circle text-warning'></i>";
      }
      if (row.last_answer === "client_answer") {
        icon = "<i class='fa fa-exclamation-triangle text-danger'></i>";
      }
      return icon;
    };
    return Call.query(filter, function(data) {
      return $scope.calls = data;
    });
  }).controller('CallsNewController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Client, AttendanceCode, Call, $filter) {
    var ModalInstanceCtrl;
    $scope.affiliates = [];
    $scope.loadingAffiliate = false;
    $scope.attendance_codes = [];
    $scope.last_calls = [];
    $scope.new_phone = null;
    $scope.call = {
      phones: [],
      operator_id: $scope.user.id
    };
    $scope.pagination = {
      page: 1,
      is_last_page: true
    };
    $scope.first_phone = null;
    $scope.form_erros = false;
    $scope.gender_type = {
      male: 'Masculino',
      female: 'Feminino'
    };
    $scope.sortableOptions = {
      cancel: ".unsortable",
      items: "li:not(.unsortable)",
      update: function(e, ui) {
        if (ui.item.sortable.first_stage) {
          ui.item.sortable.cancel();
        }
      }
    };
    AttendanceCode.get({}, function(data) {
      $scope.attendance_codes = data.attendance_codes;
      if (data.default_code) {
        return $scope.call.attendance_code_id = data.default_code.id;
      }
    });
    $scope.client_inactive = false;
    $scope.loadAffiliates = function(search) {
      if (search.length > 2) {
        $scope.loadingAffiliate = true;
        return Client.reload_affiliate({
          search: search,
          client_inactive: $scope.client_inactive
        }, function(data) {
          $scope.affiliates = data;
          return $scope.loadingAffiliate = false;
        });
      }
    };
    $scope.phoneModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/phones_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      modalInstance.result.then((function() {}), function() {
        if (angular.isDefined($scope.call.phones)) {
          if ($scope.call.phones.length === 0) {
            $scope.first_phone = null;
          } else {
            $scope.first_phone = $scope.call.phones[0];
          }
        }
      });
    };
    $scope.inactiveClientModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/inactive_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      return modalInstance;
    };
    $scope.setAddressValue = function(address) {
      return $scope.call.address = address;
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance) {
      $scope.searchingAddress = false;
      $scope.call_address = {};
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.addPhone = function() {
        if ($scope.call.affiliate_id) {
          if (angular.isDefined($scope.new_phone) && $scope.new_phone !== null) {
            if ($scope.new_phone.length >= 10) {
              $scope.call.phones.push($scope.new_phone);
              $scope.new_phone = null;
            } else {
              return toastr.error("Necessário informar DDD+Número");
            }
          }
        } else {
          return toastr.error("Filiado não informado");
        }
      };
      $scope.removePhone = function(index) {
        $scope.call.phones.splice(index, 1);
      };
      return $scope.searchAddress = function() {
        $scope.searchingAddress = true;
        return Call.search_address($scope.call_address, function(data) {
          $scope.searchingAddress = false;
          $scope.setAddressValue(data.formatted_address);
          if (!data.formatted_address) {
            return toastr.error('Nenhum endereço encontrado para o filtro informado');
          } else {
            return $scope.ok();
          }
        });
      };
    };
    $scope.reloadCall = function() {
      return Call.get({
        id: $stateParams.id
      }, function(data) {
        $scope.call = data.call;
        return $scope.affiliate = data.affiliate;
      });
    };
    $scope.diseases = {};
    $scope.getAffiliateValues = function(affiliate) {
      $scope.diseases = affiliate.diseases;
      $scope.call.affiliate_health_plan = affiliate.affiliate_health_plan;
      $scope.call.affiliate_id = affiliate.id;
      $scope.call.aggravate = affiliate.aggravate;
      $scope.call.note = affiliate.note;
      $scope.call.gender = affiliate.gender;
      $scope.call.phones = affiliate.phones;
      if (affiliate.phones[0]) {
        $scope.first_phone = affiliate.phones[0].replace(/\D+/g, '');
      }
      $scope.call.client_id = affiliate.client_id;
      $scope.call.client_name = affiliate.client_name;
      if (affiliate.affiliate_address) {
        $scope.call.address = "";
        $scope.call.address = ((affiliate.affiliate_address.street || "") + ", " + (affiliate.affiliate_address.number || "")) + "\n";
        $scope.call.address += ("CEP: " + (affiliate.affiliate_address.cep || "") + " - " + "Bairro: " + (affiliate.affiliate_address.neighborhood || "") + " - " + (affiliate.affiliate_address.city || "")) + "\n";
        $scope.call.address += ("Próximo: " + (affiliate.affiliate_address.landmark || "")) + "\n";
        $scope.call.address += ("Complemento: " + (affiliate.affiliate_address.complement || "")) + "\n";
      } else {
        $scope.call.address = affiliate.address;
      }
      $scope.call.age = affiliate.affiliate_age;
      $scope.reload_last_calls = true;
      $scope.getLastCalls();
      if (!affiliate.client_active || !affiliate.active) {
        $scope.call.inactive_affiliate = true;
        return $scope.inactiveClientModal();
      } else {
        return $scope.call.inactive_affiliate = false;
      }
    };
    $scope.getLastCalls = function() {
      if ($scope.reload_last_calls) {
        $scope.last_calls = [];
        $scope.pagination.page = 1;
        $scope.reload_last_calls = false;
      }
      return Call.affiliate_last_calls({
        affiliate_id: $scope.call.affiliate_id,
        page: $scope.pagination.page
      }, function(data) {
        $scope.last_calls = $scope.last_calls.concat(data.calls);
        return $scope.pagination = data.pagination;
      });
    };
    $scope.updatePhone = function() {
      if (angular.isDefined($scope.first_phone)) {
        if ($scope.first_phone.length >= 10) {
          $scope.call.phones[0] = $scope.first_phone;
          return toastr.info("Telefone Adicionado");
        } else {
          return toastr.error("Necessário informar DDD+Número");
        }
      }
    };
    $scope.checkPhone = function(phone) {
      if (angular.isDefined(phone)) {
        if (phone.length >= 10) {
          return $scope.form_erros = false;
        } else {
          if (phone.length !== 0) {
            $scope.form_erros = true;
            return toastr.error('Verifique o Telefone do Solicitante DDD+Número');
          }
        }
      }
    };
    $scope.searchAddressModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/search_address_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      modalInstance.result.then((function() {}), function() {});
    };
    $scope.creating_call = false;
    return $scope.createCall = function() {
      $scope.creating_call = true;
      if (!$scope.form_erros) {
        return Call.save({
          call: $scope.call
        }, (function(data) {
          toastr.info('Chamada criada');
          return $state.go('show_call', {
            id: data.id
          });
        }), function(error) {
          $scope.showError(error);
          return $scope.creating_call = false;
        });
      }
    };
  }).controller('CallsShowController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Call, $filter, $stateParams, AttendanceCode, User, Destination, Diagnosis, Qrl) {
    var ModalInstanceCtrl;
    $scope.call = {};
    $scope.new_phone = null;
    $scope.first_phone = null;
    $scope.form_erros = false;
    $scope.panel = 'attendance';
    $scope.last_calls = [];
    $scope.destinations = [];
    $scope.diagnoses = [];
    $scope.qrls = [];
    $scope.gender_type = {
      male: 'Masculino',
      female: 'Feminino'
    };
    $scope.diseases = {};
    $scope.pagination = {
      page: 1,
      is_last_page: true
    };
    $scope.sortableOptions = {
      cancel: ".unsortable",
      items: "li:not(.unsortable)",
      update: function(e, ui) {
        if (ui.item.sortable.first_stage) {
          ui.item.sortable.cancel();
        }
      }
    };
    Call.get({
      id: $stateParams.id
    }, (function(data) {
      $scope.diseases = data.affiliate.diseases;
      $scope.call = data.call;
      $scope.first_phone = data.call.phones[0];
      $scope.affiliate = data.affiliate;
      $scope.vehicles = data.vehicles;
      $scope.vehicles.unshift({
        id: null,
        name: "Nenhum"
      });
      $scope.teams = data.teams;
      $scope.teams.unshift({
        id: null,
        title: "Nenhuma"
      });
      $scope.getLastCalls();
      return $scope.canCloseCall();
    }), function(error) {
      if (error.status === 500) {
        return $state.go('calls');
      } else {
        return $scope.showError(error);
      }
    });
    $scope.reloadCall = function() {
      return Call.get({
        id: $stateParams.id
      }, function(data) {
        $scope.call = data.call;
        return $scope.affiliate = data.affiliate;
      });
    };
    $scope.reloadCall();
    $scope.phoneModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/phones_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      modalInstance.result.then((function() {}), function() {
        if (angular.isDefined($scope.call.phones)) {
          if ($scope.call.phones.length === 0) {
            $scope.first_phone = null;
          } else {
            $scope.first_phone = $scope.call.phones[0];
          }
        }
      });
    };
    $scope.getLastCalls = function() {
      return Call.affiliate_last_calls({
        affiliate_id: $scope.call.affiliate_id,
        page: $scope.pagination.page,
        last_call_id: $stateParams.id
      }, function(data) {
        $scope.last_calls = $scope.last_calls.concat(data.calls);
        return $scope.pagination = data.pagination;
      });
    };
    AttendanceCode.get({}, function(data) {
      return $scope.attendance_codes = data.attendance_codes;
    });
    $scope.cancelCallModal = function() {
      var modalInstance;
      $scope.call.cancel_reason = null;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/cancel_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      return modalInstance;
    };
    $scope.shiftHourFormat = function(index) {
      return (index + 1) % 4 === 0;
    };
    $scope.allHoursFilled = function() {
      if ($scope.call.shift_hours) {
        return ($filter('filter')($scope.call.shift_hours, {
          value: ''
        }, true)).length === 0;
      } else {
        return true;
      }
    };
    $scope.canCloseCall = function() {
      if ($scope.call) {
        return !$scope.call.is_closed && !$scope.call.is_canceled && $scope.call.destination_id && $scope.call.attendance_code_id && $scope.call.operator_id;
      } else {
        return false;
      }
    };
    $scope.checkPhone = function(phone) {
      if (angular.isDefined(phone)) {
        if (phone.length >= 10) {
          $scope.form_erros = false;
          return $scope.updateCall();
        } else {
          if (phone.length !== 0) {
            $scope.form_erros = true;
            return toastr.error('Verifique o Telefone do Solicitante DDD+Número');
          }
        }
      }
    };
    $scope.closeCall = function() {
      if ($scope.canCloseCall()) {
        return Call.close_call({
          id: $scope.call.id
        }, (function(data) {
          toastr.info('Chamada Fechada');
          return $scope.reloadCall();
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
    $scope.reopenCall = function() {
      return Call.reopen_call({
        id: $scope.call.id
      }, (function(data) {
        toastr.info('Chamada Reaberta');
        return $scope.reloadCall();
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.changeCallTitular = function() {
      var modalInstance;
      $scope.selected_affiliate = {};
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/change_call_titular.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      return modalInstance;
    };
    $scope.callHistory = function() {
      var modalInstance;
      Call.get_history({
        id: $scope.call.id
      }, function(data) {
        return $scope.histories = data;
      });
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/history.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'lg'
      });
      return modalInstance;
    };
    $scope.inactiveClientModal = function() {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/calls/inactive_modal.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md'
      });
      return modalInstance;
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, $uibModalStack, Call, Client) {
      $scope.translateFieldName = {
        'calls.affiliate_id': 'Filiado',
        'calls.client_id': 'Cliente',
        'calls.address': 'Endereço'
      };
      $scope.ok = function() {
        Call.cancel_call({
          id: $scope.call.id,
          cancel_reason: $scope.call.cancel_reason
        }, (function(data) {
          toastr.info('Chamada cancelada');
          $scope.reloadCall();
          return $uibModalInstance.close();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.client_inactive = false;
      $scope.loadAffiliates = function(search) {
        if (search.length > 2) {
          $scope.loadingAffiliate = true;
          return Client.reload_affiliate({
            search: search,
            client_inactive: $scope.client_inactive
          }, function(data) {
            $scope.affiliates = data;
            return $scope.loadingAffiliate = false;
          });
        }
      };
      $scope.getAffiliateValues = function(affiliate) {
        $scope.selected_affiliate = affiliate;
        $scope.diseases = affiliate.diseases;
        $scope.edit_call = angular.copy($scope.call);
        $scope.edit_call.affiliate_id = affiliate.id;
        $scope.edit_call.aggravate = affiliate.aggravate;
        $scope.edit_call.note = affiliate.note;
        $scope.edit_call.gender = affiliate.gender;
        $scope.edit_call.phones = affiliate.phones;
        if (affiliate.phones[0]) {
          $scope.first_phone = affiliate.phones[0].replace(/\D+/g, '');
        }
        $scope.edit_call.client_id = affiliate.client_id;
        $scope.edit_call.client_name = affiliate.client_name;
        if (affiliate.affiliate_address) {
          $scope.edit_call.address = "";
          $scope.edit_call.address = ((affiliate.affiliate_address.street || "") + ", " + (affiliate.affiliate_address.number || "")) + "\n";
          $scope.edit_call.address += ("CEP: " + (affiliate.affiliate_address.cep || "") + " - " + "Bairro: " + (affiliate.affiliate_address.neighborhood || "") + " - " + (affiliate.affiliate_address.city || "")) + "\n";
          $scope.edit_call.address += ("Próximo: " + (affiliate.affiliate_address.landmark || "")) + "\n";
          $scope.edit_call.address += ("Complemento: " + (affiliate.affiliate_address.complement || "")) + "\n";
        } else {
          $scope.edit_call.address = affiliate.address;
        }
        $scope.edit_call.age = affiliate.affiliate_age;
        if (!affiliate.client_active || !affiliate.active) {
          return $scope.call.inactive_affiliate = true;
        } else {
          return $scope.call.inactive_affiliate = false;
        }
      };
      $scope.confirmChangeCallTitular = function() {
        return Call.update({
          id: $scope.call.id,
          call: $scope.edit_call
        }, (function(data) {
          toastr.info('Chamada Atualizada');
          $scope.reloadCall();
          return $uibModalStack.dismissAll();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      $scope.addPhone = function() {
        if (angular.isDefined($scope.new_phone) && $scope.new_phone !== null) {
          if ($scope.new_phone.length >= 10) {
            $scope.call.phones.push($scope.new_phone);
            $scope.new_phone = null;
            $scope.updateCall();
          } else {
            return toastr.error("Necessário informar DDD+Número");
          }
        }
      };
      return $scope.removePhone = function(index) {
        $scope.call.phones.splice(index, 1);
        $scope.updateCall();
      };
    };
    User.users_by_position({}, function(data) {
      $scope.team_users = data;
      if (data.supervisors) {
        $scope.team_users.supervisors.unshift({
          id: null,
          name: "Nenhum"
        });
      }
      if (data.doctors) {
        $scope.team_users.doctors.unshift({
          id: null,
          name: "Nenhum"
        });
      }
      if (data.nurses) {
        $scope.team_users.nurses.unshift({
          id: null,
          name: "Nenhum"
        });
      }
      if (data.drivers) {
        $scope.team_users.drivers.unshift({
          id: null,
          name: "Nenhum"
        });
      }
      if (data.operators) {
        return $scope.team_users.operators.unshift({
          id: null,
          name: "Nenhum"
        });
      }
    });
    $scope.selectDiagnosis = function() {
      if ($scope.call.diagnosis_code) {
        return Diagnosis.get_by_code({
          code: $scope.call.diagnosis_code
        }, function(data) {
          if (data.name) {
            $scope.call.diagnosis_name = data.name;
            $scope.call.diagnosis_id = data.id;
          } else {
            $scope.call.diagnosis_name = 'Não encontrado';
            $scope.call.diagnosis_code = null;
            $scope.call.diagnosis_id = null;
          }
          return $scope.updateCall();
        });
      } else {
        return $scope.call.diagnosis_name = null;
      }
    };
    Qrl.get_qrls({}, function(data) {
      $scope.qrls = data;
      return $scope.qrls.unshift({
        id: null,
        name: "Nenhum"
      });
    });
    Destination.get_destinations({}, function(data) {
      $scope.destinations = data;
      return $scope.destinations.unshift({
        id: null,
        name: "Nenhum"
      });
    });
    $scope.updateCall = function() {
      return Call.update({
        id: $scope.call.id,
        call: $scope.call
      }, (function(data) {
        return toastr.info('Chamada Atualizada');
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.updatePhone = function() {
      if (angular.isDefined($scope.first_phone)) {
        if ($scope.first_phone.length >= 10) {
          $scope.call.phones[0] = $scope.first_phone;
          return $scope.updateCall();
        } else {
          return toastr.error("Necessário informar DDD+Número");
        }
      }
    };
    return $scope.updateShiftHours = function(index, val) {
      var a, b, output, position;
      if (angular.isUndefined(val)) {
        toastr.error('Verfifique o campo ' + $scope.call.shift_hours[index].title);
        $scope.call.shift_hours[index] = {
          title: $scope.call.shift_hours[index].title,
          value: ''
        };
      } else {
        a = $scope.call.shift_hours[index].value.slice(0, "2");
        b = $scope.call.shift_hours[index].value.slice("-2");
        position = 2;
        output = [a, b].join(':');
        $scope.call.shift_hours[index] = {
          title: $scope.call.shift_hours[index].title,
          value: output
        };
        return Call.update_shift_hours({
          id: $scope.call.id,
          shift_hours: $scope.call.shift_hours,
          index: index
        }, (function(data) {
          return toastr.info('Chamada Atualizada');
        }), function(error) {
          return $scope.showError(error);
        });
      }
    };
  }).controller('CallsRevisionController', function($timeout, toastr, $scope, $auth, $state, $uibModal, Call, User, $filter) {
    var ModalInstanceCtrl, filter;
    filter = {
      is_closed: false
    };
    $scope.calls = [];
    $scope.affiliate = null;
    $scope.table_fields = $scope.user.preferences.columns;
    if (!$scope.table_fields) {
      $scope.table_fields = [];
    }
    $scope.diseases = {};
    $scope.callReviewModal = function(id) {
      return Call.get({
        id: id
      }, function(data) {
        var modalInstance;
        if (data.affiliate.diseases) {
          $scope.diseases = data.affiliate.diseases;
        }
        $scope.call = data.call;
        $scope.affiliate = data.affiliate;
        modalInstance = $uibModal.open({
          animation: false,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/calls/review_modal.html',
          controller: ModalInstanceCtrl,
          scope: $scope,
          size: 'lg'
        });
        return modalInstance;
      });
    };
    $scope.hasSelectedToReview = function() {
      return ($filter('filter')($scope.calls, {
        checked: true
      }, true)).length > 0;
    };
    $scope.CallsReproval = function() {
      var selected_calls, selected_ids;
      selected_calls = $filter('filter')($scope.calls, {
        checked: true
      }, true);
      selected_ids = selected_calls.map(function(t) {
        return t.id;
      });
      return Call.reprove_calls({
        call_ids: selected_ids
      }, (function(data) {
        toastr.info('Chamadas reprovadas');
        return $scope.calls_revision();
      }), function(error) {
        return $scope.showError(error);
      });
    };
    $scope.CallsApproval = function() {
      var selected_calls, selected_ids;
      selected_calls = $filter('filter')($scope.calls, {
        checked: true
      }, true);
      selected_ids = selected_calls.map(function(t) {
        return t.id;
      });
      return Call.approve_calls({
        call_ids: selected_ids
      }, (function(data) {
        if (data.qtd_not_approved <= 0) {
          toastr.info('Chamadas aprovadas');
        } else {
          toastr.info(data.qtd_approved + ' chamadas aprovadas. ' + data.qtd_not_approved + ' chamadas não foram aprovadas pois não possuem nenhum ou possuem mais de um contrato ativo');
        }
        return $scope.calls_revision();
      }), function(error) {
        return $scope.showError(error);
      });
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, Call) {
      $scope.ok = function() {
        return $uibModalInstance.close();
      };
      $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
      };
      $scope.approve = function() {
        Call.approve_call({
          id: $scope.call.id,
          contract_rider_id: $scope.call.contract_rider_id,
          attendance_value: $scope.call.attendance_value
        }, (function(data) {
          toastr.info('Chamada aprovada');
          $scope.calls_revision();
          return $uibModalInstance.close();
        }), function(error) {
          return $scope.showError(error);
        });
      };
      return $scope.reprove = function() {
        Call.reprove_call({
          id: $scope.call.id
        }, (function(data) {
          toastr.error('Chamada reprovada');
          $scope.calls_revision();
          return $uibModalInstance.close();
        }), function(error) {
          return $scope.showError(error);
        });
      };
    };
    $scope.calls_revision = function() {
      return Call.calls_revision({}, function(data) {
        return $scope.calls = data;
      });
    };
    return $scope.calls_revision();
  });

}).call(this);



(function() {
  angular.module('ideal').factory('Call', [
    '$resource', function($resource) {
      return $resource('/api/calls/:id', {
        id: '@id'
      }, {
        affiliate_last_calls: {
          url: '/api/calls/affiliate_last_calls.json'
        },
        update: {
          url: '/api/calls/:id',
          method: 'PUT'
        },
        update_shift_hours: {
          url: '/api/calls/:id/update_shift_hours',
          method: 'PUT'
        },
        cancel_call: {
          url: '/api/calls/:id/cancel_call',
          method: 'PUT'
        },
        close_call: {
          url: '/api/calls/:id/close_call',
          method: 'PUT'
        },
        reopen_call: {
          url: '/api/calls/:id/reopen_call',
          method: 'PUT'
        },
        calls_text_mode: {
          url: '/api/calls/calls_text_mode'
        },
        get_history: {
          url: '/api/calls/:id/get_history',
          isArray: true
        },
        calls_revision: {
          url: '/api/calls/calls_revision',
          isArray: true
        },
        approve_call: {
          url: '/api/calls/:id/approve_call',
          method: 'PUT'
        },
        reprove_call: {
          url: '/api/calls/:id/reprove_call',
          method: 'PUT'
        },
        approve_calls: {
          url: '/api/calls/approve_calls',
          method: 'PUT'
        },
        reprove_calls: {
          url: '/api/calls/reprove_calls',
          method: 'PUT',
          isArray: true
        },
        search_address: {
          url: '/api/calls/search_address',
          method: 'GET'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').factory('AttendanceCode', [
    '$resource', function($resource) {
      return $resource('/api/attendance_codes/:id', {
        id: '@id'
      }, {
        inactivate: {
          method: 'PUT',
          url: '/api/attendance_codes/:id/inactivate'
        },
        update_order: {
          method: 'PUT',
          url: '/api/attendance_codes/update_order'
        },
        update: {
          method: 'PUT',
          url: '/api/attendance_codes/:id'
        },
        set_default_attendance: {
          method: 'PUT',
          url: '/api/attendance_codes/:id/set_default_attendance'
        }
      });
    }
  ]);

}).call(this);



(function() {
  angular.module('ideal').controller('AttendanceCodesController', function($timeout, webDevTec, toastr, $scope, $auth, $state, AttendanceCode, $uibModal) {
    var ModalInstanceCtrl;
    $scope.attendance_codes = [];
    $scope.attendance_code = {};
    $scope.update_code_str = "";
    $scope.getAttendanceCodes = function() {
      return AttendanceCode.get({}, function(data) {
        return $scope.attendance_codes = data.attendance_codes;
      });
    };
    $scope.getAttendanceCodes();
    $scope.inactivate = function(code_id, index) {
      return AttendanceCode.inactivate({
        id: code_id
      }, function(data) {
        $scope.attendance_codes.splice(index, 1);
        return toastr.error('Removido com sucesso');
      });
    };
    $scope.setDefault = function(code_id) {
      return AttendanceCode.set_default_attendance({
        id: code_id
      }, function(data) {
        return $scope.getAttendanceCodes();
      });
    };
    $scope.updateOrder = function() {
      return AttendanceCode.update_order({
        attendance_codes: $scope.attendance_codes
      }, (function(data) {}), function(error) {
        $scope.showError(error);
        return console.log(error);
      });
    };
    $scope.updateAttendance = function(code) {
      var modalInstance;
      $scope.update_code_str = "Atualizar Código";
      $scope.attendance_code = angular.copy(code);
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/attendance_codes/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
    ModalInstanceCtrl = function($scope, $uibModalInstance, Cep) {
      $scope.ok = function() {
        $uibModalInstance.close();
      };
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
      return $scope.createAttendanceCode = function() {
        if ($scope.attendance_code.id) {
          return AttendanceCode.update({
            id: $scope.attendance_code.id,
            attendance_code: $scope.attendance_code
          }, (function(data) {
            $scope.getAttendanceCodes();
            $uibModalInstance.close();
            return toastr.info('Alterado com sucesso');
          }), function(error) {
            $scope.showError(error);
            return console.log(error);
          });
        } else {
          return AttendanceCode.save({
            attendance_code: $scope.attendance_code
          }, (function(data) {
            $scope.getAttendanceCodes();
            $uibModalInstance.close();
            return toastr.info('Criado com sucesso');
          }), function(error) {
            $scope.showError(error);
            return console.log(error);
          });
        }
      };
    };
    return $scope.newAttendanceCode = function() {
      var modalInstance;
      $scope.update_code_str = "";
      $scope.attendance_code = {};
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/attendance_codes/new.html',
        controller: ModalInstanceCtrl,
        scope: $scope,
        size: 'md',
        resolve: {}
      });
    };
  });

}).call(this);



(function() {
  angular.module('ideal').run(function($log) {
    'ngInject';
    return $log.debug('runBlock end');
  }).run(function($rootScope, $location, toastr) {
    $rootScope.$on('auth:login-error', function(ev, reason) {
      toastr.error(reason.errors[0]);
    });
    $rootScope.$on('auth-not-authorized', function(ev, reason) {
      toastr.warning("Você não tem autorização");
    });
    return $rootScope.$on('auth:login-success', function(ev, reason) {
      $location.path("/");
    });
  });

}).call(this);



(function() {
  angular.module('ideal').config(function($stateProvider, $urlRouterProvider, $locationProvider) {
    'ngInject';
    $urlRouterProvider.when('/calls', '/calls/index');
    $stateProvider.state('home', {
      url: '/',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('login', {
      url: '/login',
      templateUrl: 'app/sessions/new.html',
      controller: 'SessionsController',
      controllerAs: 'login'
    }).state('configuration', {
      url: '/configuration',
      templateUrl: 'app/configuration/index.html',
      controller: 'ConfigurationController',
      controllerAs: 'conf',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('users', {
      url: '/users',
      templateUrl: 'app/users/index.html',
      controller: 'UsersController',
      controllerAs: 'users',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_users') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('new_user', {
      url: '/users/new',
      templateUrl: 'app/users/new.html',
      controller: 'UsersNewController',
      controllerAs: 'users',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_users') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('edit_user', {
      url: '/users/:id/edit',
      templateUrl: 'app/users/new.html',
      controller: 'UsersEditController',
      controllerAs: 'users',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_users') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('ceps', {
      url: '/cep',
      templateUrl: 'app/ceps/index.html',
      controller: 'CepsController',
      controllerAs: 'ceps',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_ceps') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('profile', {
      url: '/profile',
      templateUrl: 'app/users/profile.html',
      controller: 'ProfileController',
      controllerAs: 'profile',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('clients', {
      url: '/clients',
      templateUrl: 'app/clients/index.html',
      controller: 'ClientsController',
      controllerAs: 'clients',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_clients') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('new_client', {
      url: '/clients/new',
      templateUrl: 'app/clients/new.html',
      controller: 'ClientsNewController',
      controllerAs: 'new_client',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_clients') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('show_client', {
      url: '/clients/:id',
      templateUrl: 'app/clients/show.html',
      controller: 'ClientsShowController',
      controllerAs: 'show_client',
      params: {
        affiliate: null,
        tab: null,
        client_id: null,
        reopen_modal: null
      },
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_clients') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('attendance_codes', {
      url: '/attendance_codes',
      templateUrl: 'app/attendance_codes/index.html',
      controller: 'AttendanceCodesController',
      controllerAs: 'attendance_codes',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_attendance_codes') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('calls', {
      url: '/calls',
      templateUrl: 'app/calls/index.html',
      controller: 'CallsController',
      controllerAs: 'calls',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('calls.index', {
      url: '/index',
      templateUrl: 'app/calls/calls_table.html',
      controller: 'CallsController',
      controllerAs: 'calls',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('calls.revision', {
      url: '/revision',
      templateUrl: 'app/calls/revision.html',
      controller: 'CallsRevisionController',
      controllerAs: 'calls',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('new_call', {
      url: '/calls/new',
      templateUrl: 'app/calls/new.html',
      controller: 'CallsNewController',
      controllerAs: 'new_call',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('show_call', {
      url: '/calls/:id',
      templateUrl: 'app/calls/show.html',
      controller: 'CallsShowController',
      controllerAs: 'show_call',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('shift_hours', {
      url: '/shift_hours',
      templateUrl: 'app/shift_hours/index.html',
      controller: 'ShiftHoursController',
      controllerAs: 'shift_hours',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_shift_hours') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('vehicles', {
      url: '/vehicles',
      templateUrl: 'app/vehicles/index.html',
      controller: 'VehiclesController',
      controllerAs: 'vehicles',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_vehicles') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('teams', {
      url: '/teams',
      templateUrl: 'app/teams/index.html',
      controller: 'TeamsController',
      controllerAs: 'teams',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_teams') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('health_plans', {
      url: '/health_plans',
      templateUrl: 'app/health_plans/index.html',
      controller: 'HealthPlansController',
      controllerAs: 'health_plans',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_health_plan') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('qrls', {
      url: '/qrls',
      templateUrl: 'app/qrls/index.html',
      controller: 'QrlsController',
      controllerAs: 'qrls',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('diseases', {
      url: '/diseases',
      templateUrl: 'app/diseases/index.html',
      controller: 'DiseasesController',
      controllerAs: 'diseases',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('diagnoses', {
      url: '/diagnoses',
      templateUrl: 'app/diagnoses/index.html',
      controller: 'DiagnosesController',
      controllerAs: 'diagnoses',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('destinations', {
      url: '/destinations',
      templateUrl: 'app/destinations/index.html',
      controller: 'DestinationsController',
      controllerAs: 'destinations',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_destinations') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('notifications', {
      url: '/notifications',
      templateUrl: 'app/notifications/index.html',
      controller: 'NotificationsController',
      controllerAs: 'notifications',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_notifications') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('role_groups', {
      url: '/role_groups',
      templateUrl: 'app/role_groups/index.html',
      controller: 'RoleGroupsController',
      controllerAs: 'role_groups',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_role_group') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('role_groups_show', {
      url: '/role_groups/:id',
      templateUrl: 'app/role_groups/show.html',
      controller: 'RoleGroupsShowController',
      controllerAs: 'role_groups',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_role_group') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('reviews', {
      url: '/reviews',
      templateUrl: 'app/reviews/index.html',
      controller: 'ReviewsController',
      controllerAs: 'reviews',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('contract_types', {
      url: '/contract_types',
      templateUrl: 'app/contract_types/index.html',
      controller: 'ContractTypesController',
      controllerAs: 'contract_types',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_contract_types') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('contracts', {
      url: '/contracts',
      templateUrl: 'app/contracts/index.html',
      controller: 'ContractsController',
      controllerAs: 'contracts',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_contract_types') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('new_contract', {
      url: '/contracts/new',
      templateUrl: 'app/contracts/new.html',
      controller: 'ContractsNewController',
      controllerAs: 'new_contract',
      params: {
        client_id: null,
        contract_id: null,
        contract: null,
        current_rider: null
      },
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_contract_types') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('show_contract', {
      url: '/contracts/:id',
      templateUrl: 'app/contracts/show.html',
      controller: 'ContractsShowController',
      controllerAs: 'show_contract',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('manage_contract_types') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('reports', {
      url: '/reports',
      templateUrl: 'app/reports/index.html',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser()["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('export_cards', {
      url: '/reports/export_cards',
      templateUrl: 'app/reports/export_cards.html',
      controller: 'ReportsExportCardswController',
      controllerAs: 'export_cards',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_export_cards') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_contracts', {
      url: '/reports/extract_contracts',
      templateUrl: 'app/reports/extract_contracts.html',
      controller: 'ReportsExtractContractsController',
      controllerAs: 'extract_contracts',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_contracts') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_contracts_block', {
      url: '/reports/extract_contracts_block',
      templateUrl: 'app/reports/extract_contracts_block.html',
      controller: 'ReportsExtractContractsBlockController',
      controllerAs: 'extract_contracts_block',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_contracts_block') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_calls', {
      url: '/reports/extract_calls',
      templateUrl: 'app/reports/extract_calls.html',
      controller: 'ReportsExtractCallsController',
      controllerAs: 'extract_calls',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_calls') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_users', {
      url: '/reports/extract_users',
      templateUrl: 'app/reports/extract_users.html',
      controller: 'ReportsExtractUsersController',
      controllerAs: 'extract_users',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_users') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_clients', {
      url: '/reports/extract_clients',
      templateUrl: 'app/reports/extract_clients.html',
      controller: 'ReportsExtractClientsController',
      controllerAs: 'extract_clients',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_clients') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_affiliates', {
      url: '/reports/extract_affiliates',
      templateUrl: 'app/reports/extract_affiliates.html',
      controller: 'ReportsExtractAffiliatesController',
      controllerAs: 'extract_affiliates',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_affiliates') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    }).state('extract_archive', {
      url: '/reports/extract_archive',
      templateUrl: 'app/reports/extract_archive.html',
      controller: 'ReportsExtractArchivesController',
      controllerAs: 'extract_archive',
      resolve: {
        auth: function($auth, $state) {
          return $auth.validateUser().then(function() {
            if ($auth.user.roles.indexOf('can_extract_archive') < 0) {
              $state.go('home');
            }
          })["catch"](function() {
            $state.go('login');
          });
        }
      }
    });
    return $urlRouterProvider.otherwise('/');
  });

}).call(this);



(function() {
  angular.module('ideal').constant('malarkey', malarkey).constant('moment', moment);

}).call(this);



(function() {
  angular.module('ideal').config(function($logProvider, toastrConfig) {
    'ngInject';
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    return toastrConfig.progressBar = false;
  }).config([
    'uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
      uibDatepickerPopupConfig.closeText = 'Fechar';
      uibDatepickerPopupConfig.currentText = 'Hoje';
      uibDatepickerPopupConfig.clearText = 'Limpar';
      uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
    }
  ]);

}).call(this);



'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "domingo",
      "segunda-feira",
      "ter\u00e7a-feira",
      "quarta-feira",
      "quinta-feira",
      "sexta-feira",
      "s\u00e1bado"
    ],
    "ERANAMES": [
      "Antes de Cristo",
      "Ano do Senhor"
    ],
    "ERAS": [
      "a.C.",
      "d.C."
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "SHORTDAY": [
      "dom",
      "seg",
      "ter",
      "qua",
      "qui",
      "sex",
      "s\u00e1b"
    ],
    "SHORTMONTH": [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez"
    ],
    "STANDALONEMONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d 'de' MMMM 'de' y",
    "longDate": "d 'de' MMMM 'de' y",
    "medium": "d 'de' MMM 'de' y HH:mm:ss",
    "mediumDate": "d 'de' MMM 'de' y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/yy HH:mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "R$",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "pt-br",
  "localeID": "pt_BR",
  "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);
angular.module("ideal").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/attendance_codes/index.html","<section class=container><div class=row><header><div class=col-md-9><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Códigos</h4></div><div class=col-md-3><a ng-click=newAttendanceCode() class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo código</a></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"attendance_codes.length ==  0\" class=\"panel-body well\"><h5 class=text-center>Nenhum códido cadastrado, <a ng-click=newAttendanceCode() href=\"\" class=text-default>cadastrar novo código.</a></h5></div></div><div ng-if=\"attendance_codes.length &gt;  0\" class=col-md-12><ul ui-sortable ng-model=attendance_codes ui-sortable-update=updateOrder() class=list-group><li class=\"list-group-item border-none\"><div class=row><div class=col-xs-3><strong>Titulo</strong></div><div class=col-xs-3><strong>Cor</strong></div></div></li><li ng-repeat=\"code in attendance_codes\" class=list-group-item><div class=row><div ng-click=updateAttendance(code) class=col-xs-3>{{$index+1+\". \"+code.title}}</div><div ng-click=updateAttendance(code) class=col-xs-3><span style=\"background: {{code.color}}\" class=code></span></div><div class=col-xs-3><span ng-if=code.is_default><i class=\"fa fa-star fa-fw\"></i>Código Padrão</span><div ng-if=!code.is_default ng-click=setDefault(code.id)><a><i class=\"fa fa-star fa-fw\"></i>Deixar como padrão</a></div></div><div class=col-xs-3><a ng-really-click=\"inactivate(code.id, $index)\" ng-really-title=\"Remover código de atendimento\" ng-really-sub-title=\"{{ code.title}} \" href=\"\" class=\"onHover pull-right\"><i class=\"fa fa-trash-o\"></i></a></div></div></li></ul></div></div></div></div></section>");
$templateCache.put("app/attendance_codes/new.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 ng-if=\"update_code_str.length == 0\">Cadastrar Código</h4><h4 ng-if=\"update_code_str.length &gt; 0\">{{ update_code_str }} <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=row><form name=form ng-submit=createAttendanceCode() class=form><div class=col-md-12><div class=p-t-1><fieldset class=form-group><label class=control-label>Titulo</label><span class=text-danger>*</span> <input type=text placeholder=\"Titulo não informado\" ng-model=attendance_code.title required class=form-control></fieldset><fieldset class=form-group><label class=control-label>Selecione uma cor</label><span class=text-danger>*</span> <input type=color ng-model=attendance_code.color required class=form-control></fieldset></div></div></form></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button ng-disabled=form.$invalid form=form ng-click=createAttendanceCode() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check-square\"></i> Confirmar</button></div></div></div>");
$templateCache.put("app/calls/calls_table.html","<div class=row><div class=col-md-3><header class=p-b-1><h4 class=text-primary><i aria-hidden=true class=\"fa fa-stethoscope\"></i> Chamadas</h4></header></div><div class=\"col-md-9 text-right form-group\"><button type=submit data-toggle=tooltip data-placement=bottom title=\"Pesquisar chamadas\" ui-sref=extract_calls class=\"btn btn-info btn-sm\"><i aria-hidden=true class=\"fa fa-search fa-fw\"></i>Pesquisar Chamadas</button> <button type=submit data-toggle=tooltip data-placement=bottom title=\"Chamadas modo texto\" ng-click=textModeCalls() class=\"btn btn-default btn-sm\"><i aria-hidden=true class=\"fa fa-search-plus fa-fw\"></i>Modo Texto</button> <button type=submit ui-sref=calls.revision data-toggle=tooltip data-placement=bottom title=\"Revisão de chamadas\" class=\"btn btn-info btn-sm\"><i aria-hidden=true class=\"fa fa-binoculars fa-fw\"></i>Revisão</button> <button type=submit data-toggle=tooltip data-placement=bottom title=\"Abrir Chamada\" ui-sref=new_call class=\"btn btn-primary btn-sm\"><i aria-hidden=true class=\"fa fa-plus fa-fw\"></i>Abrir Chamada</button></div></div><mini-grid columns=table_fields data=calls url-prefix=\"\'/calls/\'\" on-set-visible=onSetVisible(visible_columns) on-order-field=\"onOrderField(field, reverse)\" on-group=onGroup(group) group-field=user.preferences.group order-field=user.preferences.order reverse=user.preferences.reverse></mini-grid>");
$templateCache.put("app/calls/calls_text_mode.html","<div class=modal-fade><div class=modal-body><section class=\"container-fluid text-black\"></section><div class=row><div class=\"col-md-12 p-t-0 text-center\"><header class=p-t-1><h4 class=text-primary><a ng-click=first() href=\"\" class=m-r-1><i aria-hidden=true class=\"fa fa-angle-double-left\"></i></a><a ng-click=previous() href=\"\" class=m-r-1><i aria-hidden=true class=\"fa fa-angle-left\"></i></a><span style=\"font-size: 17px; color: #000\" class=small>{{call.id}}</span><a ng-click=next() href=\"\" class=m-l-1><i aria-hidden=true class=\"fa fa-angle-right\"></i></a><a ng-click=last() href=\"\" class=m-l-1><i aria-hidden=true class=\"fa fa-angle-double-right\"></i></a></h4></header><div class=\"col-md-12 p-l-0 p-r-0 p-t-2\"><form class=\"form form-horizontal\"><div class=col-md-12><div class=row><div><h2 class=\"background text_mode\"><span>Cliente / Filiado</span></h2><div class=\"form-group m-b-0\"><label class=\"col-sm-2 col-md-2 control-label text-center\">Abertura</label><div class=\"col-sm-4 col-md-4 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.created_at | date : \"dd/MM/yyyy HH:mm\"}}</label></div></div><div class=\"form-group m-b-0\"><label class=\"col-sm-2 col-md-2 control-label text-center\">Filiado</label><div class=\"col-sm-2 col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.affiliate_name}}</label></div><div class=\"col-sm-1 col-md-2 text-right\"><label class=control-label>Cliente</label></div><div class=\"col-sm-3 col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.client_name}}</label></div><label class=\"col-sm-1 col-md-1 control-label text-center\">Telefones</label><div class=\"col-sm-3 col-md-3 text-left\"><label ng-repeat=\"phone in call.phones\" class=\"control-label font-weight-normal text-left\">{{phone | tel }}<span ng-if=!$last>/</span></label></div></div><div class=\"form-group m-b-0\"><div class=\"col-sm-2 col-md-2 text-right\"><label class=control-label>Sexo</label></div><div class=\"col-sm-2 col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{gender_text[call.affiliate_gender] || \"-\" }}</label></div><label class=\"col-sm-2 col-md-2 control-label text-right\">Plano de Saúde</label><div class=\"col-sm-2 col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.affiliate_health_plan || \"-\" }}</label></div><label class=\"col-sm-1 col-md-1 control-label text-center\">Idade</label><div class=\"col-sm-3 col-md-3 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.affiliate_age}}</label></div></div><div class=\"form-group m-b-0\"><div class=\"col-sm-2 col-md-2 text-right\"><label class=control-label>Agravantes</label></div><div class=\"col-sm-6 col-md-6 text-left\"><label class=\"control-label font-weight-normal\"><div ng-repeat=\"disease in diseases track by $index\" ng-class=\"{\'last\':$last}\" class=disease>{{ disease.title }}</div></label></div><div class=\"col-sm-1 col-md-1 text-right\"><label class=control-label>Status</label></div><div class=\"col-sm-1 col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.affiliate_status}}</label></div></div></div><div><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Endereço</label></div><div class=\"col-md-6 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.address}}</label></div><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal\">-</label></div></div></div><div><h2 class=\"background text_mode\"><span>Informações</span></h2><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right\"><label class=control-label>Código</label></div><div class=\"col-md-3 text-left\"><label class=\"control-label font-weight-normal\"><span style=\"background-color: {{call.attendance_code_color}}\" class=label>{{call.attendance_code_title}}</span></label></div><label class=\"col-md-1 control-label text-right\">Solicitante</label><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.requestor}}</label></div><label class=\"col-md-1 control-label text-right\">Paciente</label><div class=\"col-md-3 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.patient || \"-\" }}</label></div></div><div class=\"form-group m-b-0\"><label class=\"col-md-2 control-label text-right\">Telefone</label><div class=\"col-md-3 text-left\"><label class=\"control-label font-weight-normal text-left\">{{ (call.requestor_phone | tel) || \"-\" }}</label></div><label class=\"col-md-1 control-label text-right\">QNI</label><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.qni || \" - \"}}</label></div><label class=\"col-md-1 control-label text-right\">Motivo</label><div class=\"col-md-3 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.reason || \"-\" }}</label></div></div><div class=\"form-group m-b-1\"><div class=\"col-md-2 text-right\"><label class=\"control-label text-left\">Relato do Atendimento</label></div><div class=\"col-md-6 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.attendance_report || \" - \"}}</label></div><label class=\"col-md-1 control-label text-right\">Motivo Cancelamento</label><div class=\"col-md-3 text-left\"><label class=\"control-label font-weight-normal text-left white-space-pre-line\">{{call.cancel_reason || \"-\" }}</label></div></div></div><div><h2 class=\"background text_mode\"><span>Deslocamento</span></h2><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Destino</label></div><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{ call.destination.name || \" - \"}}</label></div><label class=\"col-md-2 control-label text-right\">Diagnóstico</label><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-info text-left\">{{call.diagnosis.name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=control-label>QRL</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.qrl.name || \" - \"}}</label></div></div><div ng-repeat=\"shift_hour in call.shift_hours\"><div ng-if=shiftHourFormat($index) class=form-group><div class=\"col-md-2 text-right\"><label class=\"control-label text-left\">{{shift_hour.title}}</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal\">{{shift_hour.value || \" - \"}}</label></div></div><div ng-if=!shiftHourFormat($index)><div class=\"col-md-2 text-right\"><label class=\"control-label text-left\">{{shift_hour.title || \" - \"}}</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal\">{{shift_hour.value || \" - \"}}</label></div></div></div><div class=form-group></div></div><div><h2 class=\"background text_mode\"><span>Atendimento</span></h2><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right\"><label class=control-label>Supervisor</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.supervisor_name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=control-label>Médico</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.doctor_name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=\"control-label text-right\">Enfermagem</label></div><div class=\"col-md-2 text-left\"><label class=\"control-label text-left font-weight-normal text-left\">{{call.nurse_name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=control-label>Motorista</label></div><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.driver_name || \" - \"}}</label></div></div><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right\"><label class=control-label>Operador</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.operator_name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=\"control-label text-right\">Veiculo</label></div><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.vehicle_name || \" - \"}}</label></div><div class=\"col-md-1 text-right\"><label class=control-label>Equipe</label></div><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal text-left\">{{call.team_title || \" - \"}}</label></div></div></div></div></div></form></div></div></div></div><div class=modal-footer><a ng-click=ok() class=\"btn btn-info btn-sm pull-left\"><i class=\"fa fa-reply\"></i> Voltar</a><a ui-sref=\"show_call({id: call.id})\" class=\"btn btn-primary btn-sm pull-right\"><i class=\"fa fa-pencil\"></i> Editar</a></div></div>");
$templateCache.put("app/calls/cancel_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4>Tem certeza que deseja cancelar esta chamada? <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-2\"><div class=row><div class=col-md-12><div class=form-group><label for=cancel_reason>Informe o motivo</label><textarea rows=3 ng-model=call.cancel_reason placeholder=\"Motivo não informado\" class=form-control></textarea></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=button ng-click=close() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-times\"></i> Não</button> <button type=button ng-click=ok() ng-disabled=!call.cancel_reason class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check\"></i> Sim</button></div></div></div>");
$templateCache.put("app/calls/change_call_titular.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Mudar titularidade <button aria-hidden=true data-ng-click=close() type=button class=close>×</button></h4></div></div></div><div class=modal-body><div class=row><div class=col-md-12><div class=form-group><strong class=text-danger>As informações relacionadas ao Filiado selecionado serão atualizadas</strong></div><div ng-show=call.inactive_affiliate class=form-group><strong class=\"text-danger text-center\">Esse filiado/cliente encontra-se inativo<br>Precisa negociar com o cliente pagamento à parte</strong></div></div><div class=col-md-12><div class=form-group><label>Filiado<span class=\"text-danger m-l-3px\">*</span><i ng-show=loadingAffiliate class=\"fa fa-spinner fa-pulse fa-fw\"></i></label><div class=input-group><ui-select ng-model=selected_affiliate ng-change=getAffiliateValues(selected_affiliate) required class=affiliate_select><ui-select-match :placeholder=\"Selecione um filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadAffiliates($select.search) refresh-delay=400 minimum-input-length=3 repeat=\"affiliate in affiliates\"><span ng-bind=\"affiliate.name+\' - \'+ affiliate.format_birth_date +\' - \'+affiliate.client.name\"></span></ui-select-choices></ui-select><span class=\"input-group-addon input-sm\"><label class=\"ui-checkbox m-b-0\"><input type=checkbox ng-model=client_inactive ng-change=getAffiliates(contract.client_id)><span>Inativo</span></label></span></div></div><div class=form-group><label class=\"control-label text-black\"><span style=\"margin-right: 5px\">Idade</span><span class=\"control-label font-weight-normal text-black m-r-1\">{{ selected_affiliate.affiliate_age || \"0\" }}</span></label><label class=\"control-label text-black\"><span style=\"margin-right: 5px\">Sexo</span><strong class=\"control-label font-weight-normal text-black\">{{ gender_type[selected_affiliate.gender] || \"-\"}}</strong></label></div></div><div class=form-group><div class=col-md-12><label>Cliente</label><input type=text placeholder=\"Selecione um Filiado\" ng-model=edit_call.client_name ng-disabled=true class=form-control></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button type=button ng-click=close() class=\"btn btn-default btn-sm\"><i class=\"fa fa-close fa-fw\"></i> Fechar</button> <button type=button ng-click=confirmChangeCallTitular() ng-disabled=!selected_affiliate class=\"btn btn-primary btn-sm\"><i class=\"fa fa-check fa-fw\"></i> Confirmar</button></div></div></div>");
$templateCache.put("app/calls/history.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Logs da chamada <button aria-hidden=true data-ng-click=close() type=button class=close>×</button></h4></div></div></div><div class=modal-body><div class=row><div class=col-md-12><div class=ui-timline-container><section class=ui-timeline><article ng-class=\"[\'\', \'alt\'][$index %2]\" ng-repeat=\"history in histories\" class=\"tl-item ng-scope\"><div class=tl-body><div class=tl-entry><div class=\"tl-time then ng-binding\">{{ history.created_at | date:\"dd/MM/yyyy HH:mm\"}}</div><div ng-class=\"\'bg-\'+actions[history.operation-1]\" class=\"tl-icon round-icon sm bg-success\"><i ng-class=iconClass(history) class=\"fa fa-user\"></i></div><div class=tl-content><h4 class=\"tl-title ng-binding text-success\">{{history.description}}</h4><p>{{history.user.name}}</p><a href=javascript:; ng-click=\"history.show_details = !history.show_details\" ng-show=\"history.field_values.length &gt; 0\"><small>(Detalhes)</small></a><div ng-show=history.show_details><div ng-repeat=\"field in history.field_values\"><strong style=\"margin-right: 5px\">Campo</strong><span>{{ translateFieldName[field.name] }}</span><br><div ng-show=\"field.name == \'Horas de atendimento\'\"><span class=text-muted>Valor Antigo:</span><div ng-repeat=\"old_value in field.old_value track by $index\"><span class=small>{{ old_value.title }} {{ old_value.value }}</span></div><span class=d-block></span><br><span class=text-primary>Valor Novo:</span><div ng-repeat=\"new_value in field.new_value track by $index\"><span class=small>{{ new_value.title }} {{ new_value.value }}</span></div></div><div ng-show=\"field.name == \'Telefones\'\"><span class=text-muted>Valor Antigo:</span><div ng-repeat=\"old_value in field.old_value track by $index\"><span>{{ old_value | tel }}</span></div><span class=d-block></span><span class=text-primary>Valor Novo:</span><div ng-repeat=\"new_value in field.new_value track by $index\"><span>{{ new_value | tel }}</span></div></div><div ng-show=\"field.name == \'Chamada Fechada\'\"><span class=text-muted>Valor Antigo:</span><span ng-if=field.old_value>{{ field.old_value == true ? \"Sim\" : \"Não\" }}</span><span class=d-block></span><span class=text-primary>Valor Novo:</span><span>{{ field.new_value == true ? \"Sim\" : \"Não\" }}</span></div><div ng-show=\"field.name == \'Tempo de fechamento\'\"><span class=text-muted>Valor Antigo: {{ field.old_value | date:\"dd/MM/yyyy HH:mm\" }}</span><span class=d-block></span><span class=text-primary>Valor Novo:</span><span>{{ field.new_value | date:\"dd/MM/yyyy HH:mm\" }}</span></div><div ng-if=\"field.name != \'Horas de atendimento\' &amp;&amp; field.name != \'Telefones\' &amp;&amp; field.name != \'Chamada Fechada\' &amp;&amp; field.name != \'Tempo de fechamento\' \"><span class=text-muted>Valor Antigo: {{ field.old_value }}</span><span class=d-block></span><span class=text-primary>Valor Novo: {{ field.new_value }}</span></div></div></div></div></div></div></article></section></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button type=button ng-click=close() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-ambulance fa-fw\"></i> Fechar</button></div></div></div>");
$templateCache.put("app/calls/inactive_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=text-primary>Esse filiado/cliente encontra-se inativo <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=\"row form-group\"><div class=col-md-12><div class=text-center><h4><div class=text-primary>Precisa negociar com o cliente pagamento à parte. Deseja prosseguir com a abertura da chamada?</div></h4></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-times\"></i> Não</a><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check\"></i> Sim</a></div></div></div></div>");
$templateCache.put("app/calls/index.html","<section class=container><ui-view></ui-view></section>");
$templateCache.put("app/calls/new.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=\"col-md-12 p-l-0 p-b-1 p-r-0\"><div class=col-md-12><div class=row><h4 class=text-primary><i class=\"fa fa fa-ambulance\"></i> Abrir Chamada</h4></div></div></header><form name=form class=\"form form-horizontal\"><section ng-class=\"{current: selected, done: completed}\" title=\"Informações básicas\" class=\"form-group step ng-isolate-scope current\"><div class=panel-body><div class=form-group><label for=\"\" class=\"col-sm-1 col-md-1 col-xs-12 p-r-0 control-label ng-binding\">Filiado<span class=\"text-danger m-l-3px\">*</span><i ng-show=loadingAffiliate class=\"fa fa-spinner fa-pulse fa-fw\"></i></label><div class=\"col-xs-12 col-sm-5 co-md-5\"><div class=input-group><ui-select ng-model=selected_affiliate append-to-body=true ng-change=getAffiliateValues(selected_affiliate) required class=affiliate_select><ui-select-match :placeholder=\"Selecione um filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadAffiliates($select.search) refresh-delay=400 minimum-input-length=3 repeat=\"affiliate in affiliates\"><span ng-bind=\"affiliate.name+\' - \'+ affiliate.format_birth_date +\' - \'+affiliate.client.name\"></span></ui-select-choices></ui-select><span class=\"input-group-addon input-sm\"><label class=\"ui-checkbox m-b-0\"><input type=checkbox ng-model=client_inactive ng-change=getAffiliates(contract.client_id)><span>Inativo</span></label></span></div></div><div class=\"col-md-1 col-sm-2 col-xs-12\"><label class=\"control-label text-black\"><span class=m-r-1>Idade</span><span class=\"control-label font-weight-normal text-black\">{{ call.age || \"0\" }}</span></label></div><div class=\"col-md-2 col-sm-3 col-xs-12\"><label class=\"control-label text-black\"><span class=m-r-1>Sexo</span><strong class=\"control-label font-weight-normal text-black\">{{ gender_type[call.gender] || \"-\"}}</strong></label></div><div class=\"col-md-2 col-sm-3 col-xs-12\"><label class=\"control-label text-black\"><span class=m-r-1>Plano de Saúde</span><strong class=\"control-label font-weight-normal text-black\">{{call.affiliate_health_plan || \"-\"}}</strong></label></div></div><div class=form-group><label class=\"col-xs-12 col-md-1 col-sm-1 control-label\">Cliente</label><div class=\"col-xs-12 col-sm-4 col-md-4\"><input type=text placeholder=\"Selecione um Filiado\" ng-model=call.client_name ng-disabled=true class=form-control></div><label ng-class=\"{ \'text-danger\' : form.telephone.$invalid &amp;&amp; !form.telephone.$pristine || new_phone.length &lt; 10 }\" class=\"col-xs-12 col-md-1 col-sm-4 control-label\">Telefone</label><div class=\"col-xs-12 col-md-3 col-sm-4\"><div class=input-group><input type=text placeholder=\"Telefone não informado\" ng-model=first_phone ng-enter=updatePhone() ng-change=updatePhone() ng-model-options=\"{updateOn: \'blur\'}\" ng-disabled=!call.affiliate_id ui-br-phone-number=\"\" name=telephone model-view-value=true class=form-control><span class=input-group-btn><button type=button ng-click=phoneModal() ng-disabled=!call.affiliate_id class=\"btn btn-primary btn-sm\"><i class=\"fa fa-phone\"></i></button></span></div></div></div><div class=col-md-12><div class=\"alert text-center bg-primary visible-lg-block visible-md-block\"><div class=clearfix><div class=\"col-md-2 col-sm-3 col-xs-12 text-left\"><label class=\"control-label text-black d-block text-left\">Agravantes</label><label class=\"control-label font-weight-normal text-black p-t-0\"><div ng-repeat=\"disease in diseases\" ng-class=\"{\'last\':$last}\" class=disease>{{ disease.title }}</div></label></div><div class=\"col-md-10 col-sm-9 col-xs-12 text-left\"><label class=\"control-label text-black\">Observação</label><p style=\"word-break: break-all\" class=text-danger>{{call.note || \"-\"}}</p></div></div></div></div><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-1 col-sm-2 text-right\"><label class=control-label>QNI</label></div><div class=\"col-xs-12 col-md-3 col-sm-4\"><input type=text ng-model=call.qni class=form-control></div></div><div class=form-group><label for=\"\" class=\"col-xs-12 col-sm-12 col-md-1 control-label text-right\">Endereço</label><div class=\"col-xs-12 col-md-7 col-sm-7\"><textarea ng-model=call.address rows=4 class=form-control></textarea></div></div><div class=form-group><div><div class=\"col-md-1 col-sm-2 text-right\"><label class=control-label>Código</label><span class=\"text-danger m-l-3px\">*</span></div><div class=\"col-md-3 col-sm-4 text-left ui-select-custom\"><ui-select ng-model=call.attendance_code_id append-to-body=true required><ui-select-match :placeholder=\"Selecione um código\"><div class=pull-left><span style=\"background: {{$select.selected.color}}\" class=code></span></div><span ng-bind=$select.selected.title class=m-l-1></span></ui-select-match><ui-select-choices repeat=\"code.id as code in (attendance_codes | filter: $select.search) track by code.id\"><span class=m-l-1>{{code.title}}</span><span style=\"background: {{code.color}}\" class=\"code pull-left\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-1 col-sm-2 control-label text-center\"><strong>Solicitante</strong></div><div class=\"col-md-3 col-sm-4\"><input type=text placeholder=\"Nome do solicitante\" ng-model=call.requestor class=form-control></div><label ng-class=\"{ \'text-danger\' : form.telephone_2.$invalid &amp;&amp; !form.telephone_2.$pristine || call.requestor_phone.length &lt; 10 &amp;&amp; call.requestor_phone.length != 0}\" class=\"col-md-1 col-sm-2 control-label text-right\">Telefone</label><div class=\"col-md-3 col-sm-4\"><input type=text placeholder=\"Telefone do solicitante DDD+Número\" ng-model=call.requestor_phone ui-br-phone-number=\"\" name=telephone_2 ng-blur=checkPhone(call.requestor_phone) class=form-control></div></div><div class=form-group><label for=\"\" class=\"col-xs-12 col-md-1 col-sm-2 control-label ng-binding\">Paciente</label><div class=\"col-xs-12 col-md-3 col-sm-4\"><input type=text placeholder=\"Paciente não informado\" ng-model=call.patient class=form-control></div><label for=\"\" class=\"col-xs-12 col-md-1 col-sm-2 control-label ng-binding\">Motivo</label><div class=\"col-xs-12 col-md-7 col-sm-4\"><input type=text placeholder=\"Motivo não informado\" ng-model=call.reason class=form-control></div></div><div class=form-group><label for=\"\" class=\"col-xs-12 col-md-1 col-sm-2 control-label\">Valor</label><div class=\"col-xs-12 col-sm-3 col-md-3\"><input type=text ng-model=call.call_value placeholder=\"Valor não informado\" ui-number-mask=2 class=form-control></div></div><div class=form-group><label class=\"col-xs-12 col-sm-2 col-md-1 control-label\">Atendimento</label><div class=\"col-xs-11 col-sm-11\"><textarea rows=3 ng-model=call.attendance_report class=form-control></textarea></div></div><div class=form-group><div class=\"col-md-11 col-md-offset-1\"><button form=form ng-click=createCall() ng-disabled=\"form.$invalid || creating_call\" class=\"btn btn-primary btn-block btn-md\"><i class=\"fa fa-arrow-right fa-fw\"></i>Gravar</button></div></div></div><div ng-if=\"last_calls.length &gt; 0 \" class=row><div class=\"col-md-12 col-sm-12 text-left\"><div class=table-responsive><table class=\"table table-striped table-hover custom\"><thead><tr><th>Data de abertura</th><th>Motivo</th><th>Diagnóstico</th><th>Destino</th><th></th></tr></thead><tbody><tr ng-repeat=\"last_call in last_calls\"><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{last_call.created_at | date:\"dd/MM/yyyy HH:mm\"}}</a></td><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{last_call.reason || \" - \"}}</a></td><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{ last_call.diagnosis_name }}</a></td><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{ last_call.destination_name }}</a></td><td></td></tr><tr><td colspan=5 ng-show=\"last_calls.length &gt; 0 &amp;&amp; !pagination.is_last_page\" ng-click=getLastCalls()><div class=text-center><label>Mostrar Mais</label></div></td></tr></tbody></table></div></div></div></div></div></section></form></div></div></section>");
$templateCache.put("app/calls/phones_modal.html","<div class=\"modal-fade remake\"><div class=modal-content><div class=\"modal-fade remake ng-scope\"><header class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4 class=text-left>Lista de Telefones <button aria-hidden=true data-ng-click=close() type=button class=close>×</button></h4></div></div></header><div class=\"modal-body p-t-0\"><div class=\"row p t-1\"><div class=col-md-12><ul ui-sortable=sortableOptions ng-model=call.phones ui-sortable-update=updateOrder() class=list-group><li ng-repeat=\"p in call.phones track by $index\" class=list-group-item><div class=row><div class=col-xs-1><a href=\"\"><i class=\"fa fa-arrows-alt\"></i></a></div><div class=\"col-xs-8 text-left\">{{ p | tel }}</div><div ng-hide=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=\"col-xs-3 text-right\"><a ng-click=removePhone($index) href=\"\"><i class=\"fa fa-trash-o\"></i></a></div></div></li></ul></div><div ng-hide=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=col-md-12><form name=form ng-submit=addPhone() class=row><div class=\"col-md-3 text-right p-l-0\"><label for=new_phone class=\"control-label p-t-1\">Adicionar Nº</label></div><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text name=new_phone ng-model=new_phone placeholder=\"Número não informado\" ui-br-phone-number=\"\" required class=\"form-control input-sm\"><span class=input-group-btn><button type=submit ng-disabled=form.$invalid class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></span></div></div></form></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=button ng-click=close() class=\"btn btn-default ng-binding btn-sm\"><i class=\"fa times\"></i> Fechar</button></div></div></div></div></div>");
$templateCache.put("app/calls/review_modal.html","<div class=modal-fade><div class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4>{{\"#\"+call.id}} <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=\"row small\"><div class=\"form form-horizontal\"><div class=col-md-12><h6>Cliente / Filiado</h6><hr></div><div class=col-md-12><div class=\"form-group m-b-0\"><div class=\"col-sm-2 col-md-2 control-label\"><strong>Filiado</strong></div><div class=\"col-sm-2 col-md-2 text-left control-label\">{{ call.affiliate.name }}</div><div class=\"col-sm-1 col-md-2 text-right control-label\"><strong>Cliente </strong></div><div class=\"col-sm-3 col-md-2 text-left control-label\">{{ call.affiliate.client.name }}</div><div class=\"col-sm-1 col-md-1 control-label text-center\"><strong>Telefones</strong></div><div class=\"col-sm-3 col-md-3 text-left control-label\"><div ng-repeat=\"phone in call.phones\">{{ phone | tel }}</div></div></div><div class=\"form-group m-b-0\"><div class=\"col-sm-2 col-md-2 text-right control-label\"><strong>Sexo </strong></div><div class=\"col-sm-2 col-md-2 text-left control-label\"><span>Masculino</span></div><div class=\"col-sm-2 col-md-2 control-label text-right\"><strong>Plano de Saúde</strong></div><div class=\"col-sm-2 col-md-2 text-left control-label\"><span>SUS</span></div><div class=\"col-sm-1 col-md-1 control-label text-center\"><strong>Idade </strong></div><div class=\"col-sm-3 col-md-3 text-left control-label\"><span>2131</span></div></div><div class=\"form-group m-b-0\"><div class=\"col-sm-2 col-md-2 text-right control-label\"><strong>Agravantes</strong></div><div class=\"col-sm-6 col-md-6 text-left control-label\"><div ng-repeat=\"disease in diseases\" ng-class=\"{\'last\':$last}\" class=disease>{{ disease.title }}</div></div><div class=\"col-sm-1 col-md-1 text-right control-label\"><strong>Status </strong></div><div class=\"col-sm-1 col-md-1 text-left control-label\"><span ng-if=call.affiliate.active>Ativo </span><span ng-if=!call.affiliate.active>Inativo </span></div></div><div class=form-group><div class=\"col-md-2 text-right control-label\"><strong>Endereço</strong></div><div class=\"col-md-5 text-left control-label\"><span>{{ call.address }} </span></div><div class=\"col-md-2 control-label text-right\"><strong>Complemento</strong></div><div class=\"col-md-2 text-left control-label\"><span>-</span></div></div></div><div class=col-md-12><h6>Informações</h6><hr></div><div class=col-md-12><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right control-label\"><strong>Código</strong></div><div class=\"col-md-3 text-left control-label\"><span style=\"background: {{ call.attendance_code.color }}\" class=\"label label-custom-code\">{{ call.attendance_code.title }}</span></div><div class=\"col-md-1 control-label text-right\"><strong>Solicitante </strong></div><div class=\"col-md-2 text-left p-r-0 control-label\"><span>{{ call.requestor }}</span></div><div class=\"col-md-1 control-label text-right\"><strong>Paciente</strong></div><div class=\"col-md-3 text-left control-label\"><span>{{ call.patient || \"-\" }}</span></div><div class=\"col-md-2 control-label text-right\"><strong>Telefone</strong></div><div class=\"col-md-4 text-left control-label\"><span>{{ call.requestor_phone | tel }}</span></div></div><div class=\"form-group m-b-1\"><div class=\"col-md-2 control-label text-right\"><strong>QNI</strong></div><div class=\"col-md-2 text-left control-label\"><span>{{ call.qni }}</span></div></div><div class=\"form-group m-b-1\"><div class=\"col-md-2 text-right control-label p-l-0\"><strong>Relato do Atendimento</strong></div><div class=\"col-md-5 text-left control-label\"><span>{{ call.attendance_report || \"-\"}}</span></div></div></div><div class=col-md-12><h6>Deslocamento</h6><hr></div><div class=col-md-12><div class=\"form-group m-b-0\"><div ng-repeat=\"shift_hour in call.shift_hours\"><div class=\"col-md-2 text-right control-label\"><strong>{{ shift_hour.title }}</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ shift_hour.value || \"-\" }}</span></div></div><div class=\"col-md-12 row\"><div class=\"col-md-2 text-right control-label\"><strong>Destino </strong></div><div class=\"col-md-6 text-left control-label\"><span>{{ call.destination.name || \"-\"}}</span></div></div></div></div><div class=\"col-md-12 m-t-1\"><h6>Atendimento</h6><hr></div><div class=col-md-12><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right control-label\"><strong>Supervisor</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.supervisor.name }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>Médico</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.doctor.name }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>Enfermagem</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.nurse.name }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>Motorista</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.driver.name }}</span></div></div><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right control-label\"><strong>Operador</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.operator.name }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>Veiculo</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.vehicle.name }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>Diagnóstico</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.diagnosis.name || \"-\" }}</span></div><div class=\"col-md-1 text-right control-label\"><strong>QRL</strong></div><div class=\"col-md-1 text-left control-label\"><span>{{ call.qrl.name || \"-\" }}</span></div></div><div class=form-group><div class=\"col-md-2 text-right control-label\"><strong>Equipe </strong></div><div class=\"col-md-10 text-left control-label\"><span>{{ call.team.title || \"-\"}}</span></div></div></div><div ng-if=\"affiliate.contracts.length &lt;= 0 || affiliate.contracts.length &gt; 1\" class=col-md-12><h6>Financeiro</h6><hr></div><div class=col-md-12><div class=\"form-group m-b-0\"><div class=\"col-md-2 text-right control-label\"><strong ng-if=\"affiliate.contracts.length &gt; 1\">Plano </strong><strong ng-if=\"affiliate.contracts.length &lt;=  0\">Valor </strong></div><div class=col-md-8><form name=review_form><input type=text step=0.01 min=0 placeholder=\"Valor Atendimento\" ui-number-mask=2 ng-model=call.attendance_value ng-required=\"affiliate.contracts.length &lt;= 0\" ng-if=\"affiliate.contracts.length &lt;= 0\" class=\"form-control input-sm\"><ui-select ng-model=call.contract_rider_id ng-required=\"affiliate.contracts.length &gt; 1\" ng-if=\"affiliate.contracts.length &gt; 1\" class=form-group-sm><ui-select-match placeholder=\"Plano não informado\"><span ng-bind=$select.selected.contract_type_name></span></ui-select-match><ui-select-choices repeat=\"contract_rider.contract_rider_id as contract_rider in (affiliate.contracts | filter: $select.search) track by contract_rider.contract_rider_id\"><span ng-bind=contract_rider.contract_type_name></span></ui-select-choices></ui-select></form></div></div></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-xs-6 text-left\"><button type=button ng-click=reprove() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa fa-thumbs-o-down fa-fw\"></i>Reprovar</button> <button ng-click=approve() ng-disabled=review_form.$invalid class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa fa-thumbs-o-up fa-fw\"></i>Aprovar</button></div><div class=\"col-xs-6 text-right\"><button type=button ui-sref=\"show_call({id: call.id })\" class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa fa-eye fa-fw\"></i>Visualizar</button></div></div></div></div>");
$templateCache.put("app/calls/revision.html","<div class=row><div class=col-md-3><header class=p-b-1><h4 class=text-primary><i aria-hidden=true class=\"fa fa-binoculars fa-fw\"></i> Revisão</h4></header></div><div class=\"col-md-9 text-right form-group\"><button ui-sref=calls.index class=\"btn btn-info btn-sm\"><i class=\"fa fa-reply fa-fw\"></i>Voltar</button> <button type=button ng-click=CallsReproval() ng-disabled=!hasSelectedToReview() class=\"btn btn-danger btn-sm\"><i class=\"fa fa fa-thumbs-o-down fa-fw\"></i>Reprovar</button> <button ng-click=CallsApproval() ng-disabled=!hasSelectedToReview() class=\"btn btn-success btn-sm\"><i class=\"fa fa fa-thumbs-o-up fa-fw\"></i>Aprovar</button></div></div><div class=col-md-12><div class=row><mini-grid can-select=true columns=table_fields data=calls on-row-click=callReviewModal(id)></mini-grid></div></div>");
$templateCache.put("app/calls/search_address_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Procurar Endereco <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=searchAddress() class=form><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><div class=form-group><label class=\"control-label text-left\">Cidade<span class=text-danger>*</span></label><input type=text placeholder=\"Cidade não informada\" ng-model=call_address.city ng-required=true name=city class=form-control></div><div class=form-group><label class=\"control-label text-left\">Bairro<span class=text-danger>*</span></label><input type=text placeholder=\"Bairro não informado\" ng-model=call_address.neighborhood ng-required=true name=neighborhood class=form-control></div><div class=form-group><label class=\"control-label text-left\">Rua<span class=text-danger>*</span></label><input type=text placeholder=\"Rua não informada\" ng-model=call_address.street ng-required=true name=street class=form-control></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=submit ng-disabled=\"form.$invalid || searchingAddress\" class=\"btn btn-primary btn-sm\"><i ng-if=searchingAddress class=\"fa fa-spinner fa-pulse\"></i><i ng-if=!searchingAddress class=\"fa fa-map-marker fa-fw\"></i>Pesquisar</button></div></div></form></div>");
$templateCache.put("app/calls/show.html","<div class=\"container calls\"><div class=row><div class=\"col-md-12 p-t-0\"><header class=row><div class=\"col-md-2 col-sm-4 col-xs-12\"><h4 class=text-primary><a ui-sref=calls><i aria-hidden=true class=\"fa fa-ambulance\"></i> Chamadas</a> / {{\"#\"+call.id}}</h4></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><h4 ng-if=call.is_canceled>Chamada cancelada</h4><form name=form repeat=\"code.id as code in attendance_codes\" class=\"form form-horizontal\"><div style=margin-top:4px class=\"col-md-4 ui-select-custom p-r-0\"><ui-select ng-model=call.attendance_code_id append-to-body=true required ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match><div class=pull-left><span style=\"background: {{$select.selected.color}}\" class=code></span></div><span ng-bind=$select.selected.title class=m-l-1></span></ui-select-match><ui-select-choices repeat=\"code.id as code in (attendance_codes | filter: $select.search) track by code.id\"><span class=m-l-1>{{code.title }}</span><span style=\"background: {{code.color}}\" class=\"code pull-left\"></span></ui-select-choices></ui-select></div></form></div><div style=\"margin-top: 4px\" class=\"col-md-4 col-sm-4 col-xs-12 text-right\"><a ng-click=changeCallTitular() ng-if=\"!call.is_closed &amp;&amp; hasRole(\'edit_closed_calls\')\" class=\"btn btn-warning btn-sm m-r-1\"><i class=\"fa fa-pencil\"></i> Mudar Titularidade</a> <button ng-if=call.is_closed ng-really-click=reopenCall() ng-really-title=\"Reabrir Chamada {{&quot;#&quot;+call.id}}\" ng-really-sub-title=\"&lt;h4&gt;Informações da Chamada&lt;/h4&gt; Fechamento: {{call.close_time | date:&quot;dd/MM/yyyy&quot;}} / Cliente: {{ affiliate.client_name }} / Filiado {{ affiliate.name }} &lt;p&gt;Telefone Principal {{ call.phones[0] | tel }} &lt;/p&gt; \" ng-really-description=\"&lt;h4&gt;Informações do Solicitante&lt;/h4&gt; Nome {{ call.requestor }} / Telefone {{ call.requestor_phone  | tel}} / Valor {{ call.call_value }} &lt;p&gt;Endereço {{ call.address }}&lt;/p&gt; &lt;h4&gt;Tem certeza que deseja reabrir esta chamada?&lt;/h4&gt;\" ng-really-btn=\"Reabrir Chamada\" ng-really-btn-right-class=btn-primary class=\"btn btn-primary btn-sm m-r-1\"><i class=\"fa fa-medkit\"></i> Reabrir chamada</button><a ng-click=callHistory() class=\"btn btn-default btn-sm\"><i class=\"fa fa-history\"></i> Logs</a></div></header><form name=form class=\"form form-horizontal\"><div class=col-md-12><div class=row><div class=form-group><h2 class=background><span>Cliente</span></h2><label class=\"col-md-1 col-sm-1 control-label text-center\">Filiado</label><div class=\"col-md-2 text-left\"><input ng-model=affiliate.name disabled class=\"form-control font-weight-bold\"></div><label class=\"col-md-2 col-sm-1 control-label text-center\">Plano de Saúde</label><div class=\"col-md-2 text-left\"><label class=\"control-label font-weight-normal\">{{affiliate.affiliate_health_plan || \"-\"}}</label></div><label class=\"col-md-1 col-sm-1 control-label text-center\">Idade</label><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal\">{{ affiliate.age || \"0\" }}</label></div><label class=\"col-md-1 col-sm-1 control-label text-center\">Sexo</label><div class=\"col-md-1 text-left\"><label class=\"control-label font-weight-normal\">{{ affiliate.gender || \"-\"}}</label></div></div></div><div class=row><div class=form-group><div class=\"col-md-1 col-sm-1 text-right\"><label class=control-label>Abertura</label></div><div class=\"col-md-2 col-sm-2 text-right text-left\"><label class=\"control-label font-weight-normal\">{{call.created_at | date : \"dd/MM/yyyy HH:mm\"}}</label></div><div class=\"col-md-1 col-sm-1 text-right\"><label class=control-label>Cliente</label></div><div class=\"col-md-4 col-sm-4\"><input ng-model=affiliate.client_name ng-disabled=true class=form-control></div><label class=\"col-md-1 col-sm-2 control-label text-center\">Telefone(s)</label><div class=\"col-md-2 col-sm-4\"><div class=input-group><input type=text placeholder=\"Telefone não informado\" ng-model=first_phone ng-enter=updatePhone() ng-change=updatePhone() ng-model-options=\"{updateOn: \'blur\'}\" ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ui-br-phone-number=\"\" name=telephone required class=form-control><span class=input-group-btn><button type=button ng-click=phoneModal() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-phone\"></i></button></span></div></div></div><div class=row><div class=\"col-md-12 col-sm-12\"><div class=col-md-12><div role=alert class=\"alert text-center bg-primary visible-lg-block visible-md-block\"><div class=clearfix><div class=\"col-md-2 col-sm-3 col-xs-12 text-left\"><label class=\"control-label text-black d-block text-left\">Agravantes</label><label class=\"control-label font-weight-normal text-black p-t-0\"><div ng-repeat=\"disease in diseases\" ng-class=\"{\'last\':$last}\" class=disease>{{ disease.title }}</div></label></div><div class=\"col-md-10 col-sm-9 col-xs-12 text-left\"><label class=\"control-label text-black\">Observação</label><p style=\"word-break: break-all\" class=text-danger>{{affiliate.note || \"-\"}}</p></div></div></div></div></div></div></div></div><div class=col-md-12><div class=row><ul id=myTab class=\"nav nav-tabs p-b-1\"><li ng-class=\"{\'active\': panel==\'attendance\'}\"><a ng-click=\"panel = \'attendance\'\">Atendimento</a></li><li ng-class=\"{\'active\': panel==\'team\'}\"><a ng-click=\"panel = \'team\'\">Equipe</a></li><li ng-class=\"{\'active\': panel==\'info\'}\"><a ng-click=\"panel = \'info\'\">Informações</a></li><li ng-class=\"{\'active\': panel==\'last_calls\'}\" ng-show=\"last_calls.length &gt; 0\"><a ng-click=\"panel = \'last_calls\'\">Últimas chamadas</a></li></ul></div></div><div class=col-md-12><div class=row><div class=tab-content><div id=home ng-class=\"{\'active\': panel==\'info\'}\" class=tab-pane><div class=form-group><label class=\"col-md-1 control-label text-center\">Solicitante</label><div class=col-md-3><input type=text placeholder=\"Nome do solicitante\" ng-model=call.requestor ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><label class=\"col-md-1 control-label text-right\">Telefone</label><div class=col-md-3><input type=text placeholder=\"Telefone do solicitante\" ng-model=call.requestor_phone ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ui-br-phone-number=\"\" ng-change=checkPhone(call.requestor_phone) ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><div class=\"col-md-1 text-right\"><label class=control-label>Valor</label></div><div class=col-md-3><input type=text ng-model=call.call_value ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ui-number-mask=2 ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Paciente</label></div><div class=col-md-3><input type=text ng-model=call.patient ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><div class=\"col-md-1 text-right\"><label class=control-label>Motivo</label></div><div class=col-md-7><input type=text placeholder=\"Motivo não informado\" ng-model=call.reason ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Atendimento</label></div><div ng-class=\"{\'col-md-7\': call.is_canceled, \'col-md-11\': !call.is_canceled}\"><textarea rows=3 style=\"height: 87px\" ng-model=call.attendance_report ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" placeholder=\"Relato do Atendimento\" ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-control></textarea></div><div ng-if=call.is_canceled class=\"col-md-1 text-right\"><label class=control-label>Motivo Cancelamento</label></div><div ng-show=call.is_canceled class=col-md-3><textarea rows=3 style=\"height: 87px\" ng-model=call.cancel_reason ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></textarea></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Endereço</label></div><div class=col-md-7><textarea ng-model=call.address rows=5 ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></textarea></div></div></div><div id=attendances ng-class=\"{\'active\': panel==\'attendance\'}\" class=tab-pane><div ng-repeat=\"shift_hour in call.shift_hours\"><div ng-if=shiftHourFormat($index) class=\"col-md-4 form-group\"><label class=\"col-md-5 text-right control-label small\">{{shift_hour.title}}</label><div ng-if=\"!call.is_closed || hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0\"><input type=text ng-model=shift_hour.value ng-pattern=/^(?:2[0-3]|[01][0-9]):[0-5][0-9]$/ time-input=\"\" ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=\"updateShiftHours($index, shift_hour.value)\" ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><div ng-if=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0 control-label text-left\"><span class=p-t-0>{{ shift_hour.value || \"-\" }}</span></div></div><div ng-if=!shiftHourFormat($index) class=\"col-md-4 form-group\"><label class=\"col-md-5 text-right control-label small\">{{shift_hour.title}}</label><div ng-if=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0 control-label text-left\"><span class=p-t-0>{{ shift_hour.value || \"-\" }}</span></div><div ng-if=\"!call.is_closed || hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0\"><input type=text ng-model=shift_hour.value ng-pattern=/^(?:2[0-3]|[01][0-9]):[0-5][0-9]$/ time-input=\"\" ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=\"updateShiftHours($index, shift_hour.value)\" ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div></div><div class=col-md-12><div class=row><div class=\"col-md-4 form-group\"><label class=\"col-md-5 text-right control-label small\">Diagnóstico</label><div class=\"col-md-7 p-r-0\"><input type=text ng-model=call.diagnosis_code code-input=\"\" ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=selectDiagnosis() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control><span ng-show=call.diagnosis_name class=\"help-block text-primary\">{{call.diagnosis_name}}</span></div></div><div class=\"col-md-4 form-group\"><label class=\"col-md-5 text-right control-label small\"><span>QRL</span></label><div ng-if=\"!call.is_closed || hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0\"><ui-select ng-model=call.qrl_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"QRL não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"qrl.id as qrl in (qrls | filter: $select.search) track by qrl.id\"><span ng-bind=qrl.name></span></ui-select-choices></ui-select></div></div><div class=\"col-md-4 form-group\"><label class=\"col-md-5 control-label text-right\">QNI</label><div class=\"col-md-7 p-r-0\"><input ng-model=call.qni ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" ng-change=updateCall() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div></div><div class=row><div class=\"col-md-4 form-group\"><label class=\"col-md-5 text-right control-label small\"><span>Destino</span><span ng-show=\"!call.is_closed || hasRole(\'edit_closed_calls\')\" class=text-danger>*</span></label><div ng-if=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=\"col-md-7 control-label text-left p-r-0\"><span>{{ call.destination.name || \"-\"}}</span></div><div ng-if=\"!call.is_closed || hasRole(\'edit_closed_calls\')\" class=\"col-md-7 p-r-0\"><ui-select ng-model=call.destination_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Destino não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"destination.id as destination in (destinations | filter: $select.search) track by destination.id\"><span ng-bind=destination.name></span></ui-select-choices></ui-select></div></div></div></div></div><div id=teams ng-class=\"{\'active\': panel==\'team\'}\" class=tab-pane><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Supervisor</label></div><div class=col-md-3><ui-select ng-model=call.supervisor_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Supervisor não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"supervisor.id as supervisor in (team_users.supervisors | filter: $select.search) track by supervisor.id\"><span ng-bind=supervisor.name></span></ui-select-choices></ui-select></div><div class=\"col-md-1 text-right\"><label class=control-label>Médico</label></div><div class=col-md-3><ui-select ng-model=call.doctor_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Médico não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"doctor.id as doctor in (team_users.doctors | filter: $select.search) track by doctor.id\"><span ng-bind=doctor.name></span></ui-select-choices></ui-select></div><div class=\"col-md-1 text-right\"><label class=\"control-label text-right\">Enfermagem</label></div><div class=col-md-3><ui-select ng-model=call.nurse_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Enfermagem não informada\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"nurse.id as nurse in (team_users.nurses | filter: $select.search) track by nurse.id\"><span ng-bind=nurse.name></span></ui-select-choices></ui-select></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Motorista</label></div><div class=col-md-3><ui-select ng-model=call.driver_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Motorista não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"driver.id as driver in (team_users.drivers | filter: $select.search) track by driver.id\"><span ng-bind=driver.name></span></ui-select-choices></ui-select></div><div class=\"col-md-1 text-right\"><label class=control-label>Operador<span ng-hide=call.is_closed class=\"text-danger required_field\">*</span></label></div><div class=col-md-3><ui-select ng-model=call.operator_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" required class=form-group-sm><ui-select-match placeholder=\"Operador não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"operator.id as operator in (team_users.operators | filter: $select.search) track by operator.id\"><span ng-bind=operator.name></span></ui-select-choices></ui-select></div><div class=\"col-md-1 text-right\"><label class=control-label>Veículo</label></div><div class=col-md-3><ui-select ng-model=call.vehicle_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Veículo não informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"vehicle.id as vehicle in (vehicles | filter: $select.search) track by vehicle.id\"><span ng-bind=vehicle.name></span></ui-select-choices></ui-select></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Equipe</label></div><div class=col-md-3><ui-select ng-model=call.team_id ng-change=updateCall() ng-disabled=\"call.is_closed &amp;&amp; !hasRole(\'edit_closed_calls\')\" class=form-group-sm><ui-select-match placeholder=\"Equipe não informada\"><span ng-bind=$select.selected.title></span></ui-select-match><ui-select-choices repeat=\"team.id as team in (teams | filter: $select.search) track by team.id\"><span ng-bind=team.title></span></ui-select-choices></ui-select></div></div></div><div id=calls ng-class=\"{\'active\': panel==\'last_calls\'}\" class=tab-pane><div class=table-responsive><table class=\"table table-striped table-hover custom\"><thead><tr><th>Data de abertura</th><th>Motivo</th><th>Diagnóstico</th><th>Destino</th><th></th></tr></thead><tbody><tr ng-repeat=\"last_call in last_calls\"><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{last_call.created_at | date : \"dd/MM/yyyy HH:mm\" }}</a></td><td><a href=\"\" ng-click=\"openNewTab(\'/calls/\'+last_call.id)\">{{last_call.reason || \"-\" }}</a></td><td>{{last_call.diagnosis_name || \"-\"}}</td><td>{{last_call.destination_name || \"-\"}}</td><td></td></tr><tr><td colspan=5 ng-show=\"last_calls.length &gt; 0 &amp;&amp; !pagination.is_last_page\" ng-click=getLastCalls()><div class=text-center><label>Mostrar Mais</label></div></td></tr></tbody></table></div></div></div></div></div><div class=\"col-md-12 text-right\"><div class=row><button ng-click=cancelCallModal() ng-if=!call.is_closed type=button class=\"btn btn-danger btn-sm\"><i class=\"fa fa-exclamation-triangle\"></i> Cancelar Atendimento</button> <button ng-if=!call.is_closed ng-disabled=\"!canCloseCall() || form_erros\" ng-really-click=closeCall() ng-really-title=\"Concluir Atendimento {{&quot;#&quot;+call.id}}\" ng-really-sub-title=\"&lt;h4&gt;Informações da Chamada&lt;/h4&gt; Abertura: {{call.created_at | date:&quot;dd/MM/yyyy&quot;}} / Cliente: {{ affiliate.client_name }} / Filiado {{ affiliate.name }} &lt;p&gt;Telefone Principal {{ call.phones[0] | tel }} &lt;/p&gt; \" ng-really-description=\"&lt;h4&gt;Informações do Solicitante&lt;/h4&gt; Nome {{ call.requestor }} / Telefone {{ call.requestor_phone  | tel}} / Valor {{ call.call_value }} &lt;p&gt;Endereço {{ call.address }}&lt;/p&gt; &lt;h4&gt;Tem certeza que deseja concluir atendimento?&lt;/h4&gt;\" ng-really-btn=\"Concluir Atendimento\" ng-really-btn-right-class=btn-primary class=\"btn btn-primary btn-sm\"><i class=\"fa fa-medkit\"></i> Concluir Atendimento</button></div></div></form></div></div></div>");
$templateCache.put("app/ceps/index.html","<section class=container><div class=row><header class=col-md-9><h4 class=text-primary><a ui-sref=configuration><i aria-hidden=true class=\"fa fa-gear fa-fw\"></i> Configurações </a>/ Cadastro de CEP</h4></header><div class=col-md-3><a ng-click=newCep() class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo CEP</a></div></div><div class=\"col-md-12 p-t-2\"><div ng-if=\"ceps.length ==  0\" class=\"panel-body well\"><h5 class=text-center>Nenhum CEP cadastrado, <a ng-click=newCep() href=\"\" class=text-default>cadastrar novo CEP.</a></h5></div><table ng-if=\"ceps.length &gt; 0\" class=\"table table-striped table-hover custom\"><thead><tr><th>CEP</th><th>Cidade</th><th>Bairro</th><th>Endereço</th><th></th></tr></thead><tbody><tr ng-repeat=\"cep in ceps\"><td><a href=# editable-text=cep.cep_number buttons=no onshow=onFocusCep(cep) onaftersave=\"updateCep(cep, $index)\">{{cep.cep_number}}</a></td><td><a href=# editable-text=cep.city buttons=no onshow=onFocusCep(cep) onaftersave=\"updateCep(cep, $index)\">{{cep.city}}</a></td><td><a href=# editable-text=cep.neighborhood buttons=no onshow=onFocusCep(cep) onaftersave=\"updateCep(cep, $index)\">{{cep.neighborhood}}</a></td><td><a href=# editable-text=cep.street buttons=no onshow=onFocusCep(cep) onaftersave=\"updateCep(cep, $index)\">{{cep.street}}</a></td><td><a ng-really-click=\"removeCep($index, cep.id)\" href=\"\" ng-really-title=\"Remover CEP\" ng-really-sub-title=\"{{cep.cep_number}} - {{cep.city}} / {{cep.neighborhood}}\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></section>");
$templateCache.put("app/ceps/new.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Cadastrar Endereço <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=createCep() class=form><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><div ng-class=\"{ \'has-error\' : form.cep.$invalid &amp;&amp; !form.cep.$pristine }\" class=form-group><label class=\"control-label text-left\">Informe o CEP<span class=text-danger>*</span></label><div class=row><div class=col-md-9><input type=text placeholder=\"CEP não informado\" ng-model=cep.cep_number ui-br-cep-mask=\"\" ng-required=true name=cep class=form-control></div><div class=col-md-2><a ng-click=finderCep() class=\"btn-info btn-sm btn\"><i class=\"fa fa-search fa-fw\"></i>Pesquisar</a></div></div></div><div ng-class=\"{ \'has-error\' : form.city.$invalid &amp;&amp; !form.city.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Cidade<span class=text-danger>*</span></label><input type=text placeholder=\"Cidade não informada\" ng-model=cep.city ng-required=true name=city class=form-control></div><div ng-class=\"{ \'has-error\' : form.neighborhood.$invalid &amp;&amp; !form.neighborhood.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Bairro<span class=text-danger>*</span></label><input type=text placeholder=\"Bairro não informado\" ng-model=cep.neighborhood ng-required=true name=neighborhood class=form-control></div><div ng-class=\"{ \'has-error\' : form.street.$invalid &amp;&amp; !form.street.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Rua<span class=text-danger>*</span></label><input type=text placeholder=\"Endereço não informado\" ng-model=cep.street ng-required=true name=street class=form-control></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=submit ng-disabled=form.$invalid class=\"btn btn-success btn-sm\"><i class=\"fa fa-map-marker fa-fw\"></i>Confirmar</button></div></div></form></div>");
$templateCache.put("app/clients/affiliate_archive_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 style=\"text-align: center\" class=text-primary>Tem certeza que deseja remover este filiado? <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=\"row form-group\"><div class=col-md-12><div class=form-group><h4 style=\"text-align: center\" class=text-danger>Esta ação será irreversível!</h4></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-times\"></i> Cancelar</a><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check\"></i> Remover</a></div></div></div></div>");
$templateCache.put("app/clients/archive_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 style=\"text-align: center\" class=text-primary>Tem certeza que deseja remover este cliente? <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=\"row form-group\"><div class=col-md-12><div class=form-group><label class=control-label>Motivo da remoção:<span class=text-danger>* </span></label><textarea style=resize:none cols=2 placeholder=\"Motivo não informado\" ng-model=cancel_reason class=form-control>   </textarea></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-times\"></i> Cancelar</a><a ng-click=\"(!cancel_reason || cancel_reason.length &lt; 5) === true || ok()\" ng-disabled=\"!cancel_reason || cancel_reason.length &lt; 5\" class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check\"></i> Remover</a></div></div></div></div>");
$templateCache.put("app/clients/index.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header><div class=\"col-md-5 p-l-0\"><h4 class=text-primary><i class=\"fa fa-id-card-o fa-fw\"></i> Clientes</h4></div><div class=col-md-7><div class=\"col-md-4 m-t-8px\"><div dropdown=\"\" class=\"btn-group dropdown\"><label class=ui-checkbox><input type=checkbox ng-model=client_active ng-change=searchClient()><span>Ativos</span></label><label class=ui-checkbox><input type=checkbox ng-model=client_inactive ng-change=searchClient()><span>Inativos</span></label></div></div><div class=col-md-5><div class=input-group><input type=text placeholder=\"Pesquise clientes pelo nome do cliente ou filiado\" ng-model=search ng-enter=searchClient() class=form-control><span class=input-group-btn><button type=button ng-click=searchClient() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-3><a ui-sref=new_client class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Novo cliente</a></div></div></header><div class=col-md-12><div ng-show=load_clients class=row><div class=\"col-md-12 text-center p-t-2\"><h3><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h3></div></div><div ng-hide=load_clients class=row><div class=table-responsive><table class=\"table table-striped table-hover table-fixed\"><thead><tr><th ng-click=\"orderBy(\'name\')\" class=w-50percent>Cliente<i ng-if=\"last_field_order == \'name\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_contracts\')\" class=w-5percent>Planos<i ng-if=\"last_field_order == \'qtd_contracts\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_affiliates\')\" class=w-5percent>Filiados<i ng-if=\"last_field_order == \'qtd_affiliates\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_active_affiliates\')\" class=w-10percent>Filiados Ativos<i ng-if=\"last_field_order == \'qtd_active_affiliates\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_disactive_affiliates\')\" class=w-10percent>Filiados Inativos<i ng-if=\"last_field_order == \'qtd_disactive_affiliates\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'active\')\" class=w-10percent>Situação<i ng-if=\"last_field_order == \'active\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th></tr></thead><tbody><tr ng-repeat=\"client in clients track by $index\"><td><a href=\"\" ui-sref=\"show_client({id: client.id})\" uib-popover=\"{{ client.name }}\" popover-trigger=mouseenter type=button>{{client.name}}</a></td><td>{{client.qtd_contracts || \"0\"}}</td><td>{{client.qtd_affiliates || \"0\"}}</td><td>{{client.qtd_active_affiliates || \"0\"}}</td><td>{{client.qtd_disactive_affiliates || \"0\"}}</td><td><label class=\"switch switch-success small\"><input type=checkbox checked ng-change=\"toggleActive(client.id, $index)\" ng-model=client.active><i></i></label></td><td type=button style=\"text-align: right\" ng-click=\"archiveModal(client, $index)\" ng-if=!client.active class=\"button i fa fa-trash delete\"></td></tr></tbody></table></div></div><div ng-if=\"clients.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=totalItems ng-model=pagination.page max-size=maxSize boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></section>");
$templateCache.put("app/clients/new.html","<div class=\"container client\"><div class=row><div class=\"col-md-12 p-t-0\"><header class=\"col-md-12 p-l-0 p-b-1\"><h4 class=text-primary><a ui-sref=clients><i class=\"fa fa-id-card-o fa-fw\"></i> Clientes</a>/ Novo cliente {{variavel}}</h4></header><form name=form ng-submit=addClient() novalidate class=\"form form-horizontal\"><div class=\"steps ng-scope\"><div class=\"panel-body ng-scope\"><div class=row><div class=col-xs-3><div id=first_step ng-class=\"{\'current-step\': step == 1}\" class=step-sign><p>1.<small class=ng-binding>Informações básicas</small></p></div></div><div class=col-xs-3><div id=second_step ng-class=\"{\'current-step\': step == 2}\" class=step-sign><p>2.<small class=ng-binding>Endereços</small></p></div></div><div class=\"col-xs-3 p-r-0\"><div id=third_step ng-class=\"{\'current-step\': step == 3}\" class=step-sign><p>3.<small class=ng-binding>Telefones e e-mails</small></p></div></div></div></div><div class=\"form-group step ng-isolate-scope current\"><section><div ng-show=\"step==1\" class=\"panel-body ng-scope\"><div class=form-group><label for=\"\" class=\"col-xs-2 control-label ng-binding\">Tipo cliente<div class=\"text-danger pull-right\">*</div></label><div class=col-md-7><label class=ui-radio><input type=radio ng-model=client.client_type value=legal><span>Pessoa Jurídica</span></label><label class=ui-radio><input type=radio ng-model=client.client_type value=person><span>Pessoa Física</span></label></div></div><div class=form-group><label for=\"\" class=\"col-xs-2 control-label ng-binding\">Data de Nascimento</label><div class=col-md-7><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=client.birth_date is-open=popup3.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open3() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div ng-show=\"sellers.length &gt; 0\" class=form-group><label for=\"\" class=\"col-xs-2 control-label ng-binding\">Vendedor</label><div class=col-md-7><ui-select ng-model=client.seller_id><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"seller.id as seller in (sellers | filter: $select.search) track by seller.id\"><span ng-bind=seller.name></span></ui-select-choices></ui-select></div></div><div class=form-group><label ng-show=\"client.client_type==\'legal\'\" class=\"col-xs-2 control-label ng-binding\">Nome Fantasia<div class=\"text-danger pull-right\">*</div></label><label ng-show=\"client.client_type==\'person\'\" class=\"col-xs-2 control-label ng-binding\">Nome<div class=\"text-danger pull-right\">*</div></label><div class=col-xs-7><input id=client_name required type=text ng-model=client.name class=\"form-control ng-pristine ng-invalid ng-invalid-required ng-touched\"></div></div><div ng-show=\"client.client_type==\'legal\'\" class=form-group><label class=\"col-xs-2 control-label ng-binding\">Razão Social<div class=\"text-danger pull-right\">*</div></label><div class=col-xs-7><input id=client_social ng-model=client.social ng-required=\"client.client_type==\'legal\'\" type=text class=\"form-control ng-pristine ng-invalid ng-invalid-required ng-touched\"></div></div><div class=form-group><label ng-show=\"client.client_type==\'legal\'\" class=\"col-xs-2 control-label ng-binding\">CNPJ<div class=\"text-danger pull-right\">*</div></label><label ng-show=\"client.client_type==\'person\'\" class=\"col-xs-2 control-label ng-binding\">CPF<div class=\"text-danger pull-right\">*</div></label><div class=col-xs-7><input id=client_social_revenue data-ng-model=client.document name=legal required type=text ui-br-cpfcnpj-mask=\"\" ng-change=check_cpf() class=form-control></div></div><div class=form-group><label class=\"col-xs-2 control-label ng-binding\">Número Contrato<div class=\"text-danger pull-right\">*</div></label><div class=col-xs-7><input id=client_social_revenue data-ng-model=client.membership_card_prefix name=legal required type=number class=form-control></div></div><div class=row><div class=\"col-xs-9 text-right\"><a ui-sref=clients type=button class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-reply fa-fw\"></i> Voltar</a> <button ng-disabled=\"form.$invalid || !cpf_available\" ng-click=\"goToStep(\'2\')\" type=button class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-arrow-right fa-fw\"></i> Próximo</button></div></div></div></section><section ng-show=\"step==2\"><div class=\"panel-body ng-scope\"><div class=\"col-md-2 m-b-1\"><a ng-click=newCep() class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo Endereço</a></div><div class=row><div ng-show=\"client.client_addresses_attributes.length &gt; 0\" class=col-md-12><div class=table-responsive><div class=\"col-md-9 p-r-0\"><table class=\"table table-striped table-hover custom\"><thead><tr><th>CEP</th><th>Cidade</th><th>Bairro</th><th>Endereço</th><th>Número</th><th>Complemento</th><th>Ponto de Referência</th><th>Tipo</th><th></th></tr></thead><tbody><tr ng-repeat=\"address in client.client_addresses_attributes track by $index\"><td>{{address.cep }}</td><td>{{address.city}}</td><td>{{address.neighborhood}}</td><td>{{address.street}}</td><td>{{address.number}}</td><td>{{address.complement}}</td><td>{{address.landmark}}</td><td>{{address_type[address.goal]}}</td><td class=text-right><a ng-click=removeAddress($index) href=\"\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-xs-9 text-right\"><a type=button ng-click=\"goToStep(\'1\')\" class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-reply fa-fw\"></i> Voltar</a> <button ng-click=\"goToStep(\'3\')\" type=button class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-arrow-right fa-fw\"></i> Próximo</button></div></div></div></section><section ng-show=\"step==3\"><div class=\"panel-body ng-scope\"><div class=table-responsive><div class=\"col-md-10 p-r-0\"><div class=form-group><label ng-class=\"{ \'text-danger\' : form.email.$invalid }\" class=\"col-md-2 control-label text-center\">E-mail</label><div class=col-md-3><div ng-class=\"{ \'has-error\' : form.email.$invalid &amp;&amp; !form.email.$pristine }\" class=form-group><div class=\"input-group p-b-1\"><input type=email placeholder=\"E-mail não informado\" ng-model=email name=email ng-enter=addEmail(email) class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addEmail(email) ng-disabled=\"form.email.$invalid &amp;&amp; !form.email.$pristine || email.length  == 0\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Adicionar</button></span></div></div><div class=\"row form-group\"><table class=\"table table-striped table-hover\"><tr ng-repeat=\"e in client.emails track by $index\"><td>{{e}}</td><td><a ng-click=removeEmail($index) class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></table></div></div><label ng-class=\"{ \'text-danger\' : form.phone.$invalid }\" class=\"col-md-2 control-label text-center\">Número<span class=text-danger>*</span></label><div class=col-md-3><div ng-class=\"{ \'has-error\' : form.phone.$invalid &amp;&amp; !form.phone.$pristine }\" class=form-group><div class=\"input-group p-b-1\"><input type=text placeholder=\"Número não informado\" ng-model=phone ui-br-phone-number=\"\" ng-enter=addPhone(phone) name=phone class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addPhone(phone) ng-disabled=\"form.phone.$invalid &amp;&amp; !form.phone.$pristine || phone.length  == 0\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Adicionar</button></span></div></div><div class=\"row form-group\"><table class=\"table table-striped table-hover\"><tr ng-repeat=\"e in client.phones track by $index\"><td>{{ e | tel }}</td><td class=text-right><a ng-click=removePhone($index) href=\"\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></table></div></div></div></div></div><div class=row><div class=\"col-xs-9 text-right\"><a ng-click=\"goToStep(\'2\')\" type=button class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-reply fa-fw\"></i> Voltar</a> <button ng-disabled=\" client.phones.length &lt;= 0\" type=submit class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-heartbeat fa-fw\"></i> Concluir</button></div></div></div></section></div></div></form></div></div></div><div style=\"height: 200px\"></div>");
$templateCache.put("app/clients/new_address_affiliate_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Cadastrar Endereço <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=createAffiliateAddress() class=form><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><div ng-class=\"{ \'has-error\' : form.cep.$invalid &amp;&amp; !form.cep.$pristine }\" class=form-group><label class=\"control-label text-left\">Informe o CEP<span class=text-danger>*</span></label><div class=row><div class=col-md-9><input type=text placeholder=\"CEP não informado\" ng-model=affiliate.affiliate_address.cep ui-br-cep-mask=\"\" ng-required=true name=cep class=form-control></div><div class=col-md-2><a ng-click=getAffiliateCep() class=\"btn-info btn-sm btn\"><i class=\"fa fa-search fa-fw\"></i>Pesquisar</a></div></div></div><div ng-class=\"{ \'has-error\' : form.city.$invalid &amp;&amp; !form.city.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Cidade<span class=text-danger>*</span></label><input type=text placeholder=\"Cidade não informada\" ng-model=affiliate.affiliate_address.city ng-required=true name=city class=form-control></div><div ng-class=\"{ \'has-error\' : form.neighborhood.$invalid &amp;&amp; !form.neighborhood.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Bairro<span class=text-danger>*</span></label><input type=text placeholder=\"Bairro não informado\" ng-model=affiliate.affiliate_address.neighborhood ng-required=true name=neighborhood class=form-control></div><div ng-class=\"{ \'has-error\' : form.street.$invalid &amp;&amp; !form.street.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Rua<span class=text-danger>*</span></label><input type=text placeholder=\"Rua não informada\" ng-model=affiliate.affiliate_address.street ng-required=true name=street class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Número<span class=text-danger></span></label><input type=text placeholder=\"Número não informado\" ng-model=affiliate.affiliate_address.number class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Complemento<span class=text-danger></span></label><input type=text placeholder=\"Complemento não informado\" ng-model=affiliate.affiliate_address.complement class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Ponto de referência<span class=text-danger></span></label><input type=text placeholder=\"Ponto de referência não informado\" ng-model=affiliate.affiliate_address.landmark class=form-control></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=submit ng-disabled=form.$invalid class=\"btn btn-success btn-sm\"><i class=\"fa fa-map-marker fa-fw\"></i>Confirmar</button></div></div></form></div>");
$templateCache.put("app/clients/new_address_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Cadastrar Endereço <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=createCep() class=form><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><div ng-class=\"{ \'has-error\' : form.cep.$invalid &amp;&amp; !form.cep.$pristine }\" class=form-group><label class=\"control-label text-left\">Informe o CEP<span class=text-danger>*</span></label><div class=row><div class=col-md-9><input type=text placeholder=\"CEP não informado\" ng-model=client_address.cep ui-br-cep-mask=\"\" ng-required=true name=cep class=form-control></div><div class=col-md-2><a ng-click=finderCep() class=\"btn-info btn-sm btn\"><i class=\"fa fa-search fa-fw\"></i>Pesquisar</a></div></div></div><div ng-class=\"{ \'has-error\' : form.city.$invalid &amp;&amp; !form.city.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Cidade<span class=text-danger>*</span></label><input type=text placeholder=\"Cidade não informada\" ng-model=client_address.city ng-required=true name=city class=form-control></div><div ng-class=\"{ \'has-error\' : form.neighborhood.$invalid &amp;&amp; !form.neighborhood.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Bairro<span class=text-danger>*</span></label><input type=text placeholder=\"Bairro não informado\" ng-model=client_address.neighborhood ng-required=true name=neighborhood class=form-control></div><div ng-class=\"{ \'has-error\' : form.street.$invalid &amp;&amp; !form.street.$pristine }\" ng-show=load_cep class=form-group><label class=\"control-label text-left\">Rua<span class=text-danger>*</span></label><input type=text placeholder=\"Rua não informada\" ng-model=client_address.street ng-required=true name=street class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Número<span class=text-danger></span></label><input type=text placeholder=\"Número não informado\" ng-model=client_address.number class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Complemento<span class=text-danger></span></label><input type=text placeholder=\"Complemento não informado\" ng-model=client_address.complement class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label text-left\">Ponto de referência<span class=text-danger></span></label><input type=text placeholder=\"Ponto de referência não informado\" ng-model=client_address.landmark class=form-control></div><div ng-show=load_cep class=form-group><label class=\"control-label d-block text-left\">Tipo<span class=text-danger>*</span></label><label class=ui-radio><input type=radio ng-model=client_address.goal name=address_goal value=document required><span>Documento</span></label><label class=ui-radio><input type=radio ng-model=client_address.goal name=address_goal value=attendance required><span>Atendimento</span></label><label class=ui-radio><input type=radio ng-model=client_address.goal name=address_goal value=both required><span>Ambos</span></label></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=submit ng-disabled=form.$invalid class=\"btn btn-success btn-sm\"><i class=\"fa fa-map-marker fa-fw\"></i>Confirmar</button></div></div></form></div>");
$templateCache.put("app/clients/new_affiliate.html","<div class=modal-content><div class=modal-fade><header class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4 ng-if=!affiliate.id class=ng-binding>Novo Filiado</h4><h4 ng-if=affiliate.id class=ng-binding>Filiado<span ng-if=!affiliate.active>{{\" Inativo\"}}</span></h4></div></div></header><form name=form ng-submit=createAffiliate() ng-show=\"modal_type == \'affiliate\'\" class=\"form form-horizontal\"><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><div class=form-group><label class=\"col-sm-2 control-label\"></label><div class=col-md-4><label class=ui-checkbox><input type=checkbox ng-model=affiliate.dependent ng-change=clearHolder(affiliate)><span>Dependente</span></label></div><div ng-show=affiliate.dependent class=\"col-sm-5 text-right m-t-m10px\"><ui-select ng-model=affiliate.holder_id ng-required=affiliate.dependent><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"holder.id as holder in (holders | filter: $select.search) track by holder.id\"><span ng-bind=holder.name></span></ui-select-choices></ui-select></div></div><div class=form-group><div class=\"col-sm-2 text-right\"><label class=control-label>Data Cadastro<span class=text-danger>*</span></label></div><div class=col-sm-4><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=affiliate.created_at is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats ng-focus=open2() placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"col-sm-2 control-label\">Nome<span class=text-danger>*</span></label><div placeholder=\"Nome não informado\" class=\"col-sm-9 text-left\"><input type=text placeholder=\"Nome não informado\" ng-model=affiliate.name ng-required=true class=form-control></div></div><div class=form-group><div class=\"col-sm-2 text-right\"><label class=control-label>Data de Nasc.<span class=text-danger>*</span></label></div><div class=col-sm-4><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=affiliate.birth_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats ng-focus=open1() placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true required class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-sm-1 text-right\"><label class=control-label>Gênero<span class=text-danger>*</span></label></div><div class=\"col-sm-4 m-t-1\"><label class=ui-radio><input type=radio ng-model=affiliate.gender name=gender value=male required><span>Masculino</span></label><label class=ui-radio><input type=radio ng-model=affiliate.gender name=gender value=female required><span>Feminino</span></label></div></div><div class=form-group><label ng-class=\"{ \'has-error\' : form.affiliate_cpf.$invalid &amp;&amp; !form.affiliate_cpf.$pristine }\" class=\"col-sm-2 control-label text-center\">CPF</label><div class=col-sm-4><input type=text placeholder=\"CPF não informado\" ng-model=affiliate.cpf ui-br-cpf-mask=\"\" name=affiliate_cpf ng-change=getAffiliateByCPF() class=form-control></div><label class=\"col-sm-1 control-label text-center\">RG</label><div class=col-sm-4><input type=text placeholder=\"RG não informado\" ng-model=affiliate.rg class=form-control></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Telefone<span class=text-danger>*</span></label><div class=col-sm-4><div ng-class=\"{ \'has-error\' : form.newPhone.$invalid &amp;&amp; !form.newPhone.$pristine }\"><div class=\"input-group p-b-1\"><input type=text placeholder=\"Número não informado\" ng-model=newPhone ng-enter=addAffiliatePhone(newPhone) ui-br-phone-number=\"\" name=newPhone class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addAffiliatePhone(newPhone) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></span></div></div><div class=form-group><div ng-repeat=\"phone in affiliate.phones track by $index\" class=row><div class=\"col-md-8 text-center\"><p>{{ phone | tel }}</p></div><div class=col-md-4><i ng-click=removeAffiliatePhone($index) href=\"\" class=\"fa fa-trash-o\"></i></div></div></div></div></div><div ng-class=\"{ \'has-error\' : form.affiliate_email.$invalid &amp;&amp; !form.affiliate_email.$pristine }\" class=form-group><label class=\"col-sm-2 control-label text-center\">E-mail</label><div class=col-sm-9><tags-input ng-model=affiliate_emails name=affiliate.email placeholder=\"Adicionar email\" allowed-tags-pattern=^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+.)+[A-Za-z]{2,4} min-length=4 add-on-space=true ng-blur=updateAffiliateEmails()></tags-input></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Endereço<span class=text-danger>*</span></label><div class=col-sm-9><div ng-if=affiliate.affiliate_address><a ng-click=createAffiliateAddressModal() href=\"\"><span>{{affiliate.affiliate_address.street + \" \" +(affiliate.affiliate_address.number || \"-\") }}</span><br><span>CEP: {{ (affiliate.affiliate_address.cep | cep ) || \"-\" }} - Bairro: {{ affiliate.affiliate_address.neighborhood }} - {{ affiliate.affiliate_address.city }}</span><br><span>Próximo: {{ (affiliate.affiliate_address.landmark || \"-\") }}</span><br><span>Complemento: {{ (affiliate.affiliate_address.complement || \"-\") }}</span></a></div><div ng-if=!affiliate.affiliate_address><a ng-click=createAffiliateAddressModal() href=\"\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i>Adicionar enderecço</a></div></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Plano de Saúde</label><div class=col-sm-3><ui-select ng-model=affiliate.health_plan_id ng-change=updateAffiliatePlan()><ui-select-match><span ng-bind=$select.selected.title></span></ui-select-match><ui-select-choices repeat=\"health_plan.id as health_plan in (health_plans | filter: $select.search) track by health_plan.id\"><span ng-bind=health_plan.title></span></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Agravantes</label><div class=col-sm-6><ui-select multiple ng-model=affiliate.diseases close-on-select=false title=\"Adicionar agravantes\"><ui-select-match placeholder=\"Adicionar agravantes\"><span>{{$item.title}}</span></ui-select-match><ui-select-choices repeat=\"disease.id as disease in diseases  | filter: $select.search\"><span>{{disease.title}}</span></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Observação</label><div class=col-sm-6><textarea style=resize:none cols=3 rows=10 placeholder=\"Observação não informado\" ng-model=affiliate.note class=form-control></textarea></div></div><div ng-hide=\"affiliate_emails.length == 0\" class=form-group><label class=\"col-sm-2 control-label\"></label><div class=col-md-4><label class=ui-checkbox><input type=checkbox ng-model=affiliate.send_call_emails ng-disabled=\"affiliate_emails.length == 0\"><span>Receber e-mails de atendimento</span></label></div></div><div ng-if=!affiliate.active class=form-group><label class=\"col-sm-2 control-label text-center\">Motivo Cancelamento</label><div class=col-sm-6><textarea style=resize:none cols=2 placeholder=\"\" ng-model=affiliate.inactivate_reason disabled class=form-control></textarea></div></div></div></div></div></div></div><div class=modal-footer><!--.alert.alert-danger(role=\'alert\')--><div class=\"col-xs-12 text-left\"><span ng-show=showFindCPF class=\"help-block text-info big\"><a href=\"\" ui-sref=\"show_client({id: another_cliente.id})\">*CPF encontrato em filiado {{ affiliate_is_active ? \"(Ativo)\" : \"(Inativo)\"}} do cliente {{ another_cliente.name || \"\" }}</a></span><span ng-show=has_duplicate_cpf class=\"help-block text-info big\"><a href=\"\" ui-sref=\"show_client({id: another_cliente.id})\">*CPF encontrato neste mesmo cliente.</a></span></div><div class=\"col-xs-12 text-right\"><button type=button ng-show=\"affiliate.id &amp;&amp; affiliate.active\" ng-click=\"setModalType(\'inactivate\')\" class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Inativar</button> <button type=button ng-show=\"affiliate.id &amp;&amp; !affiliate.active\" ng-click=\"setModalType(\'activate\')\" class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-thumbs-o-up fa-fw\"></i>Ativar</button> <button ng-disabled=\"form.$invalid || !affiliate.affiliate_address\" class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-id-card-o fa-fw\"></i>Confirmar</button> <button type=button ng-show=showFindCPF ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Cancelar</button></div></div></form><div ng-if=\"modal_type == \'inactivate\'\"><div class=\"modal-body p-t-0\"><div class=\"row form-group\"><div class=col-sm-3><label class=control-label>Data do cancelamento<span class=text-danger>*</span></label></div><div class=col-sm-3><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=inactivate_form.inactivate_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA ng-required=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=row><div class=form-group><div class=col-sm-3><label class=control-label>Motivo cancelamento<span class=text-danger>*</span></label></div><div class=col-sm-8><textarea style=resize:none cols=2 placeholder=\"Motivo não informado\" ng-model=inactivate_form.inactivate_reason class=form-control></textarea></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button type=button ng-click=\"setModalType(\'affiliate\')\" class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Cancelar</button> <button type=button ng-click=inactivateAffiliate(inactivate_form) ng-disabled=\"!inactivate_form.inactivate_date || !inactivate_form.inactivate_reason\" class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-id-card-o fa-fw\"></i>Confirmar</button></div></div></div><div ng-if=\"modal_type == \'activate\'\"><div class=\"modal-body p-t-0\"><div class=row><div class=form-group><h2 class=text-center>Você tem certeza?</h2></div></div><div class=row><div class=form-group><div class=col-sm-3><label class=control-label>Motivo cancelamento<span class=text-danger>*</span></label></div><div class=col-sm-8><textarea style=resize:none cols=2 placeholder=\"Motivo não informado\" ng-model=affiliate.inactivate_reason disabled class=form-control></textarea></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button type=button ng-click=\"setModalType(\'affiliate\')\" class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Cancelar</button> <button type=button ng-click=activateAffiliate() class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-id-card-o fa-fw\"></i>Confirmar</button></div></div></div></div></div>");
$templateCache.put("app/clients/new_affiliate_actions_modal.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Aviso <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form class=form><div class=\"modal-body p-t-0\"><div class=row><div class=col-md-12><div><div class=p-t-1><p>O CPF informado está atrelado a um filiado do cliente {{ another_affiliate.client.name }}</p><div class=form-group><p><strong>Para cadastrar o filiado é necessário Inativar</strong><br>o Filiado {{ another_affiliate.name }}<br>do cliente: {{ another_affiliate.client.name }}</p></div><div class=form-group><label class=control-label>Data do cancelamento<span class=text-danger>*</span></label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=inactivate_form.inactivate_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA ng-required=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=form-group><label class=control-label>Motivo cancelamento<span class=text-danger>*</span></label><textarea style=resize:none cols=2 placeholder=\"Motivo não informado\" ng-model=inactivate_form.inactivate_reason class=form-control></textarea></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button type=submit class=\"btn btn-default btn-sm\">Cancelar</button> <button type=button ng-click=inactivateAffiliate(inactivate_form) ng-disabled=\"!inactivate_form.inactivate_date || !inactivate_form.inactivate_reason\" class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-check fa-fw\"></i>Inativar</button></div></div></form></div>");
$templateCache.put("app/clients/open_has_duplicate_cpf_another_client_modal.html","<div class=modal-content><div class=modal-fade><header class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4>*CPF encontrato em filiado {{ affiliate_is_active ? \"(Ativo)\" : \"(Inativo)\"}} do cliente {{ another_cliente.name || \"\" }}</h4></div></div><div class=\"modal-body p-t-0\"><p>Encontrado no filiado {{duplicate_affiliate.name}}</p></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button ng-click=duplicateAffiliate(duplicate_affiliate) class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-id-card-o fa-fw\"></i>Duplicar</button> <button ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Cancelar</button></div></div></header></div></div>");
$templateCache.put("app/clients/open_has_duplicate_cpf_modal.html","<div class=modal-content><div class=modal-fade><header class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4>*CPF encontrato neste mesmo cliente.</h4></div></div><div class=\"modal-body p-t-0\"><p>Encontrado no filiado {{duplicate_affiliate.name}}</p></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button ng-click=editDuplicateAffiliate(duplicate_affiliate) class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-id-card-o fa-fw\"></i>Confirmar</button> <button ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-window-close fa-fw\"></i>Cancelar</button></div></div></header></div></div>");
$templateCache.put("app/clients/show.html","<section class=container><header><div class=\"col-md-12 p-l-0 p-r-0\"><h4><a ui-sref=clients><i class=\"fa fa-id-card-o fa-fw\"></i> Clientes</a>/<strong>{{client.name}}</strong><div class=\"col-md-2 pull-right\"><a ui-sref=\"new_contract({client_id: client.id})\" class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Novo Plano</a></div></h4></div></header><div class=\"row p-t-2\"><div class=\"col-md-12 form-group\"><div class=col-sm-5><label class=d-block>Nome</label><input required type=text ng-model=client.name ng-change=updateClient() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><div ng-if=\"client.client_type == person\" class=col-sm-2><label class=ng-binding>Razão Social</label><a href=# class=\"text-info d-block\">{{client.social}}</a></div><div class=col-sm-2><label class=d-block>Tipo de cliente</label>{{client_types[client.client_type]}}</div><div class=col-sm-2><label class=d-block>{{document_type[client.client_type]}}</label><input id=client_social_revenue data-ng-model=client.document name=legal required type=text ui-br-cpfcnpj-mask=\"\" ng-change=updateClient() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div><div class=col-sm-2><label class=\"ng-binding d-block\">Status</label><label class=\"switch switch-success\"><input type=checkbox checked ng-change=\"toggleActive(client.id, index)\" ng-model=client.active class=\"ng-pristine ng-untouched ng-valid ng-scope\"><i></i></label></div></div><div class=\"col-md-12 form-group\"><div class=col-md-3><label for=\"\" class=d-block>Vendedor</label><div class=\"col-md-12 p-l-0\"><ui-select ng-model=client.seller_id ng-change=updateClient()><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"seller.id as seller in (sellers | filter: $select.search) track by seller.id\"><span ng-bind=seller.name></span></ui-select-choices></ui-select></div></div><div class=col-md-2><label for=\"\" class=d-block>Data de Nascimento</label><div class=input-group><input type=text ng-change=updateClient() uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=client.birth_date is-open=popup3.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats ng-focus=open3() placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open3() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-md-2><label for=\"\" class=d-block>Número Contrato</label><div class=input-group><input type=number ng-change=updateClient() ng-model=client.membership_card_prefix class=\"form-control input-sm\"></div></div></div></div><div class=col-md-12><div class=row><ul class=\"nav nav-tabs p-b-1 p-t-1\"><li ng-class=\"{\'active\': panel==\'phones\'}\"><a ng-click=\"panel=\'phones\'\"><i class=\"fa fa-phone\"></i> Telefones</a></li><li ng-class=\"{\'active\': panel==\'emails\'}\"><a ng-click=\"panel=\'emails\'\"><i class=\"fa fa-envelope-o\"></i> E-mails</a></li><li ng-class=\"{\'active\': panel==\'address\'}\"><a ng-click=\"panel=\'address\'\"><i class=\"fa fa-road\"></i> Endereços</a></li><li ng-class=\"{\'active\': panel==\'affiliate\'}\"><a ng-click=\"panel=\'affiliate\'\"><i class=\"fa fa-users\"></i> Filiados</a></li></ul><form name=form class=\"tab-content form-horizontal\"><div id=tel ng-class=\"{\'active\': panel==\'phones\'}\" class=tab-pane><div ng-class=\"{ \'has-error\' : form.newPhone.$invalid &amp;&amp; !form.newPhone.$pristine }\" class=form-group><label class=\"col-md-1 control-label text-center\">Número<span class=\"text-danger required_field\">*</span></label><div class=col-md-3><div class=\"input-group p-b-1\"><input type=text placeholder=\"Número não informado\" ng-model=newPhone ng-enter=addPhone(newPhone) ui-br-phone-number=\"\" name=newPhone class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addPhone(newPhone) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></span></div></div></div><div ng-show=\"client.phones.length &gt; 0\" class=\"col-md-6 col-sm-12\"><div class=table-responsive><table class=\"table table-condensed table-striped table-hover custom\"><thead><th>Número</th><th></th></thead><tbody><tr ng-repeat=\"phone in client.phones track by $index\"><td><p class=m-b-0>{{ phone | tel }}</p></td><td class=text-right><button class=\"btn btn-sm btn-link\"><i ng-click=removePhone($index) class=\"fa fa-trash-o d-block\"></i></button></td></tr></tbody></table></div></div></div><div id=messages ng-class=\"{\'active\': panel==\'emails\'}\" class=tab-pane><div ng-class=\"{ \'has-error\' : form.newEmail.$invalid &amp;&amp; !form.newEmail.$pristine }\" class=form-group><label class=\"col-md-1 control-label text-center\">Email</label><div class=col-md-3><div class=\"input-group p-b-1\"><input type=email placeholder=\"E-mail não informado\" ng-model=newEmail ng-enter=addEmail(newEmail) name=newEmail class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addEmail(newEmail) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></span></div></div></div><div ng-if=\"client.emails.length &gt; 0\" class=\"col-md-6 col-sm-12\"><div class=table-responsive><table class=\"table table-condensed table-striped table-hover custom\"><thead><th>Email</th><th></th></thead><tbody><tr ng-repeat=\"email in client.emails track by $index\"><td><p class=m-b-0>{{ email }}</p></td><td class=text-right><button class=\"btn btn-sm btn-link\"><i ng-click=removeEmail($index) class=\"fa fa-trash-o d-block\"></i></button></td></tr></tbody></table></div></div></div><div id=address ng-class=\"{\'active\': panel==\'address\'}\" class=tab-pane><div class=\"col-md-2 m-b-1\"><a ng-click=newCep() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-plus\"></i> Novo Endereço</a></div><div ng-show=\"client.client_addresses.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover custom\"><thead><tr><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"address in client.client_addresses track by $index\"><td><a ng-click=editAddress(address) href=\"\"><span>{{ (address_type[address.goal] || \"-\") }}</span><br><span>{{address.street + \" \" +(address.number || \"-\") }}</span><br><span>CEP: {{ (address.cep | cep ) || \"-\" }} - Bairro: {{ address.neighborhood }} - {{ address.city }}</span><br><span>Próximo: {{ (address.landmark || \"-\") }}</span><br><span>Complemento: {{ (address.complement || \"-\") }}</span></a></td><td><a ng-click=\"removeAddress(address.id, $index)\" href=\"\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div></div><div id=affiliate ng-class=\"{\'active\': panel==\'affiliate\'}\" class=tab-pane><div class=table-responsive><div class=col-md-12><div class=clearfix><a type=button ng-click=newAffiliate() ng-class=\"{\'pull-left\': client.affiliates.length == 0}\" class=\"btn btn-primary btn-sm pull-right\"><i class=\"fa fa-plus\"></i> Novo Filiado</a></div><table ng-if=\"client.affiliates.length &gt; 0\" class=\"table table-striped table-hover affiliates_table custom\"><thead><tr><th width=40% ng-click=\"getAffiliates(\'name\')\">Nome<i ng-if=\"last_field_order == \'name\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"getAffiliates(\'birth_date\')\">Data de Nascimento<i ng-if=\"last_field_order == \'birth_date\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"getAffiliates(\'membership_card\')\">Carterinha<i ng-if=\"last_field_order == \'membership_card\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"getAffiliates(\'status_description\')\">Situação<i ng-if=\"last_field_order == \'status_description\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"getAffiliates(\'inactivate_date\')\">Data de Inativação<i ng-if=\"last_field_order == \'inactivate_date\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th ng-click=\"getAffiliates(\'created_at\')\">Data de Cadastro<i ng-if=\"last_field_order == \'created_at\'\" ng-class=\"{\'fa-chevron-up\': direction==\'asc\', \'fa-chevron-down\': direction==\'desc\'}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"affiliate in client.affiliates\"><td width=40% ng-click=\"editAffiliate(affiliate, $index, null)\">{{affiliate.name || \" - \"}}</td><td>{{affiliate.birth_date | date : \"dd/MM/yyyy\" || \" - \"}}</td><td>{{affiliate.membership_card || \" - \"}}</td><td>{{affiliate.status_description || \" - \"}}</td><td><span ng-if=!affiliate.active>{{affiliate.inactivate_date | date : \"dd/MM/yyyy\" || \" - \"}}</span><span ng-if=affiliate.active></span></td><td>{{affiliate.created_at | date : \"dd/MM/yyyy\" || \" - \"}}</td><td type=button style=\"text-align: right\" ng-click=\"affiliateArchiveModal(affiliate, $index)\" ng-if=!affiliate.active class=\"button i fa fa-trash delete\"></td></tr></tbody></table></div></div></div></form></div></div></section>");
$templateCache.put("app/configuration/index.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><i aria-hidden=true class=\"fa fa-gear fa-fw\"></i> Configurações</h4></header><div ng-show=\"hasRole(\'manage_teams\') ||  hasRole(\'manage_calls\')\" class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-stethoscope fa-fw\"></i><span class=text-uppercase>Atendimento</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'manage_teams\')\" class=\"border-none border-radius-none\"><a ui-sref=teams class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-users\"></i> Equipes</a></li><li ng-show=\"hasRole(\'manage_calls\')\" class=\"border-none border-radius-none\"><a ui-sref=reviews class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-clock-o\"></i> Revisão</a></li><li ng-show=\"hasRole(\'manage_attendance_codes\')\" class=\"border-none border-radius-none\"><a ui-sref=attendance_codes class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-check-square\"></i> Códigos</a></li><li class=\"border-none border-radius-none\"><a ui-sref=diagnoses class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-clipboard\"></i> Diagnósticos</a></li><li class=\"border-none border-radius-none\"><a ui-sref=qrls class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-ellipsis-v\"></i> QRLs</a></li></ul></div><div ng-show=\"hasRole(\'manage_shift_hours\') || hasRole(\'manage_destinations\') || hasRole(\'manage_vehicles\')\" class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-ambulance fa-fw\"></i><span class=text-uppercase>Deslocamento</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'manage_shift_hours\')\" class=\"border-none border-radius-none\"><a ui-sref=shift_hours class=\"btn border-radius-none border-none ng-binding\"><i aria-hidden=true class=\"fa fa-clock-o\"></i> Tipo de hora de deslocamento</a></li><li ng-show=\"hasRole(\'manage_destinations\')\" class=\"border-none border-radius-none\"><a ui-sref=destinations class=\"btn border-radius-none border-none ng-binding\"><i aria-hidden=true class=\"fa fa-location-arrow\"></i> Cadastro de Destino</a></li><li ng-show=\"hasRole(\'manage_vehicles\')\" class=\"border-none border-radius-none\"><a ui-sref=vehicles class=\"btn border-radius-none border-none\"><i aria-hidden=true class=\"fa fa-ambulance\"></i><span class=ng-binding>Veículos</span></a></li></ul></div><div class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-users fa-fw\"></i><span class=text-uppercase>Usuários</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'manage_users\')\" class=\"border-none border-radius-none\"><a ui-sref=users class=\"btn border-radius-none border-none ng-binding\"><i aria-hidden=true class=\"fa fa-users\"></i> Usuários</a></li><li ng-show=\"hasRole(\'manage_role_group\')\" class=\"border-none border-radius-none\"><a ui-sref=role_groups class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-unlock-alt\"></i> Grupo de Permissões</a></li><li class=\"border-none border-radius-none\"><a ui-sref=profile class=\"btn border-radius-none border-none\"><i aria-hidden=true class=\"fa fa-user-md\"></i> Meu perfil</a></li></ul></div><div ng-show=\"hasRole(\'manage_contract_types\') ||  hasRole(\'manage_notifications\') || hasRole(\'manage_role_groups\') || hasRole(\'manage_health_plan\')\" class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-cubes fa-fw\"></i><span class=text-uppercase>Geral</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'manage_notifications\')\" class=\"border-none border-radius-none\"><a ui-sref=notifications class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-paper-plane\"></i> Notificações</a></li><li ng-show=\"hasRole(\'manage_contract_types\')\" class=\"border-none border-radius-none\"><a ui-sref=contract_types class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-handshake-o\"></i> Tipo de plano</a></li><li class=\"border-none border-radius-none\"><a ui-sref=diseases class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-yelp\"></i> Agravantes</a></li><li class=\"border-none border-radius-none\"><a ui-sref=health_plans class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-warning\"></i> Planos de saúde</a></li></ul></div></div></div></section>");
$templateCache.put("app/contract_types/index.html","<section class=container><div class=row><header><div class=col-md-4><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Tipo de plano</h4></div><form name=form ng-submit=addContractType() class=\"col-md-8 form-horizontal m-t-6px\"><div class=\"form-group m-b-0\"><label class=\"col-md-2 control-label\">Tipo de plano<span class=\"text-danger required_field\">*</span></label><div class=col-md-3><select ng-model=new_contract_type._type required class=form-control><option value=\"\" selected disabled>Tipo não selecionado</option><option value=free>Livre</option><option value=group>Compartilhado</option><option value=single>Individual com taxa</option><option value=single_free>Individual livre</option></select></div><label class=\"col-md-1 control-label text-right\">Nome<span class=\"text-danger required_field\">*</span></label><div class=col-md-4><input type=text ng-model=new_contract_type.name placeholder=\"Nome não informado\" required class=form-control></div><div class=col-md-2><button ng-disabled=form.$invalid class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Salvar</button></div></div></form></header></div><div class=\"col-md-12 p-t-2\"><div class=row><div class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Nome</th><th>Tipo</th><th></th></tr></thead><tbody><tr ng-repeat=\"contract_type in contract_types\"><td><a ng-click=editContract(contract_type) href=\"\">{{contract_type.name}}</a></td><td><a ng-click=editContract(contract_type) href=\"\">{{all_types[contract_type._type]}}</a></td><td><a ng-really-click=\"deleteContractType($index, contract_type.id)\" href=\"\" ng-really-title=\"Remover tipo de contrato {{ contract_type.name }}\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div></section>");
$templateCache.put("app/contract_types/modalEdit.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Editar <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-5\"><div class=row><div class=col-md-2></div><form name=form ng-submit=saveContract() class=col-md-8><div class=\"form-group m-b-0\"><label class=\"col-md-12 control-label\">Tipo de plano <span class=text-danger>*</span></label><div class=col-md-12><select ng-model=new_contract_type._type required class=form-control><option value=\"\" selected disabled>Tipo não selecionado</option><option value=free>Livre</option><option value=group>Compartilhado</option><option value=single>Individual com taxa</option><option value=single_free>Individual livre</option></select></div><label class=\"col-md-12 p-t-1 control-label\">Nome <span class=text-danger>*</span></label><div class=col-md-12><input type=text ng-model=new_contract_type.name placeholder=\"Nome não informado\" required class=form-control></div><div class=\"col-md-4 m-t-10 pull-right\"><button class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Salvar</button></div></div></form></div></div></div>");
$templateCache.put("app/contracts/add_rider.html","<div class=modal-fade><div class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4>Gerar adendo <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=addRider() class=\"form form-horizontal\"><div class=\"modal-body p-t-0\"><div class=\"row small\"><div class=col-md-12><div class=\"col-md-12 p-l-0\"><div class=p-t-1><div class=form-group><label class=\"col-sm-4 control-label text-right\">Adendo<span class=text-danger>*</span></label><div class=\"col-sm-8 text-left\"><select ng-model=new_rider.rider_type required ng-change=clearValues() class=form-control><option value=\"\" selected disabled>Tipo de adendo selecionado</option><option value=due>No vencimento</option><option value=during>Durante vigência do contrato</option></select></div></div><div ng-if=\"new_rider.rider_type==\'due\'\" class=form-group><label class=\"col-sm-4 control-label text-right\">Duração<span class=text-danger>*</span></label><div placeholder=\"Duração não informada\" class=\"col-sm-8 text-left\"><input type=number ng-required=\"new_rider.rider_type==\'due\'\" ng-model=new_rider.duration class=form-control></div></div><div ng-if=\"new_rider.rider_type==\'during\'\" class=form-group><label class=\"col-sm-4 control-label text-right\">Data de início<span class=text-danger>*</span></label><div class=\"col-sm-8 text-left\"><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=new_rider.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div ng-if=\"contract.contract_type._type != &quot;single&quot; &amp;&amp; contract.contract_type._type != &quot;single_free&quot;\" class=form-group><div class=\"col-sm-4 text-right\"><label class=control-label>Valor contrato<span class=text-danger>*</span></label></div><div class=\"col-sm-8 text-left\"><div class=input-group><span class=\"input-group-addon ng-binding input-sm\">R$</span> <input type=text ng-required=\"selected_contract_type._type != &quot;single&quot; &amp;&amp; selected_contract_type._type != &quot;single_free&quot;\" ng-model=new_rider.billing_cycle_value ui-number-mask=2 class=form-control></div></div></div><div ng-if=\"contract.contract_type._type != \'free\'\" class=form-group><div class=\"col-sm-4 text-right\"><label class=control-label>Filiados</label></div><div class=\"col-sm-8 text-left\"><ui-select ng-model=rider_new_affiliate ng-change=\"riderAddAffiliate($select.selected, $select)\" ng-if=\"contract.contract_type._type== \'single_free\' ||  contract.contract_type._type== \'group\' || contract.contract_type._type== \'single\'\"><ui-select-match allow-clear=true placeholder=\"Selecione o Filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"affiliate.id as affiliate in (rider_affiliates | filter: $select.search) track by affiliate.id\"><span ng-bind=affiliate.name></span></ui-select-choices></ui-select></div></div><div ng-if=\"contract.contract_type._type != \'free\'\" class=form-group><div class=\"col-sm-12 text-left\"><table ng-if=\"contract.contract_type._type == \'group\' || contract.contract_type._type == \'single\' || contract.contract_type._type == \'single_free\' \" class=\"table table-striped table-hover custom\"><thead><tr><th>Nome</th><th ng-if=\"contract.contract_type._type==\'single\' || contract.contract_type._type==\'single_free\'\">Valor contrato</th><th ng-if=\"contract.contract_type._type!=\'single_free\'\">Quantidade Chamadas</th><th ng-if=\"contract.contract_type._type==\'single\'\">Valor chamada excedente</th><th></th></tr></thead><tbody><tr ng-repeat=\"affiliate in new_rider.contract_rider_affiliates_hash track by $index\"><td>{{ affiliate.name }}</td><td ng-if=\"contract.contract_type._type != \'single\' &amp;&amp; contract.contract_type._type != \'single_free\' \">{{ current_rider.qtd_calls }}</td><td ng-if=\"contract.contract_type._type==\'single\' || contract.contract_type._type==\'single_free\'\"><input type=text ng-required=\"contract.contract_type._type==\'single\' || contract.contract_type._type==\'single_free\'\" ng-model=affiliate.billing_cycle_value ui-number-mask=2 class=form-control></td><td ng-if=\"contract.contract_type._type==\'single\'\"><input type=number ng-required=\"contract.contract_type._type==\'single\'\" ng-model=affiliate.qtd_calls class=form-control></td><td ng-if=\"contract.contract_type._type==\'single\'\"><input type=text ng-required=\"contract.contract_type._type==\'single\'\" ng-model=affiliate.additional_call ui-number-mask=2 class=form-control></td><td><a href=\"\" ng-if=\"contract.contract_type._type == \'group\' || contract.contract_type._type == \'single\' || contract.contract_type._type == \'single_free\' \" ng-click=\"riderRemoveAffiliate($index, affiliate)\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button ng-disabled=form.$invalid class=\"btn btn-primary btn-sm\"><i class=\"fa fa-handshake-o fa-fw\"></i> Confirmação</button></div></div></form></div>");
$templateCache.put("app/contracts/cancel_contract.html","<div class=modal-fade><div class=\"modal-header border-modal-btn custom\"><div class=row><div class=col-xs-12><h4>Cancelar contrato <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><form name=form ng-submit=riderCancelContract() class=\"form form-horizontal\"><div class=\"modal-body p-t-0\"><div class=\"row small\"><div class=col-md-12><div class=\"col-md-12 p-l-0\"><div class=p-t-1><div class=form-group><label class=\"col-sm-4 control-label text-right\">Data de cancelamento<span class=text-danger>*</span></label><div class=\"col-sm-8 text-left\"><div class=input-group><input type=text uib-datepicker-popup=dd/MM/yyyy ng-model=new_rider.expiration_date is-open=opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar name=expiration_date ng-focus=\"opened=true\" required ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=\"opened=true\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"col-sm-4 control-label text-right\">Motivo de cancelamento<span class=text-danger>*</span></label><div class=\"col-sm-8 text-left\"><textarea rows=3 ng-model=new_rider.cancel_reason placeholder=\"Motivo não informado\" required class=form-control></textarea></div></div></div></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right\"><button ng-disabled=form.$invalid class=\"btn btn-primary ng-binding btn-sm\"><i class=\"fa fa-handshake-o\"></i>Confirmação</button></div></div></form></div>");
$templateCache.put("app/contracts/index.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header><div class=row><div class=col-md-5><h4 class=text-primary><i class=\"fa fa-handshake-o\"></i>Planos</h4></div><div class=col-md-7><div class=col-md-5><div class=input-group><input type=text placeholder=Pesquisar ng-model=filter.query ng-enter=searchContracts() class=form-control><span class=input-group-btn><button type=button ng-click=searchContracts() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-md-4 m-t-8px\"><div dropdown=\"\" class=\"btn-group dropdown\"><label class=ui-checkbox><input type=checkbox ng-model=filter.active ng-change=searchContracts()><span>Ativos</span></label><label class=ui-checkbox><input type=checkbox ng-model=filter.inactive ng-change=searchContracts()><span>Inativos</span></label></div></div><div class=col-md-3><a ui-sref=new_contract class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Novo plano</a></div></div></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=table-responsive><table class=\"table table-striped table-hover custom\"><thead><tr><th class=w-15percent>Plano</th><th class=w-45percent>Cliente</th><th class=w-10percent>Qtd. Filiados</th><th class=w-10percent>Número contrato</th><th class=w-10percent>Cobrança</th><th class=w-10percent>Data de expiração</th><th></th></tr></thead><tbody><tr ng-repeat=\"contract in contracts track by $index\"><td><a href=\"\" ui-sref=\"show_contract({id: contract.id})\">{{ contract.contract_type_name }}</a></td><td><a href=\"\" ui-sref=\"show_contract({id: contract.id})\" uib-popover=\"{{ contract.client_name }}\" popover-trigger=mouseenter type=button>{{contract.client_name}}</a></td><td><a href=\"\" ui-sref=\"show_contract({id: contract.id})\">{{ contract.qtd_affiliates || \"0\" }}</a></td><td>{{contract.contract_number}}</td><td>{{all_types[contract.contract_type_type]}}</td><td>{{contract.expiration_date | date:\'dd/MM/yyyy\' }}</td><td><a ng-really-click=\"removeContract(contract.id, $index)\" ng-really-description=\"&lt;h4&gt;Você tem certeza?&lt;/h4&gt;\" ng-really-title=\"Remover contrato\" ng-hide=contract.is_billed class=\"cursor-hand onHover\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"contracts.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></section>");
$templateCache.put("app/contracts/new.html","<div class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=\"col-md-12 p-l-0 p-b-1\"><h4 class=text-primary><a ui-sref=contracts><i class=\"fa fa-fa fa-handshake-o\"></i> Planos</a> / {{ page_title }}</h4></header><form name=form ng-submit=saveContract() class=\"form form-horizontal\"><div class=col-md-12><div class=row><div class=\"form-group text-right\"><label class=\"col-md-2 control-label\">Tipo de plano<span class=\"text-danger required_field\">*</span></label><div class=col-md-3><ui-select ng-model=contract.contract_type_id required ng-change=setContractType($select.selected)><ui-select-match placeholder=\"Tipo de Contrato não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"contract_type.id as contract_type in (contract_types | filter: $select.search) track by contract_type.id\"><span ng-bind=contract_type.name></span></ui-select-choices></ui-select></div><div class=\"col-md-2 text-right\"><label class=control-label>Cliente</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><ui-select ng-model=contract.client_id required ng-change=getAffiliates($select.selected.id)><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select><span ng-if=contract.client_id class=\"help-block text-left\"><span style=\"padding-right: 5px\">Cliente selecionado possui</span><span ng-show=!loadAffiliates>{{ total_affiliates }}</span><span ng-show=loadAffiliates><i class=\"fa fa-spinner fa-pulse\"></i></span><span style=\"padding-left: 5px\">filiado(s) ativo(s)</span></span></div></div><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Data de Início</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=contract_rider.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats ng-change=checkDate(contract_rider.start_date) placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true required class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div><span class=help-block>Dia não pode ser maior que 28</span></div><div class=\"col-md-2 text-right\"><label ng-class=\"{ \'text-danger\' : form.duration.$invalid &amp;&amp; !form.duration.$pristine }\" class=control-label>Duração</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><div class=input-group><input type=number placeholder=\"\" ng-model=contract_rider.duration min=0 required name=duration class=form-control><span class=\"input-group-addon input-sm\">MESES</span></div></div></div><div class=form-group><div class=\"col-md-2 text-right\"><label ng-class=\"{ \'text-danger\' : form.due_day.$invalid &amp;&amp; !form.due_day.$pristine }\" class=control-label>Dia de vencimento</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><input type=number min=0 max=31 ng-model=contract_rider.due_day required name=due_day class=form-control></div><div class=\"col-md-2 text-right\"><label class=control-label>Número de Contrato</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><input type=text plcaholder=\"Nome do contrato\" ng-model=contract.contract_number required class=form-control></div></div><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Ciclo de faturamento</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><select ng-model=contract_rider.billing_cicle required class=form-control><option value=\"\" selected disabled>Tipo não selecionado</option><option value=1>Mensal</option><option value=2>Bimestral</option><option value=3>Trimestral</option><option value=6>Semestral</option><option value=12>Anual</option></select></div><div class=\"col-md-2 text-right\"><label class=control-label>Faturamento</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><select required ng-model=contract_rider.billing_type class=form-control><option value=\"\" selected disabled>Faturamento não selecionado</option><option value=before>Antecipado</option><option value=after>Posterior</option></select></div></div><div ng-if=\"selected_contract_type._type != &quot;single&quot; &amp;&amp; selected_contract_type._type != &quot;single_free&quot;\" class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Valor contrato</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><input type=text min=0 placeholder=\"Valor não informado\" ng-model=contract_rider.billing_cycle_value ng-required=\"selected_contract_type._type != &quot;single&quot; &amp;&amp; selected_contract_type._type != &quot;single_free&quot;\" name=billing_cycle_value ui-number-mask=2 class=form-control></div></div><div class=form-group><div ng-if=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'group\'\" class=\"col-md-2 text-right\"><label class=control-label>Ciclo de fechamento</label><span ng-if=\"selected_contract_type._type == &quot;single&quot; || selected_contract_type._type == &quot;group&quot;\" class=\"text-danger required_field\">*</span></div><div ng-if=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'group\'\" class=col-md-3><select ng-model=contract_rider.closing_cicle ng-required=\"selected_contract_type._type == &quot;single&quot; || selected_contract_type._type == &quot;group&quot;\" class=form-control><option value=\"\" selected disabled>Tipo não selecionado</option><option value=1>Mensal</option><option value=2>Bimestral</option><option value=3>Trimestral</option><option value=6>Semestral</option><option value=12>Anual</option></select></div><div class=\"col-md-2 text-right\"><label class=control-label>Forma de Pagamento</label><span class=\"text-danger required_field\">*</span></div><div class=col-md-3><select ng-model=contract_rider.payment_method required class=form-control><option value=\"\" selected disabled>Método não selecionado</option><option value=bill>Boleto</option><option value=notification>Carnê</option><option value=card>Cartão</option><option value=bank_check>Cheque</option><option value=money>Dinheiro</option><option value=discount_in_pay>Desconto em folha</option><option value=deposit>Depósito em conta</option><option value=permutation>Permuta</option></select></div></div><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Observação</label></div><div class=col-md-5><textarea style=resize:none rows=3 placeholder=\"Observação não informada\" ng-model=contract_rider.note class=form-control></textarea></div></div><div ng-if=\"(selected_contract_type._type == &quot;single&quot; || selected_contract_type._type == &quot;single_free&quot; || selected_contract_type._type == &quot;group&quot;) &amp;&amp; (affiliates.length &gt; 0 || contract_rider_affiliates.length &gt; 0 )\" class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Filiados</label><span class=\"text-danger required_field\">*</span></div><div class=\"col-md-6 p-r-0 p-l-0\"><div class=col-sm-6><ui-select ng-model=new_affiliate ng-change=\"addAffiliate($select.selected, $select)\" ng-disabled=\"affiliates.length == 0\" ng-required=\"(selected_contract_type._type == &quot;single&quot; || selected_contract_type._type == &quot;single_free&quot; || selected_contract_type._type == &quot;group&quot;) &amp;&amp; contract_rider_affiliates.length == 0\"><ui-select-match allow-clear=true placeholder=\"Selecione o Filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"affiliate.id as affiliate in (affiliates | filter: $select.search | orderBy:&quot;name&quot;) track by affiliate.id\"><span ng-bind=affiliate.name></span></ui-select-choices></ui-select></div><div class=col-sm-3><div class=input-group><button type=button ng-click=addAllAffiliates() ng-disabled=\"affiliates.length == 0\" class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus fa-fw\"></i> Todos</button> <button type=button ng-click=removeAllAffiliates() ng-disabled=\"contract_rider_affiliates.length == 0\" class=\"btn btn-danger btn-sm btn-block\"><i class=\"fa fa-trash-o fa-fw\"></i> Limpar Todos</button></div></div></div></div><div ng-if=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'single_free\' || (affiliates.length &gt; 0 || contract_rider_affiliates.length &gt; 0 )\" class=\"row form-group\"><div class=\"col-md-10 text-right max-table-height\"><table class=\"table table-striped\"><thead><tr><th>Filiado</th><th ng-if=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'single_free\' \">Valor contrato</th><th ng-hide=\"selected_contract_type._type == \'single_free\' || selected_contract_type._type == \'group\'\">Chamadas</th><th ng-hide=\"selected_contract_type._type == \'single_free\' || selected_contract_type._type == \'group\'\">Valor chamada excedente</th><th></th></tr></thead><tbody><tr ng-repeat=\"affiliate in contract_rider_affiliates | orderBy:&quot;name&quot;\"><td align=left><span>{{affiliate.name}}</span><span style=\"padding: 0 10px\">Aniversário: {{affiliate.birth_date | date:\'dd/MM/yyyy\' }}</span><span ng-if=affiliate.birth_date>Idade: {{affiliate.birth_date | ageFilter }}</span></td><td ng-if=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'single_free\'\"><input type=text step=0.01 placeholder=\"Valor contrato\" ng-model=affiliate.billing_cycle_value ng-required=\"selected_contract_type._type == \'single\' || selected_contract_type._type == \'single_free\'\" ui-number-mask=2 class=form-control></td><td ng-hide=\"selected_contract_type._type == \'single_free\' || selected_contract_type._type == \'group\'\"><input type=number min=0 placeholder=Quantidade ng-model=affiliate.qtd_calls ng-required=\"selected_contract_type._type == &quot;single&quot;\" class=form-control></td><td ng-hide=\"selected_contract_type._type == \'single_free\' || selected_contract_type._type == \'group\'\"><input type=text step=0.01 placeholder=\"Valor adicional\" ng-model=affiliate.additional_call ng-required=\"selected_contract_type._type == \'single\'\" ui-number-mask=2 class=form-control></td><td><a href=\"\" ng-click=\"removeAffiliate($index, affiliate)\" class=\"btn btn-link btn-sm text-primary\"><i style=\"visibility: visible\" class=\"fa fa-trash-o d-block\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"selected_contract_type._type == &quot;group&quot;\" class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Quantidade de Chamadas</label><span ng-if=\"selected_contract_type._type == \'group\'\" class=\"text-danger required_field\">*</span></div><div class=col-md-3><input type=number placeholder=\"Quantidade de chamadas\" ng-model=contract_rider.qtd_calls ng-required=\"selected_contract_type._type == \'group\'\" class=form-control></div><div class=\"col-md-2 text-right\"><label class=control-label>Valor chamada adicional</label><span ng-if=\"selected_contract_type._type == \'group\'\" class=\"text-danger required_field\">*</span></div><div class=col-md-3><input type=text step=0.01 placeholder=\"Valor chamada adicional\" ng-model=contract_rider.additional_call ng-required=\"selected_contract_type._type == \'group\'\" ui-number-mask=2 class=form-control></div></div><div class=form-group><div class=\"col-md-10 text-right p-r-0\"><button ng-disabled=form.$invalid style=\"margin-right: 7px\" class=\"btn btn-sm btn-primary\"><i aria-hidden=true class=\"fa fa-floppy-o\"></i> Salvar Plano</button></div></div></div></div></form></div></div></div>");
$templateCache.put("app/contracts/show.html","<section class=container><header><h4><a ui-sref=contracts href=\"\"><i class=\"fa fa-handshake-o fa-fw\"></i> Planos</a> / {{ contract.contract_type.name }}<small><span>(</span><span ng-if=\"!contract.is_active &amp;&amp; !contract.is_cancelled\">INATIVO</span><span ng-if=\"contract.is_active &amp;&amp; !contract.is_cancelled\">ATIVO</span><span ng-if=contract.is_cancelled class=text-danger>CANCELADO</span><span>)</span></small><div uib-dropdown=\"\" class=btn-group><button id=split-button type=button class=\"btn btn-primary btn-sm\">{{\"Adendo \"+current_rider.rider+\".\"+current_rider.release}}</button> <button type=button uib-dropdown-toggle=\"\" style=\"width: 40px\" class=\"btn btn-primary btn-sm\"><span class=caret></span><span class=sr-only>Split button!</span></button><ul uib-dropdown-menu=\"\" role=menu aria-labelledby=split-button class=dropdown-menu><li ng-repeat=\"rider in rider_releases\"><a ng-click=getRider(rider.id) href=\"\">{{\"Adendo \"+rider.rider+\".\"+rider.release}}</a></li></ul></div></h4></header><div class=\"row p-t-2\"><div class=\"col-sm-2 form-group\"><label>Plano</label><p>{{ contract.contract_type.name }}</p></div><div class=\"col-sm-4 form-group\"><label>Cliente</label><p>{{ contract.client.name }}</p></div><div class=\"col-sm-2 form-group\"><label ng-class=\"{\'bg-warning\': valueChanged(\'start_date\')}\">Data de início</label><p>{{current_rider.start_date | date : \"dd/MM/yyyy\"}}</p></div><div class=\"col-sm-2 form-group\"><label ng-class=\"{\'bg-warning\': (valueChanged(\'cancel_date\') ||valueChanged(\'duration\') )}\">Data de expiração</label><p>{{current_rider.expiration_date | date : \"dd/MM/yyyy\"}}<small class=d-block>{{\"(Duração \"+current_rider.duration+\" meses)\"}}</small></p></div><div class=\"col-sm-2 form-group\"><label>Número do contrato</label><p>{{ contract.contract_number }}</p></div></div><div class=\"row p-t-2\"><div class=\"col-sm-2 form-group\"><label ng-class=\"{bg_warning: valueChanged(\'billing_cycle_value\')}\">Valor contrato</label><p>{{ current_rider.billing_cycle_value | currency }}</p></div><div class=\"col-sm-2 form-group\"><label>Faturamento</label><p>{{billing_types[current_rider.billing_type]}}</p></div><div class=\"col-sm-2 form-group\"><label>Ciclo de faturamento</label><p>{{cicles[current_rider.billing_cicle]}}</p></div><div ng-if=\"contract.contract_type._type != \'single_free\'\" class=\"col-sm-2 form-group\"><label>Ciclo de fechamento</label><p>{{cicles[current_rider.closing_cicle]}}</p></div><div class=\"col-sm-2 form-group\"><label>Usuário</label><p>{{current_rider.user_name}}</p></div><div ng-show=current_rider.payment_method class=\"col-sm-2 form-group\"><label>Forma de Pagamento</label><p>{{ translatePaymentMethod[current_rider.payment_method] }}</p></div></div><div class=\"row p-t-2\"><div ng-show=\"contract.contract_type._type == \'group\'\" class=\"col-sm-2 form-group\"><label ng-class=\"{bg_warning: valueChanged(\'max_equipments\')}\">Chamadas de direito</label><p>{{current_rider.qtd_calls || \"-\" }}</p></div><div ng-show=\"contract.contract_type._type == \'group\'\" class=\"col-sm-2 form-group\"><label ng-class=\"{bg_warning: valueChanged(\'additional_equipment_value\')}\">Valor de chamada adicional</label><p>{{ (current_rider.additional_call | currency) || \"-\" }}</p></div><div class=\"col-sm-2 form-group\"><label>Última atualização</label><p>{{current_rider.updated_at | date : \"dd/MM/yyyy\"}}</p></div><div class=\"col-sm-6 form-group\"><label class=\"text-danger d-block\">Observação</label><p class=\"font-weight-bold white-space-pre-line text-danger\">{{ current_rider.note || \"-\" }}</p></div><div ng-show=contract.is_cancelled class=\"col-md-4 form-group\"><label class=\"text-danger d-block\">Motivo de Cancelamento</label><p class=\"font-weight-bold white-space-pre-line text-danger\">{{ current_rider.cancel_reason || \"-\" }}</p></div></div><div class=\"row p-b-1\"><div class=col-md-12><div class=pull-left><button ng-if=current_rider.is_last_rider ng-really-click=removeLastRider() ng-really-title=\"Remover último adendo\" ng-really-sub-title=\"Tem certeza que deseja remover o {{\'Adendo \'+current_rider.rider+\'.\'+current_rider.release}}? \" class=\"btn btn-sm btn-danger ng-isolate-scope\"><div class=\"fa fa-times\"></div>Remover último adendo</button></div><div class=pull-right><button ng-click=editContract() ng-if=!contract.is_cancelled class=\"btn btn-warning btn-sm\"><i class=\"fa fa-pencil fa-fw\"></i>Editar contrato</button> <button ng-really-click=removeContract() ng-if=!contract.is_cancelled class=\"btn btn-danger btn-sm\">Deletar contrato</button> <button ng-click=cancelContract() ng-if=!contract.is_cancelled class=\"btn btn-danger btn-sm\">Cancelar contrato</button> <button ng-click=addRiderModal() ng-if=!contract.is_cancelled class=\"btn btn-info btn-sm\"><div class=\"fa fa-pencil\"></div>Gerar Adendo</button></div></div></div><div class=col-md-12><div class=row><ul id=myTab class=\"nav nav-tabs p-b-1 p-t-1\"><li ng-show=\"contract.contract_type._type == \'group\' || contract.contract_type._type == \'single\' || contract.contract_type._type == \'single_free\'\" ng-class=\"{\'active\': panel==\'affiliates\'}\"><a ng-click=\"panel = \'affiliates\'\">Filiados</a></li><li ng-class=\"{\'active\': panel==\'notifications\'}\"><a ng-click=\"panel = \'notifications\'\">Notificações</a></li><li ng-class=\"{\'active\': panel==\'files\'}\"><a ng-click=\"panel = \'files\'\">Arquivos</a></li></ul><div class=\"tab-content form-horizontal\"><div ng-class=\"{\'active\': panel==\'affiliates\'}\" ng-show=\"contract.contract_type._type == \'group\' || contract.contract_type._type == \'single\' || contract.contract_type._type == \'single_free\'\" class=tab-pane><div class=table-responsive><div class=col-md-12><div ng-if=\"(contract.contract_type._type &amp;&amp; contract.contract_type._type == \'group\') &amp;&amp; !contract.is_cancelled\" class=\"col-md-4 p-l-0 p-b-1\"><ui-select ng-model=new_affiliate ng-change=\"addAffiliate($select.selected.id, $select)\"><ui-select-match allow-clear=true placeholder=\"Selecione o Filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"affiliate.id as affiliate in (affiliates | filter: $select.search | orderBy:&quot;affiliate.name&quot;) track by affiliate.id\"><span ng-bind=affiliate.name></span></ui-select-choices></ui-select></div><table class=\"table table-striped table-hover custom\"><thead><tr><th ng-click=\"affiliatesOrderBy(\'affiliate.name\')\">Nome<i ng-if=\"propertyName == \'affiliate.name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"affiliatesOrderBy(\'affiliate.birth_date\')\">Data Nascimento<i ng-if=\"propertyName == \'affiliate.birth_date\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"affiliatesOrderBy(\'affiliate.membership_card\')\">Carterinha<i ng-if=\"propertyName == \'affiliate.membership_card\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-if=\"contract.contract_type._type == &quot;single&quot; || contract.contract_type._type == &quot;single_free&quot;\" ng-click=\"affiliatesOrderBy(\'billing_cycle_value\')\">Valor contrato<i ng-if=\"propertyName == \'billing_cycle_value\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-if=\"contract.contract_type._type == &quot;single&quot;\" ng-click=\"affiliatesOrderBy(\'qtd_calls\')\">Quantidade chamadas<i ng-if=\"propertyName == \'qtd_calls\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-if=\"contract.contract_type._type == &quot;single&quot;\" ng-click=\"affiliatesOrderBy(\'additional_call\')\">Valor chamada excedente<i ng-if=\"propertyName == \'additional_call\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"rider_affiliate in current_rider.contract_rider_affiliates | orderBy:propertyName:reverse\"><td>{{rider_affiliate.affiliate.name}}</td><td>{{rider_affiliate.affiliate.birth_date | date:\'dd/MM/yyyy\'}} ({{ rider_affiliate.affiliate.birth_date | ageFilter }}) anos</td><td>{{rider_affiliate.affiliate.membership_card}}</td><td ng-if=\"contract.contract_type._type == &quot;single&quot; || contract.contract_type._type == &quot;single_free&quot;\">{{rider_affiliate.billing_cycle_value | currency}}</td><td ng-if=\"contract.contract_type._type == &quot;single&quot;\">{{rider_affiliate.qtd_calls}}</td><td ng-if=\"contract.contract_type._type == &quot;single&quot;\">{{rider_affiliate.additional_call | currency}}</td><td><a href=\"\" ng-if=\"contract.contract_type._type== \'group\' || contract.contract_type._type== \'single\' || contract.contract_type._type== \'single_free\'\" ng-really-click=\"removeAffiliate($index, rider_affiliate.affiliate_id)\" ng-really-title=\"Remover Filiado {{ rider_affiliate.affiliate.name }}\" ng-really-sub-title=\"Tem certeza que deseja remover o Filiado {{ rider_affiliate.affiliate.name }}?\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div><div ng-class=\"{\'active\': panel==\'notifications\'}\" class=tab-pane><form name=form ng-submit=addNotification(new_notification)><div class=col-sm-4><input type=text placeholder=\"E-mails não informados\" ng-model=new_notification.emails ng-enter=addNotification() required class=form-control></div><div class=col-sm-6><input type=number placeholder=\"Quantos dias antes da data de expiração o e-mail será enviado\" ng-model=new_notification.days_before ng-enter=addNotification(new_notification) required class=form-control></div><div class=col-sm-2><button type=button ng-disabled=form.$invalid class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus fa-fw\"></i> Adicionar</button></div></form><div class=col-md-12><div class=table-responsive><table ng-if=\"contract.contract_notifications.length &gt; 0\" class=\"table table-striped table-hover custom\"><thead><tr><th>E-mails</th><th>Dias</th><th></th></tr></thead><tbody ng-repeat=\"notification in contract.contract_notifications track by $index\"><tr><td>{{notification.emails}}</td><td>{{notification.days_before}}</td><td><a href=\"\" ng-really-click=\"removeNotification($index, notification.id)\" ng-really-sub-title=\"Tem certeza que deseja remover esta notificação de contrato?\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div><div ng-class=\"{\'active\': panel==\'files\'}\" class=tab-pane><div class=list-group><input id=contract_file multiple nv-file-select=true type=file uploader=uploader class=\"list-group-item hidden\"> <button href=javascript:; onclick=$(&quot;#contract_file&quot;).click() class=\"btn btn-info btn-sm\"><i class=\"fa fa-file\"></i> Procurar arquivos</button><div ng-repeat=\"item in uploader.queue\" class=list-group-item><div class=row><div class=col-xs-7><div class=btn-group><button ng-click=item.upload() class=\"btn btn-info btn-sm\">Enviar</button><div ng-click=item.remove() class=\"btn btn-danger btn-sm\"><i class=\"fa fa-trash\"></i></div><div style=\"text-overflow: ellipsis;overflow: hidden;width: 100px\" class=\"btn btn-link text-primary disabled btn-sm\"><i class=\"fa fa-files-o\"></i> {{ item.file.name }}</div><div class=\"btn btn-link text-primary disabled btn-sm\">({{ item.file.size/1024/1024|number:2 }}) MB</div></div></div><div class=col-xs-5><div style=\"margin: 6px 0 7px\" class=progress><div ng-style=\"{ \'width\': item.progress + \'%\' }\" role=progressbar class=progress-bar></div></div></div></div></div><li class=list-group-item><div class=row><div class=col-xs-7><a disabled ng-click=uploader.uploadAll() class=\"btn btn-primary btn-sm\">Enviar tudo</a></div><div class=col-xs-5><div style=\"margin: 6px 0 7px\" class=progress><div ng-style=\"{ \'width\': uploader.progress + \'%\' }\" role=progressbar class=progress-bar></div></div></div></div></li><li class=list-group-item><div class=row><div ng-repeat=\"file in contract.contract_files\" class=col-sm-4><div class=\"panel panel-default\"><div class=panel-body>{{ file.archive_file_name }}</div><div class=panel-footer><div ng-click=downloadFile(file) ng-if=file.archive_url class=\"btn btn-primary btn-sm\"><i class=\"fa fa-cloud-download fa-fw\"></i> {{ \"download\" | translate }}</div><div ng-really-click=\"removeFile(file.id, $index)\" ng-really-title=\"Remover Arquivo\" ng-really-sub-title=\"Tem certeza que deseja remover {{ file.archive_file_name }}?\" ng-class=\"{\'pull-right\': file.archive_url}\" class=\"btn btn-danger btn-sm\"><i class=\"fa fa-trash\"></i></div></div></div></div></div></li></div></div></div></div></div></section>");
$templateCache.put("app/destinations/index.html","<section class=container><div class=row><header><div class=col-md-4><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Destinos</h4></div><div class=col-md-3><div class=input-group><input type=text placeholder=\"Pesquisar destino\" ng-model=search ng-enter=searchDestination() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchDestination() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><form name=form ng-submit=addDestination(new_destination) class=\"col-md-5 form-horizontal\"><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar Destino<span class=\"text-danger required_field\">*</span></label><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text placeholder=\"Destino não informado\" required ng-model=new_destination class=form-control><span class=\"input-group-btn dark\"><button ng-disabled=form.$invalid class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"destinations.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhum destino encontrato, preencha o formulário acima para adicionar novo destino.</h5></div><div ng-if=\"destinations.length &gt;  0\" class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Nome</th><th></th></tr></thead><tbody><tr ng-repeat=\"destination in destinations track by $index\"><td><a href=# editable-text=destination.name buttons=no onaftersave=updateDestination(destination)>{{destination.name}}</a></td><td><a ng-really-click=\"removeDestination(destination.id, $index)\" ng-really-title=\"Remover Destino\" ng-really-sub-title={{destination.name}} class=\"cursor-hand onHover\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div><div ng-if=\"destinations.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></div></section>");
$templateCache.put("app/diagnoses/index.html","<section class=container><div class=row><header><div class=col-md-7><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Diagnósticos</h4></div><div class=col-md-5><div class=row><div class=col-md-6><div class=input-group><input type=text placeholder=\"Pesquisar diagnóstico\" ng-model=search ng-enter=searchDiagnose() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchDiagnose() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-6><a ng-click=newDiagnosis() class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo diagnóstico</a></div></div></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"diagnoses.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhum diagnóstico encontrado,<a ng-click=newDiagnosis() href=\"\" class=text-default>cadastrar novo diagnóstico.</a></h5></div><div class=table-responsive><table ng-if=\"diagnoses.length &gt; 0\" class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Nome</th><th>Código</th><th></th></tr></thead><tbody><tr ng-repeat=\"diagnosis in diagnoses track by $index\"><td><a ng-click=editDiagnosis(diagnosis) href=\"\">{{diagnosis.name}}</a></td><td><a ng-click=editDiagnosis(diagnosis) href=\"\">{{diagnosis.code}}</a></td><td ng-really-click=\"removeDiagnosis(diagnosis.id, $index)\" ng-really-title=\"Remover diagnóstico\" ng-really-sub-title=\"{{diagnosis.name}} - {{diagnosis.code}}\"><a href=\"\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"diagnoses.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></section>");
$templateCache.put("app/diagnoses/new.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Cadastrar Diagnóstico <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=row><form name=form ng-submit=saveDiagnosis() class=\"form form-horizontal\"><div class=col-md-12><div><div class=p-t-1><div class=form-group><label class=\"col-sm-2 control-label text-center\">Nome<span class=text-danger>*</span></label><div class=col-sm-10><input type=text placeholder=\"Nome não informado\" ng-model=diagnosis.name ng-required=true class=form-control></div></div><div class=form-group><label class=\"col-sm-2 text-right control-label\">Código<span class=text-danger>*</span></label><div class=\"col-sm-4 text-left\"><input type=text placeholder=\"Código não informado\" ng-model=diagnosis.code ng-required=true code-input=\"\" ng-pattern=code_regex class=form-control></div></div></div></div></div></form></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button ng-disabled=form.$invalid form=form ng-click=saveDiagnosis() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-clipboard\"></i>Confirmar</button></div></div></div>");
$templateCache.put("app/diseases/index.html","<section class=container><div class=row><header><div class=col-md-5><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Agravantes</h4></div><div class=\"col-md-7 p-r-0\"><div class=col-md-8><div class=input-group><input type=text placeholder=\"Pesquise agravante pelo titulo\" ng-model=search ng-enter=searchDisease() class=form-control><span class=input-group-btn><button type=button ng-click=searchDisease() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-4><a ng-click=newDisease() class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-plus\"></i> Novo Agravante</a></div></div></header><div class=\"col-md-12 p-t-2\"><div class=col-md-12><div class=row><div class=col-md-12><div ng-if=\"diseases.length ==  0 &amp;&amp; !load_diseases\" class=\"panel-body well\"><h5 class=text-center>Nenhum Agravante encontrato, preencha o formulário acima para adicionar Agravante.</h5></div></div></div><div ng-show=load_diseases><div class=\"col-md-12 text-center p-t-2\"><h3><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h3></div></div><div ng-if=\"!load_diseases &amp;&amp; diseases.length &gt; 0\"><div class=table-responsive><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Titulo</th><th></th></tr></thead><tbody><tr ng-repeat=\"disease in diseases\"><td><a href=# editable-text=disease.title buttons=no onaftersave=updateDisease(disease)>{{disease.title}}</a></td><td><a ng-really-click=\"removeDisease(disease.id, $index)\" ng-really-title=\"Remover agravante\" ng-really-sub-title={{disease.title}} class=\"cursor-hand onHover\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"!load_diseases &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=totalItems ng-model=pagination.page max-size=maxSize boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></section>");
$templateCache.put("app/diseases/new.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4>Cadastrar Agravante <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=row><form name=form ng-submit=addDisease(new_disease) class=form><div class=col-md-12><div class=p-t-1><fieldset class=form-group><label class=control-label>Titulo</label><span class=text-danger>*</span> <input type=text placeholder=\"Titulo não informado\" ng-model=new_disease required class=form-control></fieldset></div></div></form></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button ng-disabled=form.$invalid form=form ng-click=addDisease(new_disease) class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check-square fa-fw\"></i> Confirmar</button></div></div></div>");
$templateCache.put("app/health_plans/index.html","<section class=container><div class=row><header><div class=col-md-4><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Planos de saúde</h4></div><div class=col-md-3><div class=input-group><input type=text placeholder=\"Pesquisar plano\" ng-model=search ng-enter=searchHealthPlan() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchHealthPlan() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><form name=form ng-submit=addHealthPlan(new_health_plan) class=\"col-md-5 form-horizontal\"><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar Plano<span class=\"text-danger required_field\">*</span></label><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text placeholder=\"Titulo não informado\" required ng-model=new_health_plan class=form-control><span class=\"input-group-btn dark\"><button type=button ng-disabled=form.$invalid ng-click=addHealthPlan(new_health_plan) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"health_plans.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhuma plano de saúde encontrato, preencha o formulário acima para adicionar plano.</h5></div><div ng-if=\"health_plans.length &gt;  0\" class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Titulo</th><th></th></tr></thead><tbody><tr ng-repeat=\"plan in health_plans track by $index\"><td><a href=# editable-text=plan.title buttons=no onaftersave=updateHealthPlan(plan)>{{plan.title}}</a></td><td><a ng-really-click=\"removeHealthPlan(plan.id, $index)\" ng-really-title=\"Remover plano de sauúde\" ng-really-sub-title={{plan.title}} class=\"cursor-hand onHover\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"health_plans.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></section>");
$templateCache.put("app/main/main.html","<section class=container><div class=row><div class=col-md-12><header class=p-b-1><h4 class=\"text-primary text-left\"><i aria-hidden=true class=\"fa fa-hospital-o fa-fw\"></i>Dashboard</h4></header><div class=\"panel panel-profile border-none\"><div class=\"panel-heading bg-info border-radius-none text-white\"><i class=\"fa fa-list fa-fw\"></i> Resumo de chamadas</div><div class=\"panel panel-box\"><div class=panel-bottom><ul class=\"list-justified text-center\"><li><a href=\"\" ui-sref=calls.index><p class=\"size-h2 text-primary\"><i class=\"fa fa-stethoscope\"></i></p><p class=text-muted>{{ open_calls }} Chamadas abertas</p></a></li><li><a href=\"\" ui-sref=calls.revision><p class=\"size-h2 text-info\"><i class=\"fa fa-hand-stop-o\"></i></p><p class=text-muted>{{ pending_revision_calls }} Pendentes para revisão</p></a></li></ul></div></div></div></div><div class=col-md-12><canvas id=doughnut height=60px chart-data=attendance_data chart-labels=attendance_labels chart-options=attendance_options chart-colors=attendance_color class=\"chart chart-doughnut\"></canvas></div></div></section>");
$templateCache.put("app/notifications/calls_variables.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Ajuda - Variáveis <button aria-hidden=true data-ng-click=ok() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-1\"><div class=row><div class=col-md-12><p>#Utilizando às variáveis nos modelos de e-mail.#</p><p>Abaixo estão os códigos das variáveis e ao lado uma explicação de para o que elas servem. Quando for escrever o modelo de e-mail basta invocar as variáveis usando o código delas. Ex:</p><p>Bom dia \'{NOME_CLIENTE}\'. Sua chamada de número \'{NUMERO_CHAMADA}\' foi criada.</p></div><div class=col-md-12><div class=form-group><li>Nome cliente - {NOME_CLIENTE}</li><li>Número da chamada - {NUMERO_CHAMADA}</li><li>Data criação chamada - {DATA_CRIACAO}</li><li>Data finalização - chamada {DATA_FINALIZACAO}</li><li>Data reabertura chamada - {DATA_REABERTURA}</li><li>Nome filiado - {NOME_FILIADO}</li><li>Valor contrato - {CODIGO_ATENDIMENTO}</li></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-close\"></i> Fechar</a></div></div></div>");
$templateCache.put("app/notifications/index.html","<section class=container><div class=row><header><div class=col-md-9><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i>Configurações</a> / Notificações</h4></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div class=\"form-group row\"><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de expiração de contrato</h6></div><div class=pull-right><a ng-click=notificationExpirationContract() href=\"\" ng-model=notification.expiration_contract_active ng-class=\"{ \'btn-danger\' : notification.expiration_contract_active == true, \'btn-success\' : notification.expiration_contract_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.expiration_contract_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.expiration_contract_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=variablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><trix-editor angular-trix=\"\" ng-model=notification.expiration_contract_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de abertura de chamadas</h6></div><div class=pull-right><a ng-click=notificationOpenCall() href=\"\" ng-model=notification.open_call_active ng-class=\"{ \'btn-danger\' : notification.open_call_active == true, \'btn-success\' : notification.open_call_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.open_call_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.open_call_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=callsVariablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><trix-editor angular-trix=\"\" ng-model=notification.open_call_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de finalização de chamadas</h6></div><div class=pull-right><a ng-click=notificationCloseActive() href=\"\" ng-model=notification.close_call_active ng-class=\"{ \'btn-danger\' : notification.close_call_active == true, \'btn-success\' : notification.close_call_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.close_call_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.close_call_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=callsVariablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><trix-editor angular-trix=\"\" ng-model=notification.close_call_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de reabertura de chamadas</h6></div><div class=pull-right><a ng-click=notificationReopenActive() href=\"\" ng-model=notification.reopen_call_active ng-class=\"{ \'btn-danger\' : notification.reopen_call_active == true, \'btn-success\' : notification.reopen_call_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.reopen_call_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.reopen_call_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=callsVariablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><trix-editor angular-trix=\"\" ng-model=notification.reopen_call_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de ASO</h6></div><div class=pull-right><a ng-click=notificationAso() href=\"\" ng-model=notification.aso_active ng-class=\"{ \'btn-danger\' : notification.aso_active == true, \'btn-success\' : notification.aso_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.aso_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.aso_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=usersVariablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><div class=form-group><div class=row><div class=col-md-4><label class=control-label>Dias antes do envio</label><input type=text placeholder=\"Quantidade não informada\" ng-model=notification.aso_days_before ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div></div><div class=row><div class=col-md-12><trix-editor angular-trix=\"\" ng-model=notification.aso_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div></div></div><div class=col-md-9><div class=\"panel panel-default\"><div class=panel-heading><div class=clearfix><div class=pull-left><h6 class=\"font-weight-bold font-16px m-t-8px\">Template de Integração</h6></div><div class=pull-right><a ng-click=notificationIntegration() href=\"\" ng-model=notification.integration_active ng-class=\"{ \'btn-danger\' : notification.integration_active == true, \'btn-success\' : notification.integration_active == false}\" class=\"btn btn-sm\"><span ng-if=\"notification.integration_active == false\"><i class=\"fa fa-info-circle\"></i> Ativar</span><span ng-if=\"notification.integration_active == true\"><i class=\"fa fa-info-circle\"></i> Desativar</span></a><a ng-click=usersVariablesModal() href=\"\" style=\"margin-left: 3px\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-info-circle\"></i> Ajuda</a></div></div></div><div class=panel-body><div class=form-group><div class=row><div class=col-md-4><label class=control-label>Dias antes do envio</label><input type=text placeholder=\"Quantidade não informada\" ng-model=notification.integration_days_before ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\" class=form-control></div></div></div><div class=row><div class=col-md-12><trix-editor angular-trix=\"\" ng-model=notification.integration_text ng-change=changeNotification() ng-model-options=\"{updateOn: \'blur\'}\"></trix-editor></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("app/notifications/users_variables.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Ajuda - Variáveis <button aria-hidden=true data-ng-click=ok() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-1\"><div class=row><div class=col-md-12><p>#Utilizando às variáveis nos modelos de e-mail.#</p><p>Abaixo estão os códigos das variáveis e ao lado uma explicação de para o que elas servem. Quando for escrever o modelo de e-mail basta invocar as variáveis usando o código delas. Ex:</p><p>Bom dia. A data de Integração do usuário {NOME_USUARIO} vencerá dia {DATA_INTEGRACAO}.</p></div><div class=col-md-12><div class=form-group><li>Nome do usuário - {NOME_USUARIO}</li><li>Número da chamada - {DATA_NASCIMENTO}</li><li>Data integração - {DATA_INTEGRACAO}</li><li>Data ASO - {DATA_ASO}</li><li>E-mail usuário - {EMAIL_USUARIO}</li></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-close\"></i> Fechar</a></div></div></div>");
$templateCache.put("app/notifications/variables.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Ajuda - Variáveis <button aria-hidden=true data-ng-click=ok() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-1\"><div class=row><div class=col-md-12><p>#Utilizando às variáveis nos modelos de e-mail.#</p><p>Abaixo estão os códigos das variáveis e ao lado uma explicação de para o que elas servem. Quando for escrever o modelo de e-mail basta invocar as variáveis usando o código delas. Ex:</p><p>Bom dia \'{NOME_CLIENTE}\'. Seu contrato de nome \'{NOME_CONTRATO}\' precisa ser renovado.</p></div><div class=col-md-12><div class=form-group><li>Nome cliente - {NOME_CLIENTE}</li><li>Nome contrato - {NOME_CONTRATO}</li><li>Data expiração contrato - {DATA_EXPIRACAO}</li><li>Data cadastro contrato - {DATA_CADASTRO_CONTRATO}</li><li>Tipo do contrato - {TIPO_CONTRATO}</li><li>Valor contrato - {VALOR_CONTRATO}</li></div></div></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-close\"></i> Fechar</a></div></div></div>");
$templateCache.put("app/qrls/index.html","<section class=container><div class=row><header><div class=col-md-4><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / QRLs</h4></div><div class=col-md-3><div class=input-group><input type=text placeholder=\"Pesquisar QRL\" ng-model=search ng-enter=searchQRL() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchQRL() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><form name=form ng-submit=addQrl(new_qrl) class=\"col-md-5 form-horizontal\"><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar QRL<span class=\"text-danger required_field\">*</span></label><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text placeholder=\"QRL não informado\" required ng-model=new_qrl class=form-control><span class=\"input-group-btn dark\"><button type=button ng-disabled=form.$invalid ng-click=addQrl(new_qrl) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"qrls.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhum QRL encontrato, preencha o formulário acima para adicionar QRL.</h5></div><div ng-if=\"qrls.length &gt;  0\" class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Titulo</th><th></th></tr></thead><tbody><tr ng-repeat=\"qrl in qrls track by $index\"><td><a href=# editable-text=qrl.name buttons=no onaftersave=updateQrl(qrl)>{{qrl.name}}</a></td><td><a ng-really-click=\"removeQrl(qrl.id, $index)\" ng-really-title=\"Remover qrl\" ng-really-sub-title={{qrl.name}} class=\"cursor-hand onHover\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"qrls.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></section>");
$templateCache.put("app/reports/archive_modal_revive.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><div ng-click=!affiliate.id class=ng-binding><h4 style=\"text-align: center\" class=text-primary>Tem certeza que deseja desfazer a remoção deste cliente? <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-xs-12 text-right p-r-0\"><a ng-click=cancel() class=\"btn btn-danger ng-binding btn-sm\"><i class=\"fa fa-times\"></i> Cancelar</a><a ng-click=ok() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-check\"></i> Confirmar</a></div></div></div></div>");
$templateCache.put("app/reports/export_cards.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Exportar Carterinhas</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=col-md-3><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required ng-change=getAffiliates($select.selected.id)><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Filiado</label><ui-select ng-model=report.affiliate_id><ui-select-match allow-clear=true placeholder=\"Selecione o Filiado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"affiliate.id as affiliate in (affiliates | filter: $select.search) track by affiliate.id\"><span ng-bind=affiliate.name></span></ui-select-choices></ui-select></div></div><div class=\"col-md-4 p-r-0 text-right\"><p class=text-white>.</p><div class=form-group><label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.exported ng-model=report.exported checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Exportados</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.not_exported ng-model=report.not_exported class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Pendente de exportação</span></label></div></div></div></div><div class=row><div class=\"col-md-9 p-l-0\"><p class=text-white>.<label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.active ng-model=report.active checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Ativos</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.inactive ng-model=report.inactive class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Inativos</span></label></p></div><div class=\"col-md-12 text-right\"><button ng-click=applyReport() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i>Aplicar</button></div></div><div class=row><div ng-show=\"result.length &gt; 0\" class=\"col-md-4 form-group p-l-0\"><button ng-disabled=\"result.length == 0\" ng-click=generateAll() class=\"btn btn-sm btn-primary m-r-1\">Gerar todos</button> <button ng-disabled=\"result.length == 0\" ng-click=generateSelected() class=\"btn btn-sm btn-info\">Gerar Selecionados</button></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover custom review\"><thead><tr><th class=text-right><label class=\"ui-checkbox blue m-r-0 m-b-0\"><input name=checkbox1 type=checkbox ng-change=setAll(all_check) ng-model=all_check class=\"ng-untouched ng-valid ng-dirty ng-valid-parse\"><span class=\"text-black font-weight-bold\"></span></label></th><th ng-click=\"orderBy(\'affiliate_created_at\')\">Data de criação<i ng-if=\"propertyName == \'affiliate_created_at\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_name\')\">Cliente<i ng-if=\"propertyName == \'client_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'affiliate_name\')\">Filiado<i ng-if=\"propertyName == \'affiliate_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'exported\')\">Exportados<i ng-if=\"propertyName == \'exported\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th></tr></thead><tbody><tr ng-repeat=\"affiliate in (result | orderBy:propertyName:reverse ) track by $index\"><td class=text-right><label class=\"ui-checkbox blue m-b-0\"><input name=checkbox1 type=checkbox value=affiliate.checked checked ng-model=affiliate.checked class=\"ng-untouched ng-valid ng-dirty\"><span></span></label></td><td>{{affiliate.affiliate_created_at}}</td><td>{{affiliate.client_name}}</td><td>{{affiliate.affiliate_name}}</td><td>{{exported_labels[affiliate.exported]}}</td><td></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_affiliates.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Filiados</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Data criação</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Tipo de plano</label><ui-select ng-model=report.contract_type_ids multiple append-to-body=true><ui-select-match placeholder=\"Tipo de Plano não Informado\"><span class=m-l-1>{{$item.name}}</span></ui-select-match><ui-select-choices repeat=\"contract_type.id as contract_type in contract_types\"><span class=m-l-1>{{contract_type.name}}</span></ui-select-choices></ui-select></div></div><div class=\"col text-right\"><p class=text-white>.</p><div class=form-group><label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.active ng-model=report.active checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Ativos</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ,=\"\" ng-checked=report.inactive ng-model=report.inactive class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Inativos</span></label></div></div><div class=\"col-md-12 text-right\"><button ng-click=applyReport() ng-disabled=loadingReport class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button> <button ng-click=downloadCSV() ng-disabled=loadingReport class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i> Download Excel</button> <button ng-click=downloadPDF() ng-disabled=loadingReport class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-pdf-o fa-fw\"></i> Resumido PDF</button></div></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th ng-click=\"orderBy(\'created_at\')\">Data de criação<i ng-if=\"propertyName == \'created_at\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'name\')\">Filiado<i ng-if=\"propertyName == \'name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_name\')\">Cliente<i ng-if=\"propertyName == \'client_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'membership_card\')\">Carteirinha<i ng-if=\"propertyName == \'membership_card\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_calls\')\">Quantidade chamadas<i ng-if=\"propertyName == \'qtd_calls\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'contracts[0].name\')\">Tipo de Plano<i ng-if=\"propertyName == \'contracts[0].name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"affiliate in (result | orderBy:propertyName:reverse ) track by $index\"><td>{{affiliate.created_at | date:\"dd/MM/yyyy\" }}</td><td>{{affiliate.name}}</td><td>{{affiliate.client_name}}</td><td>{{affiliate.membership_card}}</td><td>{{affiliate.qtd_calls}}</td><td><span ng-repeat=\"contract in (affiliate.contracts) track by $index\">{{contract.name}}<span ng-if=\"$index &gt;= 0 &amp;&amp; $index+1 &lt; affiliate.contracts.length\">/</span></span></td><td><a ng-click=\"openNewTab(\'/clients/\'+affiliate.client_id)\" href=\"\">Visualizar cliente</a></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_archive.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Clientes removidos</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Data de remoção</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-md-3 p-l-0\"><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Tipo de plano</label><ui-select ng-model=report.contract_type_id><ui-select-match placeholder=\"Tipo de Plano não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"contract_type.id as contract_type in (contract_types | filter: $select.search) track by contract_type.id\"><span ng-bind=contract_type.name></span></ui-select-choices></ui-select></div></div></div></div><div class=row><div class=\"col-md-8 p-l-0\"><p class=text-white>.<label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.person ng-model=report.person checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Cliente Físico</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.legal ng-model=report.legal class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Cliente Jurídico</span></label></p></div><div class=\"col-md-4 text-right\"><button ng-click=applyReport() ng-disabled=applySearch class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th ng-click=\"orderBy(\'updated_at\')\">Data de remoção<i ng-if=\"propertyName == \'updated_at\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'name\')\">Cliente<i ng-if=\"propertyName == \'name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'phones\')\" class=w-10percent>Telefones<i ng-if=\"propertyName == \'phones\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_affiliates\')\">Quantidade filiados<i ng-if=\"propertyName == \'qtd_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_active_affiliates\')\">Quantidade filiados ativos<i ng-if=\"propertyName == \'qtd_active_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_calls\')\">Quantidade chamadas<i ng-if=\"propertyName == \'qtd_calls\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'cancel_reason\')\">Motivo de remoção<i ng-if=\"propertyName == \'cancel_reason\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"client in (result | orderBy:propertyName:reverse ) track by $index\"><td>{{client.updated_at | date:\"dd/MM/yyyy\" }}</td><td>{{client.name}}</td><td><span uib-popover-html=\"\'&lt;span&gt;{{ client.phones.join(\', \') }}&lt;/span&gt;\'\" popover-trigger=mouseenter type=button>{{ client.phones[0] | tel }}</span></td><td>{{client.qtd_affiliates}}</td><td>{{client.qtd_active_affiliates}}</td><td>{{client.qtd_calls}}</td><td>{{client.cancel_reason}}</td><td type=button style=\"text-align: right\" ng-click=\"archiveModalRevive(client, $index)\" class=\"button i fa fa-reply update\"></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_calls.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Chamadas</h4></header><div class=\"col-md-12 p-r-0 p-l-0\"><div class=\"col-md-3 p-l-0\"><div class=form-group><label class=font-weight-normal>Data criação</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required ng-change=clearAffiliateValues()><ui-select-match placeholder=\"Cliente não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Filiado</label><ui-select ng-model=report.affiliate_id required><ui-select-match placeholder=\"Filiado não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadAffiliates($select.search) refresh-delay=200 repeat=\"affiliate.id as affiliate in affiliates\"><span ng-bind=affiliate.name></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12 p-r-0 p-l-0\"><div class=\"col-md-3 p-l-0\"><div class=form-group><label class=font-weight-normal>Supervisor</label><ui-select ng-model=report.supervisor_id class=form-group-sm><ui-select-match placeholder=\"Supervisor não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"supervisor.id as supervisor in (team_users.supervisors | filter: $select.search) track by supervisor.id\"><span ng-bind=supervisor.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Médico</label><ui-select ng-model=report.doctor_id class=form-group-sm><ui-select-match placeholder=\"Médico não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"doctor.id as doctor in (team_users.doctors | filter: $select.search) track by doctor.id\"><span ng-bind=doctor.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Enfermagem</label><ui-select ng-model=report.nurse_id class=form-group-sm><ui-select-match placeholder=\"Enfermagem não informada\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"nurse.id as nurse in (team_users.nurses | filter: $select.search) track by nurse.id\"><span ng-bind=nurse.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Motorista</label><ui-select ng-model=report.driver_id class=form-group-sm><ui-select-match placeholder=\"Motorista não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"driver.id as driver in (team_users.drivers | filter: $select.search) track by driver.id\"><span ng-bind=driver.name></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12 p-r-0 p-l-0\"><div class=\"col-md-3 p-l-0\"><div class=form-group><label class=font-weight-normal>Operador</label><ui-select ng-model=report.operator_id class=form-group-sm><ui-select-match placeholder=\"Operador não informado\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"operator.id as operator in (team_users.operators | filter: $select.search) track by operator.id\"><span ng-bind=operator.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Código de atendimento</label><ui-select ng-model=report.attendance_code_ids multiple append-to-body=true class=form-group-sm><ui-select-match placeholder=\"Código não informado\"><span class=m-l-1>{{$item.title}}</span><span style=\"background: {{$item.color}}\" class=\"code pull-left\"></span></ui-select-match><ui-select-choices repeat=\"attendance.id as attendance in attendance_codes\"><span class=m-l-1>{{attendance.title}}</span><span style=\"background: {{attendance.color}}\" class=\"code pull-left\"></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=\"font-weight-normal d-block\">Status</label><label class=\"ui-checkbox danger text-primary m-r-1\"><input name=checkbox1 type=checkbox ng-checked=report.opened ng-model=report.opened class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Abertas</span></label><label class=\"ui-checkbox warning text-primary m-r-1\"><input name=checkbox1 type=checkbox ng-checked=report.closed ng-model=report.closed class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Fechadas</span></label><label class=\"ui-checkbox m-r-1\"><input name=checkbox1 type=checkbox ng-checked=report.canceled ng-model=report.canceled class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Canceladas</span></label></div></div><div class=col-md-3><div class=form-group><label class=\"font-weight-normal d-block\">Revisado</label><label class=\"ui-checkbox danger text-primary m-r-1\"><input name=checkbox1 type=checkbox ng-checked=report.revised ng-model=report.revised class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Sim</span></label><label class=\"ui-checkbox warning text-primary m-r-1\"><input name=checkbox1 type=checkbox ng-checked=report.not_revised ng-model=report.not_revised class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Não</span></label></div></div></div><div class=\"col-md-12 text-right\"><p class=text-white>.</p><div class=form-group><button ng-click=downloadPDF() ng-disabled=loadingPdf class=\"btn btn-sm btn-primary\"><i ng-if=loadingPdf class=\"fa fa-spinner fa-pulse\"></i><i ng-if=!loadingPdf class=\"fa fa-file-pdf-o fa-fw\"></i> Download PDF</button> <button ng-click=downloadCSVDetailed() ng-disabled=loadingCSVDetailed class=\"btn btn-sm btn-primary\"><i ng-if=loadingCSVDetailed class=\"fa fa-spinner fa-pulse\"></i><i ng-if=!loadingCSVDetailed class=\"fa fa-file-excel-o fa-fw\"></i> Download Detalhado</button> <button ng-click=applyReport() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><strong>Quantidade de chamadas: {{result.length}}</strong></div><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th ng-click=\"orderBy(\'created_at\')\">Data de criação<i ng-if=\"propertyName == \'created_at\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_name\')\">Cliente<i ng-if=\"propertyName == \'client_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'affiliate_name\')\">Filiado<i ng-if=\"propertyName == \'affiliate_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'is_closed\')\">Status<i ng-if=\"propertyName == \'is_closed\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'close_time\')\">Data de Fechamento<i ng-if=\"propertyName == \'close_time\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'doctor_name\')\">Médico<i ng-if=\"propertyName == \'doctor_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'supervisor_name\')\">Supervisor<i ng-if=\"propertyName == \'supervisor_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'nurse_name\')\">Enfermagem<i ng-if=\"propertyName == \'nurse_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'driver_name\')\">Motorista<i ng-if=\"propertyName == \'driver_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'operator_name\')\">Operador<i ng-if=\"propertyName == \'operator_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'destination_name\')\">Destino<i ng-if=\"propertyName == \'destination_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"call in (result | orderBy:propertyName:reverse ) track by $index\"><td>{{call.created_at | date:\"dd/MM/yyyy\" }}</td><td>{{call.client_name}}</td><td>{{call.affiliate_name}}</td><td>{{is_closed_labels[call.is_closed]}}</td><td>{{call.close_time | date:\"dd/MM/yyyy\" }}</td><td>{{call.doctor_name }}</td><td>{{call.supervisor_name }}</td><td>{{call.nurse_name }}</td><td>{{call.driver_name }}</td><td>{{call.operator_name }}</td><td>{{call.destination_name }}</td><td><a ng-click=\"openNewTab(\'/calls/\'+call.id)\" href=\"\">Visualizar Chamada</a></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_clients.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Clientes</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Data criação</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/mm/AAAA ui-mask=99/99/9999 model-view-value=true class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-md-3 p-l-0\"><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>Vendedor</label><ui-select ng-model=report.seller_id><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"seller.id as seller in (sellers | filter: $select.search) track by seller.id\"><span ng-bind=seller.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Tipo de plano</label><ui-select ng-model=report.contract_type_id><ui-select-match placeholder=\"Tipo de Plano não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"contract_type.id as contract_type in (contract_types | filter: $select.search) track by contract_type.id\"><span ng-bind=contract_type.name></span></ui-select-choices></ui-select></div></div></div></div><div class=row><div class=\"col-md-8 p-l-0\"><p class=text-white>.<label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.person ng-model=report.person checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Cliente Físico</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.legal ng-model=report.legal class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Cliente Jurídico</span></label><label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.active ng-model=report.active checked class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Clientes Ativos</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.inactive ng-model=report.inactive class=\"ng-pristine ng-untouched ng-valid\"><span class=text-primary>Clientes Inativos</span></label></p></div><div class=\"col-md-4 text-right\"><button ng-click=applyReport() ng-disabled=applySearch class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button> <button ng-click=downloadCSV() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i> Download Excel</button></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th ng-click=\"orderBy(\'created_at\')\">Data de criação<i ng-if=\"propertyName == \'created_at\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'name\')\">Cliente<i ng-if=\"propertyName == \'name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'phones\')\">Telefones<i ng-if=\"propertyName == \'phones\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_seller\')\">Vendendor<i ng-if=\"propertyName == \'client_seller\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_affiliates\')\">Quantidade filiados<i ng-if=\"propertyName == \'qtd_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_active_affiliates\')\">Quantidade filiados ativos<i ng-if=\"propertyName == \'qtd_active_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_calls\')\">Quantidade chamadas<i ng-if=\"propertyName == \'qtd_calls\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th></th></tr></thead><tbody><tr ng-repeat=\"client in (result | orderBy:propertyName:reverse ) track by $index\"><td>{{client.created_at | date:\"dd/MM/yyyy\" }}</td><td>{{client.name}}</td><td><span uib-popover-html=\"\'&lt;span&gt;{{ client.phones.join(\', \') }}&lt;/span&gt;\'\" popover-trigger=mouseenter type=button>{{ client.phones[0] | tel }}</span></td><td>{{client.client_seller || \"-\"}}</td><td>{{client.qtd_affiliates}}</td><td>{{client.qtd_active_affiliates}}</td><td>{{client.qtd_calls}}</td><td><a ng-click=\"openNewTab(\'/clients/\'+client.id)\" href=\"\">Visualizar cliente</a></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_contracts.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Planos</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Data início</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Tipo de plano</label><ui-select ng-model=report.contract_type_id required><ui-select-match placeholder=\"Tipo de Contrato não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"contract_type.id as contract_type in (contract_types | filter: $select.search) track by contract_type.id\"><span ng-bind=contract_type.name></span></ui-select-choices></ui-select></div></div><div class=col-md-3><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>Vendedor</label><ui-select ng-model=report.seller_id><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"seller.id as seller in (sellers | filter: $select.search) track by seller.id\"><span ng-bind=seller.name></span></ui-select-choices></ui-select></div></div></div></div><div class=row><div class=\"col-md-8 p-l-0\"><p class=text-white>.<label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.person ng-model=report.person checked><span class=text-primary>Pessoa Física</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.legal ng-model=report.legal><span class=text-primary>Pessoa Jurídica</span></label><label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.active ng-model=report.active><span class=text-primary>Planos Ativos</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.inactive ng-model=report.inactive><span class=text-primary>Planos Inativos</span></label><label class=\"ui-checkbox m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.canceled ng-model=report.canceled><span class=text-primary>Planos Cancelados</span></label></p></div><div class=col-md-4><div class=text-right><button ng-click=applyReport() ng-disabled=applySearch class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button> <button ng-click=downloadCSV() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i> Download Excel</button> <button ng-show=\"show_add_rider=show_add_rider &amp;&amp; result.length &gt; 0\" ng-click=addRider() class=\"btn btn-sm btn-success\"><i class=\"fa fa-plus fa-fw\"></i> Adicionar</button></div></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th ng-click=\"orderBy(\'start_date\')\">Data de início<i ng-if=\"propertyName == \'start_date\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'contract_number\')\">Número Contrato<i ng-if=\"propertyName == \'contract_number\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'contract_type_name\')\">Plano<i ng-if=\"propertyName == \'contract_type_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_name\')\">Cliente<i ng-if=\"propertyName == \'client_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_phones\')\">Telefones<i ng-if=\"propertyName == \'client_phones\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_seller\')\">Vendendor<i ng-if=\"propertyName == \'client_seller\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_affiliates\')\">Quantidade filiados<i ng-if=\"propertyName == \'qtd_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'billing_cycle_value\')\">Valor contrato<i ng-if=\"propertyName == \'billing_cycle_value\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-show=show_add_rider>Adendo (%)</th></tr></thead><tbody><tr ng-repeat=\"contract in (result | orderBy:propertyName:reverse ) track by $index\"><td>{{contract.start_date | date:\"dd/MM/yyyy\" }}</td><td>{{contract.contract_number}}</td><td>{{contract.contract_type_name}}</td><td>{{contract.client_name }}</td><td><span uib-popover-html=\"\'&lt;span&gt;{{ contract.client_phones.join(\', \') }}&lt;/span&gt;\'\" popover-trigger=mouseenter type=button>{{ contract.client_phones[0] | tel }}</span></td><td>{{contract.client_seller}}</td><td>{{contract.qtd_affiliates}}</td><td>{{contract.billing_cycle_value | currency}}</td><td><a ng-click=\"openNewTab(\'/contracts/\'+contract.id)\" href=\"\">Visualizar contrato</a></td><td><div ng-show=show_add_rider class=form-group><div style=padding-left:0 class=col-sm-8><input type=number placeholder=% ng-model=contract.rider class=form-control></div></div></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_contracts_block.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Adendo em Bloco</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Mês vencimento</label><div class=input-group><input type=text ui-mask=99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_month_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-md-6><div class=form-group><label class=font-weight-normal>Cliente</label><ui-select ng-model=report.client_id required><ui-select-match placeholder=\"Cliente não Informado\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=loadClients($select.search) refresh-delay=200 repeat=\"client.id as client in clients track by $index\"><span ng-bind=client.name></span></ui-select-choices></ui-select></div></div><div class=col-md-4><label class=\"d-block text-white\">.</label><button ng-click=applyReport() ng-disabled=applySearch class=\"btn btn-sm btn-primary\"><i class=\"fa fa-search fa-fw\"></i> Aplicar</button> <button ng-click=downloadCSV() class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i> Download Excel</button></div></div></div><div class=row><div class=\"col-md-8 p-l-0\"><p class=text-white>.<label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.person ng-model=report.person><span class=text-primary>Pessoa Física</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.legal ng-model=report.legal><span class=text-primary>Pessoa Jurídica</span></label><label class=\"ui-checkbox danger text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.active ng-model=report.active><span class=text-primary>Planos Ativos</span></label><label class=\"ui-checkbox warning text-primary m-r-0\"><input name=checkbox1 type=checkbox ng-checked=report.inactive ng-model=report.inactive><span class=text-primary>Planos Inativos</span></label></p></div></div><div class=row><div class=\"col-md-2 form-group\"><button ng-show=\"result.length &gt; 0\" ng-click=\"show_add_rider=!show_add_rider\" class=\"btn btn-sm btn-info\"><i class=\"fa fa-plus fa-fw\"></i> Adicionar Adendo em Bloco</button></div><div ng-show=\"show_add_rider &amp;&amp; result.length &gt; 0\" class=col-md-4><div class=input-group><input type=number placeholder=% ng-model=affiliate_rider_value min=0 ng-change=updateAffiliateRider() class=form-control><span class=input-group-btn><button ng-click=addRiderBlock() ng-disabled=\"!affiliate_rider_value || disable_action\" class=\"btn btn-sm btn-success\"><i class=\"fa fa-check fa-fw\"></i> Adicionar</button></span></div><span class=help-block>Os valores abaixos estão com reajuste de {{ affiliate_rider_value }} %</span></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th style=\"width: 15px\"><label class=\"ui-checkbox blue m-b-0\"><input name=checkbox1 type=checkbox ng-change=checkAll(all_check) ng-model=all_check class=\"ng-untouched ng-valid ng-dirty\"><span></span></label></th><th ng-click=\"orderBy(\'expiration_date\')\">Data de expiração<i ng-if=\"propertyName == \'expiration_date\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'contract_type_name\')\">Plano<i ng-if=\"propertyName == \'contract_type_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'client_name\')\">Cliente<i ng-if=\"propertyName == \'client_name\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'qtd_affiliates\')\">Quantidade filiados<i ng-if=\"propertyName == \'qtd_affiliates\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-click=\"orderBy(\'billing_cycle_value\')\">Valor contrato<i ng-if=\"propertyName == \'billing_cycle_value\'\" ng-class=\"{\'fa-chevron-up\': !reverse, \'fa-chevron-down\': reverse}\" class=\"fa fa-fw\"></i></th><th ng-show=show_add_rider>Valor calculado (%)</th></tr></thead><tbody><tr ng-repeat=\"contract in (result | orderBy:propertyName:reverse ) track by $index\"><td class=text-right><label class=\"ui-checkbox blue m-b-0\"><input name=checkbox1 type=checkbox ng-change=\"selectedIndex(contract, $index)\" ng-model=contract.checked class=\"ng-untouched ng-valid ng-dirty\"><span></span></label></td><td>{{contract.expiration_date | date:\"dd/MM/yyyy\" }}</td><td>{{contract.contract_type_name}}</td><td>{{contract.client_name}}</td><td>{{contract.qtd_affiliates}}</td><td>{{contract.billing_cycle_value | currency}}</td><td ng-show=show_add_rider>{{contract.rider | currency}}</td><td><a ng-click=\"openNewTab(\'/contracts/\'+contract.id)\" href=\"\">Visualizar contrato</a></td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/extract_users.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a href=\"\" ui-sref=reports><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</a> / Usuários</h4></header><div class=col-md-12><div class=row><div class=form-group><div class=\"col-md-2 p-l-0\"><div class=form-group><label class=font-weight-normal>Data de Admissão</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.start_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><span type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></span></span></div></div></div><div class=col-md-2><div class=form-group><label class=font-weight-normal>até</label><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=report.end_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><span type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></span></span></div></div></div><div class=col-md-4><div class=form-group><label class=\"d-block font-weight-normal\">Função</label><menu class=c-input><label for=checkbox ng-click=toggleSearch() focus={{check_selected}} class=\"c-input__label white-space-nowrap handle handle-right\">Selecione as funções<i aria-hidden=true class=\"fa fa-caret-down c-input__icon\"></i></label><ul ng-class=\"{expanded: check_selected, collapsed: !check_selected}\" class=\"c-dropdown u-text-small\"><li ng-repeat=\"position in positions track by $index\"><label class=\"ui-checkbox blue m-r-0\"><input name=checkbox1 type=checkbox ng-model=report.positions[position.id]><span class=\"text-black font-weight-bold\">{{position.name}}</span></label></li></ul></menu></div></div><div class=col-md-4><div class=text-left><label class=\"d-block text-white\">.</label><button ng-click=downloadCSV() ng-disabled=loadingCSV class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i> Download Excel</button></div></div></div></div></div><div ng-show=\"result.length &gt; 0\" class=col-md-12><div class=row><div class=table-responsive><table style=table-layout:auto class=\"table table-striped table-hover\"><thead><tr><th>Nome</th><th>Email</th><th>Usuário</th><th>Acesso sistema</th><th>Data Nascimento</th><th>CPF</th><th>RG</th><th>CRM</th><th>COREN</th><th>Matricula</th><th>Data Admissão</th><th>Data ASO</th><th>Data Integração</th><th>Telefones</th><th>Endereço</th><th>Funções</th><th>Observação</th></tr></thead><tbody><tr ng-repeat=\"contract in result track by $index\"><td>{{contract.expiration_date | date:\"dd/MM/yyyy\" }}</td><td>{{contract.contract_type_name}}</td><td>{{contract.client_name}}</td><td>{{contract.qtd_affiliates}}</td><td>{{contract.billing_cycle_value | currency}}</td></tr></tbody></table></div></div></div></div></div></section>");
$templateCache.put("app/reports/index.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><i aria-hidden=true class=\"fa fa-file-pdf-o fa-fw\"></i> Relatórios</h4></header><div class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-cube fa-fw\"></i><span class=text-uppercase>Geral</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'can_extract_clients\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_clients class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-users fa-fw\"></i> Clientes</a></li><li ng-show=\"hasRole(\'can_extract_affiliates\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_affiliates class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-handshake-o fa-fw\"></i> Filiados</a></li><li ng-show=\"hasRole(\'can_extract_calls\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_calls class=\"btn border-radius-none border-none\"><i aria-hidden=true class=\"fa fa-ambulance\"></i><span class=ng-binding>Chamadas</span></a></li><li ng-show=\"hasRole(\'can_extract_users\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_users class=\"btn border-radius-none border-none\"><i aria-hidden=true class=\"fa fa-users\"></i><span class=ng-binding>Usuários</span></a></li></ul><ul class=\"nav nav-boxed nav-justified text-primary\"><li ng-show=\"hasRole(\'can_export_cards\')\" class=\"border-none border-radius-none\"><a ui-sref=export_cards class=\"btn border-radius-none border-none\"><i class=\"fa fa-id-card-o\"></i><span>Exportar Carterinha</span></a></li><li ng-show=\"hasRole(\'can_extract_contracts_block\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_contracts_block class=\"btn border-radius-none border-none\"><i class=\"fa fa-cubes\"></i><span>Adendo em Bloco</span></a></li><li ng-show=\"hasRole(\'can_extract_contracts\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_contracts class=\"btn border-radius-none border-none\"><i class=\"fa fa-id-card-o\"></i><span>Planos </span></a></li><li ng-show=\"hasRole(\'can_extract_archive\')\" class=\"border-none border-radius-none\"><a ui-sref=extract_archive class=\"btn border-radius-none border-none\"><i class=\"fa fa-trash\"></i><span>Clientes removidos</span></a></li></ul></div><div class=\"panel panel-default\"><div class=panel-heading><strong><i class=\"fa fa-money\"></i><span class=text-uppercase>Faturamento</span></strong></div><ul class=\"nav nav-boxed nav-justified text-primary\"><li class=\"border-none border-radius-none\"><a class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-fa fa-circle-o-notch fa-fw\"></i> Pendentes</a></li><li class=\"border-none border-radius-none\"><a class=\"btn border-radius-none border-none ng-binding\"><i class=\"fa fa-history fa-fw\"></i> Histórico</a></li></ul></div></div></div></section>");
$templateCache.put("app/reviews/index.html","<div class=container><div class=row><header><div class=col-md-12><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Revisão</h4></div></header><div class=col-md-12><div class=col-md-6><fieldset class=form-group><label class=control-label>Quantidade de dias para revisão</label><span class=text-danger>*</span> <input type=text placeholder=\"Quantidade de dias para revisão\" ng-model=organization.qtd_days_revision ng-enter=saveRevision() class=form-control></fieldset></div><div class=col-md-6><fieldset class=form-group><label class=\"control-label text-white\">.</label><div class=row><button type=button ng-disabled=!organization.qtd_days_revision ng-click=saveRevision() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></div></fieldset></div></div></div></div>");
$templateCache.put("app/role_groups/index.html","<section class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=row><div class=col-md-5><h4><a ui-sref=configuration><i aria-hidden=true class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Grupos de Permissão</h4></div><div class=col-md-3><div class=input-group><input type=text placeholder=\"Pesquisar grupo de permissão\" ng-model=query ng-enter=filterRoleGroups(query) class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=filterRoleGroups(query) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-4><form class=form-horizontal><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar</label><div class=col-md-9><div class=input-group><input type=text placeholder=\"Novo grupo de permissão\" ng-model=new_role_group ng-enter=addRoleGroup() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=addRoleGroup() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></div></header></div><div class=\"col-md-12 p-t-2\"><div ng-if=\"role_groups.length == 0\" class=well><h5 class=text-center>Nenhum grupo de permissão encontrado, preencha o formulário acima para adicionar novo grupo</h5></div><div ng-if=\"role_groups.length &gt; 0\" class=table-responsible><table class=\"table table-striped table-hover custom\"><thead><tr><th>Nome</th><th></th></tr></thead><tbody><tr ng-repeat=\"role_group in role_groups\"><td ui-sref=\"role_groups_show({id: role_group.id})\"><a href=\"\">{{role_group.name}}</a></td><td><a ng-really-click=\"removeRoleGroup(role_group.id, $index)\" href=\"\" ng-really-title=\"Remover Groupo de Permissão\" ng-really-sub-title={{role_group.name}} class=\"onHover text-right\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></section>");
$templateCache.put("app/role_groups/show.html","<section class=container><div class=row><header><div class=col-md-5><h4><a ui-sref=role_groups href=\"\"><i class=\"fa fa-gear fa-fw\"></i> Grupos de Permissão</a> / {{role_group.name}}</h4></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=table-responsive><div ng-if=\"users.length &gt; 0\" class=\"col-md-4 form-group\"><p>Adicionar usuário ao grupo {{role_group.name}}</p><ui-select data-ng-model=new_user theme=bootstrap ng-change=addUser(new_user)><ui-select-match placeholder=\"Adicionar usuário ao grupo\"></ui-select-match><ui-select-choices repeat=\"user in (users | filter: $select.search) track by user.id\"><span ng-bind=\"user.name+\' \'+user.email\"></span></ui-select-choices></ui-select></div><div ng-if=\"role_group.users.length &gt; 0\" class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><strong>Usuários</strong></div><div class=panel-body><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Nome</th><th>E-mail</th><th></th></tr></thead><tbody><tr ng-repeat=\"role_user in role_group.users\"><td>{{ role_user.name }}</td><td>{{ role_user.email }}</td><td ng-if=\"user.email == role_user.email\"></td><td ng-if=\"user.email != role_user.email\"><a ng-really-click=\"removeUser(role_user, $index)\" href=\"\" ng-really-title=\"Remover Usuário\" ng-really-sub-title={{role_user.name}} class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><strong>Permissões</strong></div><div class=panel-body><div ng-repeat=\"role in roles\"><div ng-class-odd=\"\'col-md-4\'\" ng-class-even=\"\'col-md-4\'\"><div class=row><span><label class=\"ui-checkbox blue\"><input ng-checked=checkExists(role) name=checkbox1 type=checkbox data-ng-model=role_group[role.name] ng-change=\"updateRole(role.name, role.id)\" ng-init=\"role_group[role.name]=checkExists(role)\"><span class=text-black>{{ translate_roles[role.name] }}</span></label></span></div></div></div></div><div class=panel-body><strong>Relatórios</strong></div><div class=panel-body><div ng-repeat=\"role in report_roles\"><div ng-class-odd=\"\'col-md-4\'\" ng-class-even=\"\'col-md-4\'\"><div class=row><span><label class=\"ui-checkbox blue\"><input ng-checked=checkExists(role) name=checkbox1 type=checkbox data-ng-model=role_group[role.name] ng-change=\"updateRole(role.name, role.id)\" ng-init=\"role_group[role.name]=checkExists(role)\"><span class=text-black>{{ translate_roles[role.name] }}</span></label></span></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("app/sessions/new.html","<div class=\"container m-t-13cent\"><div class=row><div class=\"col-xs-12 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-4 well\"><div class=\"text-center login-title\"><img src=assets/images/ideal_gray.png class=\"img-responsive login-logo\"></div><div class=account-wall><form ng-submit=submitLogin(loginForm) role=form ng-init=\"loginForm = {}\" class=form-signin><fieldset class=form-group><label for=username>Usuário</label><input type=text name=Login ng-model=loginForm.username required placeholder=\"Informe seu usuário\" class=\"form-control input-sm\"></fieldset><fieldset class=form-group><label for=Senha>Senha</label><input type=password name=password ng-model=loginForm.password required placeholder=\"Informe sua senha\" class=\"form-control input-sm\"></fieldset><button type=submit translate=Entrar class=\"btn btn-sm btn-primary btn-block\">Entrar</button><span class=clearfix></span></form></div></div></div></div>");
$templateCache.put("app/shift_hours/index.html","<section class=container><div class=row><header><div class=col-md-6><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Tipos de hora de deslocamento</h4></div><form name=form ng-submit=addShiftHour(new_shift_hour) class=\"col-md-6 form-horizontal\"><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar Hora<span class=\"text-danger required_field\">*</span></label><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text placeholder=\"Hora não informada\" required ng-model=new_shift_hour name=shift_hour class=form-control><span class=\"input-group-btn dark\"><button type=button ng-disabled=form.$invalid ng-click=addShiftHour(new_shift_hour) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"shift_hours.length == 0\" class=\"panel-body well\"><h5 class=text-center>Nenhum tipo de hora cadastrada, preencha o formulário acima para adicionar hora .</h5></div></div><div ng-if=\"shift_hours.length &gt; 0\" class=col-md-12><ul ui-sortable ng-model=shift_hours ui-sortable-update=updateOrder() class=list-group><li class=\"list-group-item border-none\"><div class=row><div class=col-xs-3><strong>Titulo</strong></div></div></li><li ng-repeat=\"shift_hour in shift_hours\" class=\"list-group-item cursor-hand\"><div class=row><div class=col-xs-3>{{shift_hour.title}}</div><div class=col-xs-9><a ng-really-click=\"removeShiftHour(shift_hour.id, $index)\" ng-really-title=\"Remover tipo de hora de deslocamento\" ng-really-sub-title={{shift_hour.title}} href=\"\" class=\"onHover pull-right\"><i class=\"fa fa-trash-o\"></i></a></div></div></li></ul></div></div></div></div></section>");
$templateCache.put("app/teams/index.html","<section class=container><div class=row><header><div class=col-md-4><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Equipes</h4></div><div class=col-md-3><div class=input-group><input type=text placeholder=\"Pesquisar time\" ng-model=search ng-enter=searchTeam() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchTeam() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><form name=form ng-submit=addTeam(new_team) class=\"col-md-5 form-horizontal\"><div class=\"form-group m-b-0\"><label class=\"col-md-3 control-label text-right\">Adicionar Equipe<span class=\"text-danger required_field\">*</span></label><div class=col-md-9><div class=\"input-group p-b-1\"><input type=text placeholder=\"Titulo não informado\" required ng-model=new_team class=form-control><span class=\"input-group-btn dark\"><button type=button ng-disabled=form.$invalid ng-click=addTeam(new_team) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus fa-fw\"></i>Salvar</button></span></div></div></div></form></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"teams.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhuma equipe encontrato, preencha o formulário acima para adicionar equipe.</h5></div><div ng-if=\"teams.length &gt;  0\" class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Titulo</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in teams track by $index\"><td><a href=# editable-text=team.title buttons=no onaftersave=updateTeam(team)>{{team.title}}</a></td><td><a ng-really-click=\"removeTeam(team.id, $index)\" ng-really-title=\"Remover equipe\" ng-really-sub-title={{team.title}} class=cursor-hand><i style=\"visibility: visible\" class=\"fa fa-trash-o d-block\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"teams.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></section>");
$templateCache.put("app/users/index.html","<section class=container><div class=row><header><div class=col-md-7><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Usuários</h4></div><div class=col-md-5><div class=row><div class=col-md-6><div class=input-group><input type=text placeholder=Pesquisar ng-model=search ng-enter=searchUser() class=form-control><span class=input-group-btn><button type=button ng-click=searchUser() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-6><a ui-sref=new_user class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo usuário</a></div></div></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=\"tab-content form-horizontal\"><div id=home class=\"tab-pane active\"><div ng-show=load_users class=row><div class=\"col-md-12 text-center p-t-2\"><h3><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h3></div></div><div ng-show=!load_users class=table-responsive><div class=col-md-12><table class=\"table table-striped table-hover fixed table-condensed custom\"><thead><tr><th>Nome</th><th>Email</th><th>Ativo</th><th>Acesso ao sistema</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in users track by $index\"><td><a ui-sref=\"edit_user({id: user.id})\" href=\"\" class=cursor-hand>{{user.name || user.email.split(\"@\")[0]}}</a></td><td><a ui-sref=\"edit_user({id: user.id})\" href=\"\" ng-if=user.system_access class=cursor-hand>{{user.email}}</a></td><td><label class=\"switch switch-success small\"><input type=checkbox checked ng-change=toggleIsActive(user.id) ng-model=user.is_active class=\"ng-pristine ng-untouched ng-valid ng-scope\"><i></i></label></td><td><label class=\"switch switch-success small\"><input type=checkbox checked ng-change=toggleSystemAcess(user.id) ng-model=user.system_access class=\"ng-pristine ng-untouched ng-valid ng-scope\"><i></i></label></td></tr></tbody></table></div></div></div><div ng-if=\"users.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></section>");
$templateCache.put("app/users/new.html","<div class=container><div class=row><div class=\"col-md-12 p-t-0\"><header class=\"col-md-12 p-l-0 p-b-0\"><h4 class=text-primary><a ui-sref=users><i aria-hidden=true class=\"fa fa-users\"></i> Usuários</a> / Novo usuário</h4></header><form name=form ng-submit=createUser() class=\"form form-horizontal\"><div class=col-md-12><div class=\"row p-t-1\"><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Acessa o sistema</label></div><div class=\"col-md-3 text-left\"><label class=\"switch switch-success\"><input type=checkbox ng-model=newUser.system_access class=\"ng-pristine ng-untouched ng-valid ng-scope\"><i></i></label></div></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Nome<span class=text-danger>*</span></label></div><div class=col-md-3><input type=text placeholder=\"Nome não informado\" ng-model=newUser.name required class=form-control></div><label ng-if=newUser.system_access class=\"col-md-1 control-label text-center\">E-mail<span ng-show=newUser.system_access class=text-danger>*</span></label><div ng-if=newUser.system_access class=col-md-3><input type=email placeholder=\"E-mail não informado\" ng-model=newUser.email ng-required=newUser.system_access class=form-control></div><label ng-if=newUser.system_access class=\"col-md-1 control-label text-center\">Usuário<span class=text-danger>*</span></label><div ng-if=newUser.system_access class=col-md-3><input type=text placeholder=\"Usuário não informado\" ng-model=newUser.username ng-required=newUser.system_access class=form-control></div></div><div class=form-group><div ng-if=newUser.system_access class=\"col-md-1 text-right\"><label class=control-label>Senha<span ng-show=!newUser.id class=text-danger>*</span></label></div><div ng-if=newUser.system_access class=col-md-3><input type=password placeholder=\"Senha não informada\" ng-required=newUser.system_access ng-model=newUser.password class=form-control></div><label ng-if=newUser.system_access class=\"col-md-1 control-label text-center\">Confirmar senha<span ng-show=!newUser.id class=text-danger>*</span></label><div ng-if=newUser.system_access class=col-md-3><input type=password placeholder=\"Confirmação de Senha não informada\" ng-required=newUser.system_access ng-model=newUser.password_confirmation class=form-control></div><label class=\"col-md-1 control-label text-center\">Data de Nasc</label><div class=col-md-3><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=newUser.birth_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div ng-class=\"{ \'has-error\' : form.cep.$invalid &amp;&amp; !form.cep.$pristine }\" class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>CPF<span class=text-danger>*</span></label></div><div class=col-md-3><input type=text placeholder=\"CPF não informado\" ng-model=newUser.cpf required ui-br-cpfcnpj-mask=\"\" name=cep class=form-control></div><label class=\"col-md-1 control-label text-center\">RG</label><div class=col-md-3><input type=text placeholder=\"RG não informado\" ng-model=newUser.rg class=form-control></div><label class=\"col-md-1 control-label text-center\">Gênero</label><div class=\"col-md-3 m-t-1\"><label class=ui-radio><input type=radio ng-model=newUser.gender value=male><span>Masculino</span></label><label class=ui-radio><input type=radio ng-model=newUser.gender value=female><span>Feminino</span></label></div></div><div class=form-group><label class=\"col-md-1 control-label text-right\">CRM<span ng-show=\"newUser.positions[\'doctor\']\" class=text-danger>*</span></label><div class=col-md-3><input type=text placeholder=\"CRM não informado\" ng-model=newUser.crm ng-required=\"newUser.positions[\'doctor\']\" class=form-control></div><label class=\"col-md-1 control-label text-right\">COREN<span ng-show=\"newUser.positions[\'nurse\']\" class=text-danger>*</span></label><div class=col-md-3><input type=text placeholder=\"COREN não informado\" ng-model=newUser.coren ng-required=\"newUser.positions[\'nurse\']\" class=form-control></div></div><div class=form-group><label class=\"col-md-1 control-label text-center\">Matrícula</label><div class=col-md-3><input type=text placeholder=\"Matrícula não informada\" ng-model=newUser.registration class=form-control></div><label class=\"col-md-1 control-label text-right\">Data de admissão</label><div class=col-md-3><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=newUser.admission_date is-open=popup3.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open3() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div><label class=\"col-md-1 control-label text-center\">Data ASO</label><div class=col-md-3><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=newUser.aso_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"col-md-1 control-label text-center\">Data Integração</label><div class=col-md-3><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=newUser.integration_date is-open=popup4.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open4() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div ng-class=\"{ \'has-error\' : form.phone.$invalid &amp;&amp; !form.phone.$pristine }\" class=form-group><label class=\"col-md-1 control-label text-center\">Telefone</label><div class=col-md-3><div class=\"input-group p-b-1\"><input type=text placeholder=\"Telefone não informado\" ng-model=newUser.phone ui-br-phone-number=\"\" name=phone class=form-control><span class=\"input-group-btn dark\"><button type=button ng-click=addFone(newUser.phone) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></span></div></div><div class=col-md-8><span ng-repeat=\"phone in phones track by $index\" class=form-control-static>{{phone | tel }}<i ng-click=removePhone($index) class=\"fa fa-close fa-fw\"></i><span ng-show=!$last>{{\" - \"}}</span></span></div></div><div class=form-group><div class=\"col-md-1 text-right\"><label class=control-label>Endereço</label></div><div class=col-md-7><input type=text placeholder=\"Endereço não informado\" ng-model=newUser.address class=form-control></div><label class=\"col-md-1 control-label text-center\">Funções</label><div class=col-md-3><menu class=c-input><label for=checkbox ng-click=toggleSearch() focus={{check_selected}} class=\"c-input__label white-space-nowrap handle handle-right\">Selecione as funções<i aria-hidden=true class=\"fa fa-caret-down c-input__icon\"></i></label><ul ng-class=\"{expanded: check_selected, collapsed: !check_selected}\" class=\"c-dropdown u-text-small\"><li ng-repeat=\"position in positions\"><label class=\"ui-checkbox blue m-r-0\"><input name=checkbox1 type=checkbox ng-model=newUser.positions[position.id]><span class=\"text-black font-weight-bold\">{{position.name}}</span></label></li></ul></menu></div></div><div class=form-group><label class=\"col-sm-1 control-label text-center\">Observação</label><div class=col-sm-7><textarea style=resize:none cols=3 rows=3 placeholder=\"Observação não informado\" ng-model=newUser.notes class=form-control></textarea></div></div></div><div class=\"col-md-12 text-right m-b-2\"><button ng-disabled=form.$invalid class=\"btn btn-primary btn-sm\"><i class=\"fa fa-user-plus\"></i> Salvar</button></div></form></div></div></div>");
$templateCache.put("app/users/profile.html","<section class=\"container profile\"><div class=row><div class=\"col-md-12 p-t-0\"><header class=p-b-1><h4 class=text-primary><a ui-sref=configuration><i aria-hidden=true class=\"fa fa-gear fa-fw\"></i> Configurações</a> / {{edit_user.username}}</h4></header></div><div class=\"col-md-12 p-t-2\"><div class=col-md-6><form name=ProfileValue novalidate class=\"form form-horizontal\"><div class=\"row p-t-1\"><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Nome</label></div><div class=col-md-10><input type=text placeholder=\"Nome não informado\" ng-model=edit_user.name required class=form-control></div></div><div class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>E-mail</label></div><div class=col-md-10><input type=email placeholder=\"E-mail não informada\" ng-model=edit_user.email required class=form-control></div></div><div class=form-group><button ng-click=\"show_password=!show_password\" class=\"btn btn-info btn-sm\"><i class=\"fa fa-pencil-square fa-fw\"></i>Mudar Senha</button></div><div ng-show=show_password class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Senha</label></div><div class=col-md-10><input type=password placeholder=\"Senha não informada\" ng-model=edit_user.password required class=form-control></div></div><div ng-show=show_password class=form-group><div class=\"col-md-2 text-right\"><label class=control-label>Confirmar senha</label></div><div class=col-md-10><input type=password placeholder=\"Senha não informada\" ng-model=edit_user.password_confirmation required class=form-control></div></div><div class=\"col-md-12 text-right p-r-0\"><button ng-click=updateUser() class=\"btn btn-info btn-sm\"><i class=\"fa fa-pencil-square\"></i> Atualizar Informações</button></div></div></form></div><div class=\"col-md-4 text-center\"><input id=user_avatar nv-file-select=\"&lt;%= true %&gt;\" type=file uploader=uploader class=\"form-control hidden\"><div class=profile-img><div class=text-left><div class=avatar-area><img ng-if=\"user_avatar.length &gt; 0\" src={{user_avatar}} class=\"img-profile img-circle img80_80\"></div></div><button href=javascript:; onclick=$(&quot;#user_avatar&quot;).click() class=\"btn btn-link m-t-2 text-primary\"><i class=\"fa fa-camera fa-fw\"></i>Alterar imagem</button></div></div></div></div></section>");
$templateCache.put("app/vehicles/index.html","<section class=container><div class=row><header><div class=col-md-7><h4><a ui-sref=configuration><i class=\"fa fa-gear fa-fw\"></i> Configurações</a> / Veículos</h4></div><div class=col-md-5><div class=row><div class=col-md-6><div class=input-group><input type=text placeholder=\"Pesquisar veículo\" ng-model=search ng-enter=searchVehicle() class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=searchVehicle() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=col-md-6><a ng-click=newVehicle() class=\"btn btn-sm btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Novo veículo</a></div></div></div></header><div class=\"col-md-12 p-t-2\"><div class=row><div class=col-md-12><div ng-if=\"vehicles.length ==  0\" class=\"panel-body well\"><h5 ng-if=load_data class=text-center><i class=\"fa fa-spinner fa-pulse fa-fw\"></i>Carregando</h5><h5 ng-if=!load_data class=text-center>Nenhum veículo encontrado,<a ng-click=newVehicle() href=\"\" class=text-default>cadastrar novo veículo.</a></h5></div><div ng-if=\"vehicles.length &gt; 0\" class=table-responsive><table class=\"table table-striped table-hover fixed custom\"><thead><tr><th>Nome</th><th>Placa</th><th>Ano</th><th>Vencimento IPVA</th><th>Vencimento Seguro</th><th></th></tr></thead><tbody><tr ng-repeat=\"v in vehicles track by $index\"><td><a ng-click=editVehicle(v) href=\"\" class=cursor-hand>{{v.name}}</a></td><td><a ng-click=editVehicle(v) href=\"\">{{v.car_plate}}</a></td><td><a ng-click=editVehicle(v) href=\"\">{{v.year}}</a></td><td><a ng-click=editVehicle(v) href=\"\">{{v.ipva_due_date | date:\'dd/MM/yyyy\'}}</a></td><td><a ng-click=editVehicle(v)>{{v.insurance_due_date | date:\'dd/MM/yyyy\'}}</a></td><td ng-really-click=\"removeVehicle(v.id, $index)\" ng-really-title=\"Remover veículo\" ng-really-sub-title=\"{{v.name}} - {{v.car_plate}}\"><a href=\"\" class=onHover><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div><div ng-if=\"vehicles.length &gt; 0 &amp;&amp; pagination\" class=\"col-md-12 text-right\"><ul uib-pagination=\"\" first-text=Primero last-text=Último previous-text=‹ next-text=› total-items=pagination.total_items ng-model=pagination.page max-size=10 boundary-links=true rotate=false num-pages=pagination.qtd_pages items-per-page=30 ng-change=pageChanged() class=pagination-sm></ul></div></div></div></div></div></section>");
$templateCache.put("app/vehicles/new.html","<div class=modal-fade><div class=modal-header><div class=row><div class=col-xs-12><h4 class=ng-binding>Cadastrar Veículo <button aria-hidden=true data-ng-click=cancel() type=button class=close>×</button></h4></div></div></div><div class=\"modal-body p-t-0\"><div class=row><form name=form ng-submit=saveVehicle() class=\"form form-horizontal\"><div class=col-md-12><div><div class=p-t-1><div class=form-group><label class=\"col-sm-2 control-label text-center\">Nome<span class=text-danger>*</span></label><div class=col-sm-10><input type=text placeholder=\"Nome não informado\" ng-model=vehicle.name ng-required=true class=form-control></div></div><div class=form-group><label class=\"col-sm-2 text-right control-label\">Placa<span class=text-danger>*</span></label><div class=\"col-sm-4 text-left\"><input type=text placeholder=\"Placa não informada\" ng-model=vehicle.car_plate ng-required=true class=form-control></div><label class=\"col-sm-2 col-md-2 control-label text-center\">Ano<span class=text-danger>*</span></label><div class=col-sm-4><input type=number placeholder=\"Ano não informado\" ng-model=vehicle.year ng-required=true class=form-control></div></div><div class=form-group><label class=\"col-sm-2 text-right control-label\">Vencimento IPVA</label><div class=\"col-sm-4 text-left\"><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=vehicle.ipva_due_date is-open=popup1.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open1() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div><label class=\"col-sm-2 control-label text-center\">Vencimento Seguro</label><div class=col-sm-4><div class=input-group><input type=text ui-mask=99/99/9999 model-view-value=true uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=vehicle.insurance_due_date is-open=popup2.opened datepicker-options=dateOptions current-text=Hoje close-text=Fechar clear-text=Limpar alt-input-formats=altInputFormats placeholder=dd/MM/AAAA class=\"form-control input-sm\"><span class=input-group-btn><button type=button ng-click=open2() class=\"btn btn-default btn-sm\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"col-sm-2 control-label text-center\">Observações</label><div class=col-sm-10><textarea placeholder=\"Vencimento Seguro não informado\" ng-model=vehicle.note class=form-control></textarea></div></div></div></div></div></form></div></div><div class=modal-footer><div class=\"col-xs-12 text-right p-r-0\"><button ng-disabled=form.$invalid form=form ng-click=saveVehicle() class=\"btn btn-success ng-binding btn-sm\"><i class=\"fa fa-ambulance\"></i> Confirmar</button></div></div></div>");}]);